
  <div id="delete-pic" style="display:none; position:fixed; z-index:1000; left:0; top:0; width:100%; height:100%; overflow:auto; background-color:rgba(0,0,0,0.75);">
    <div style="background-color: #ffffff;
    margin: 25% auto;
    padding: 2em;
    border: 1px solid #888;
    width: 80%;
    max-width: 300px;
    border-radius: 1em;">
      <p style="color: #424242;font-weight: 600;">Delete Photo?</p>
      <button style="border: 0;margin-right: 2em;background: #8cc63f;color: white;width: 4em;" (click)="deletePhoto(true)">Yes</button>
      <button style="background: #ffffff;color: #424242;width: 4em;border: 1px solid #d8d8d8;" (click)="deletePhoto(false)">No</button>
    </div>
  </div>

  <div id="delete-pic-mf" style="display:none; position:fixed; z-index:1000; left:0; top:0; width:100%; height:100%; overflow:auto; background-color:rgba(0,0,0,0.75);">
    <div style="background-color: #ffffff;
    margin: 25% auto;
    padding: 2em;
    border: 1px solid #888;
    width: 80%;
    max-width: 300px;
    border-radius: 1em;">
      <p style="color: #424242;font-weight: 600;">Delete Photo?</p>
      <button style="border: 0;margin-right: 2em;background: #8cc63f;color: white;width: 4em;" (click)="deletePhotoMF(true)">Yes</button>
      <button style="background: #ffffff;color: #424242;width: 4em;border: 1px solid #d8d8d8;" (click)="deletePhotoMF(false)">No</button>
    </div>
  </div>

  <div id="delete-pic-loflow" style="display:none; position:fixed; z-index:1000; left:0; top:0; width:100%; height:100%; overflow:auto; background-color:rgba(0,0,0,0.75);">
    <div style="background-color: #ffffff;
    margin: 25% auto;
    padding: 2em;
    border: 1px solid #888;
    width: 80%;
    max-width: 300px;
    border-radius: 1em;">
      <p style="color: #424242;font-weight: 600;">Delete Photo?</p>
      <button style="border: 0;margin-right: 2em;background: #8cc63f;color: white;width: 4em;" (click)="deletePhotoLoflow(true)">Yes</button>
      <button style="background: #ffffff;color: #424242;width: 4em;border: 1px solid #d8d8d8;" (click)="deletePhotoLoflow(false)">No</button>
    </div>
  </div>

  <div id="delete-pic-ventctrl" style="display:none; position:fixed; z-index:1000; left:0; top:0; width:100%; height:100%; overflow:auto; background-color:rgba(0,0,0,0.75);">
    <div style="background-color: #ffffff;
    margin: 25% auto;
    padding: 2em;
    border: 1px solid #888;
    width: 80%;
    max-width: 300px;
    border-radius: 1em;">
      <p style="color: #424242;font-weight: 600;">Delete Photo?</p>
      <button style="border: 0;margin-right: 2em;background: #8cc63f;color: white;width: 4em;" (click)="deletePhotoVentCtrl(true)">Yes</button>
      <button style="background: #ffffff;color: #424242;width: 4em;border: 1px solid #d8d8d8;" (click)="deletePhotoVentCtrl(false)">No</button>
    </div>
  </div>

  <div id="delete-pic-esceilingfans" style="display:none; position:fixed; z-index:1000; left:0; top:0; width:100%; height:100%; overflow:auto; background-color:rgba(0,0,0,0.75);">
    <div style="background-color: #ffffff;
    margin: 25% auto;
    padding: 2em;
    border: 1px solid #888;
    width: 80%;
    max-width: 300px;
    border-radius: 1em;">
      <p style="color: #424242;font-weight: 600;">Delete Photo?</p>
      <button style="border: 0;margin-right: 2em;background: #8cc63f;color: white;width: 4em;" (click)="deletePhotoEsCeilingFans(true)">Yes</button>
      <button style="background: #ffffff;color: #424242;width: 4em;border: 1px solid #d8d8d8;" (click)="deletePhotoEsCeilingFans(false)">No</button>
    </div>
  </div>

  <div id="delete-pic-allotrceilings" style="display:none; position:fixed; z-index:1000; left:0; top:0; width:100%; height:100%; overflow:auto; background-color:rgba(0,0,0,0.75);">
    <div style="background-color: #ffffff;
    margin: 25% auto;
    padding: 2em;
    border: 1px solid #888;
    width: 80%;
    max-width: 300px;
    border-radius: 1em;">
      <p style="color: #424242;font-weight: 600;">Delete Photo?</p>
      <button style="border: 0;margin-right: 2em;background: #8cc63f;color: white;width: 4em;" (click)="deletePhotoAllOtrCeilings(true)">Yes</button>
      <button style="background: #ffffff;color: #424242;width: 4em;border: 1px solid #d8d8d8;" (click)="deletePhotoAllOtrCeilings(false)">No</button>
    </div>
  </div>

    <div *ngIf="currentUpload.active" class="global-upload-status"
    style="position: fixed;
      background: white;
      width: 85vw;
      z-index: 1000;"> 
      <div class="global-upload-text">
        Uploading photo for <strong>{{ currentUpload.field }}</strong>:
        {{ currentUpload.percent }}%
      </div>
      <mat-progress-bar
        mode="determinate"
        [value]="currentUpload.percent">
      </mat-progress-bar>
    </div>


  <div id="admin-notes" style="display:none; position:fixed; z-index:1000; left:0; top:0; width:100%; height:100%; overflow:auto; background-color:rgba(0,0,0,0.75);">
    <div style="background-color: #ffffff;
    margin: 25% auto;
    padding: 2em;
    border: 1px solid #888;
    max-width: 50%;
    border-radius: 1em;">
      <p style="color: #424242;font-weight: 600;">Admin Notes</p>
      <textarea rows=6 style="width: 100%;" [(ngModel)]="adminNotesText"></textarea>
      <button style="border: 0;margin-right: 2em;background: #8cc63f;color: white;width: 6em; height: 3em;margin-top: 1em;" (click)="saveAdminNotes()">Save</button>
      <button style="background: #ffffff;color: #424242;width: 6em; height: 3em; border: 1px solid #d8d8d8;" (click)="closeAdminNotes()">Close</button>
    </div>
  </div>


<div id="formContainer" class="mat-dialog-background"
  style="font-family: 'Roboto';font-weight: 200;letter-spacing: 0.8px;">

  <form [formGroup]="raterform">
    <div class="d-flex">
      <h2 class="form-title"> {{locationTxt}} </h2>

      <div mat-dialog-actions style="padding-bottom: 40px;
      padding-left: 15px;
      padding-top: 0px;">
        <button class="mr-2" mat-button (click)="closeFunction(data)" style="border: solid;
        border-width: 1px;">Close</button>
        <button *ngIf='!data.noSave' class="mr-2" mat-button (click)="save()" style="border: solid;
        border-width: 1px;
        border-color: #bdbcbc;
        color: white;
        background: #8bc34a;">Save</button>

        <button class="mr-2" mat-button (click)="openAdminNotes()" style="border: solid; border-width: 1px;">Admin Notes</button>

<!--
        <div style="margin-top: 20px;" class="load-ev">
          <span><label>Review Mode</label></span>
          <label class="switch">
            <input type="checkbox" (click)='toggleReviewMode()'>
            <span class="slider round"></span>
          </label>
          </div>
-->

      </div>
    </div>
    <!--
    <input style="padding-bottom: 20px; display: none;" matInput #searchValue formControlName = "search" (blur)="updateSingleField('search')" placeholder="Search for a field here..." (change)="searchFunction(searchValue.value)">
  -->
    <div class="tab-wrapper" style="width:91vw;">
      <div class="tab-bar">
        <button class="tab-item active" (click)="setSelectedItem(0)" id="item0">Home</button>
        <button class="tab-item" (click)="setSelectedItem(1)" id="item1">Checklist & IAP</button>
        <button class="tab-item" (click)="setSelectedItem(8)" id="item8" *ngIf="isESMFNC">ESMFNC</button>
        <button class="tab-item" (click)="setSelectedItem(2)" id="item2">Testing</button>
        <button class="tab-item" (click)="setSelectedItem(9);setSysNo(systemNo);" id="item9">HVAC</button>
        <button class="tab-item" (click)="setSelectedItem(3)" id="item3">Sticker</button>
        <button class="tab-item" (click)="setSelectedItem(4)" id="item4">Final</button>
        <button class="tab-item" (click)="setSelectedItem(5)" id="item5">Envelope</button>
        <button class="tab-item" (click)="setSelectedItem(6)" id="item6">Support</button>
        <button class="tab-item" (click)="setSelectedItem(7)" *ngIf="mftemplateid > 0" id="item7">NGBS</button>
      </div>
      <mat-menu #subMenu="matMenu">
        <button mat-menu-item (click)="setSelectedItem(2)">Prelim</button>
        <button mat-menu-item (click)="setSelectedItem(3)">ASHRAE & Multi-point</button>
      </mat-menu>

      <div class="tab-content" id="item0" [hidden]="selectedItem != 0">

        <!-- <cdk-virtual-scroll-viewport [itemSize]="100" style="height: 100vh; width: 100vw;"> -->
        <div style="padding-bottom: 2em;padding-top: 2em;color: #424242;">
          <p style="text-align:left;">{{this.street_address}}</p>
          <p style="text-align:left;">[{{this.subdivision_name}} - {{this.lot}}]</p>
          <p style="text-align:left;">{{initials}}</p>
          <p style="text-align:left;">{{customerObj.customer_name || 'No customer selected'}}</p>
          <p style="text-align:left;">{{phoneNumberText}}</p>
        </div>
        <div class="d-flex flex-wrap row">


          <div class="col-lg-6 col-12 px-lg-3 px-3 pb-3">
            <label>Click the dropdown below to select responsible trades: </label>
            <mat-form-field style="margin: 0px; width:80%; color: black;">
              <mat-select (blur)="tradeSelection(); updateSingleField('trades')" formControlName='trades' multiple>
                <mat-option *ngFor="let trade of this.trades" [value]="trade">
                  {{trade}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-lg-6 col-12 px-lg-3 px-3 pb-3">
            <label>Job Scope </label>
            <h3 class="collapseButton"><span>Job Scope</span> </h3>
            <!--This was requested by Sam and Caitlin on March 1, 2023. The purpose of the conditional blocks below is to show additional pre-drywall notes depending on the PDWI type-->
            <div class="content" style="text-align: left">

              <pre style="white-space:pre-wrap" [innerHTML]="jobscope"></pre></div>
          </div>
          <div *ngIf="consultant && consultant.length > 0  ">
            <p style="font-size: 3em;
              padding-top: 1em;
              padding-bottom: 0.25em;">Consultant: {{consultant}}</p>
            <p *ngIf="consultantPhone" style="font-size: 1.5em;
              padding-bottom: 1em;"><a href="tel:{{consultantPhone}}">{{consultantPhone}}</a></p>
            </div>


          <p style="padding: 25px;
          border: 1px double black;
          font-weight: 500;
          letter-spacing: 1.5px;
          line-height: 20px;"> {{notesText}}</p>

          <div *ngIf='multifamilyDoc' style="text-align: center;
          padding: 25px;">
            <a style="font-size: 25px;" href="https://docs.google.com/document/d/1TOi9Sqoz1W2o2_6EHW2RkWaKL7Nur3lLRRb-FhQPR2o/edit" target = 'blank'>MF Onsite Process and Photos REQUIRED</a>
          </div>


          <div style="text-align: center;
          padding: 25px;">
            <a style="font-size: 25px;" href="https://drive.google.com/drive/u/0/folders/{{drivelink}}" target = 'blank'>Documents Folder</a>
          </div>

          <div style="text-align: center;
          padding: 25px;">
            <p>Selfie Photo</p>
            <input (change)="onFilePicked($event, -1, 'selfie_pic')" 
              type="file" accept="image/*, text/plain" 
              id= "selfie_input"
              style="display: none;" />
            <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('selfie_input')">
                <fa-icon [icon]="facamera"></fa-icon> 
              </button>
          </div>




          <div class="photo-gallery" *ngIf="selfiepics && selfiepics.length > 0">
            <div *ngFor="let photoUrl of selfiepics; let i = index" class="photo-thumbnail-wrapper">
                <a href="javascript:void(0)" (click)="openPhotoViewer(photoUrl)">
                    <img loading='lazy' class="photo-thumbnail" [src]="photoUrl" alt="selfie photo {{i + 1}}">
                </a>
                <button style="background-color: red;color: white;border: 0;border-radius: 9px;width: 4em;" 
                (click)="openDeleteModal(photoUrl)" title="Delete Photo">
                    <mat-icon style="font-family: 'Roboto';">X</mat-icon>
                </button>
            </div>
        </div>
        <p *ngIf="!selfiepics || selfiepics.length === 0">No photos uploaded yet.</p>

        </div>


        <div class="d-flex flex-wrap row">
        <!-- <p class = "text-center">{{this.form_id}}</p> -->
          <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start" style="border: 1px solid lightgrey;
          display: flex !important;
          flex-direction: column !important;
          justify-content: center !important;
          align-items: center !important;">


        <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
            <a *ngIf="data.pics.codepermit" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.codepermit)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.codepermit || ''}}">
          </a>
          <label class="mb-auto">Code Permit or Unit Number</label>
          <input (change)="photoTaken($event, 'codepermit')" type="file" accept="image/*,text/plain" id="pictureinput61"
            style="display: none;" />
          <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput61')">
            <span>
              <fa-icon [icon]="facamera"></fa-icon>
            </span>
          </button>
          <span [hidden]="!data.pics?.codepermit"><button mat-button color="green"
              [hidden]="!data.pics?.codepermit" (click)="viewPic('codepermit')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button></span>

        </div>
      </div>

          <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start" style="border: 1px solid lightgrey;
          display: flex !important;
          flex-direction: column !important;
          justify-content: center !important;
          align-items: center !important;">

            <label class="mb-auto" style="line-height: 50px;text-align:center;margin-right: 0px;"> Meter #</label>
            <a *ngIf="data.pics.meterno" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.meterno)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.meterno || ''}}">
          </a>
            <input (change)="photoTaken($event, 'meterno')" type="file" accept="image/*,text/plain" id="pictureinput90"
              style="display: none;" />
            <button style="width: 20px;margin-bottom: 25px;" class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput90')">
              <span>
                <fa-icon [icon]="facamera"></fa-icon>
              </span>
            </button>
            <span [hidden]="!data.pics?.meterno"><button mat-button color="green"
                [hidden]="!data.pics?.meterno" (click)="viewPic('meterno')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button></span>
            <div class="flex-section-external-pressure col-lg-6 col-12 px-3" style="width: 50%;">
            <mat-label class="formLabel">Meter/Premise # </mat-label>
            <mat-form-field>
              <input matInput formControlName="meterno" (focus)="setInitialValue('meterno')" (blur)="updateSingleField('meterno')" id='meterno'>
            </mat-form-field>
          </div>
          </div>
</div>

        <div class="d-flex flex-wrap row">
          <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start" style="border: 1px solid lightgrey;
          display: flex !important;
          flex-direction: column !important;
          justify-content: center !important;
          align-items: center !important;">




            <label class="mb-auto" style="line-height: 50px;text-align:center;margin-right: 0px;"> Attic Tent </label>
            <a *ngIf="data.pics.attictent" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.attictent)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.attictent || ''}}">
          </a>
            <input (change)="photoTaken($event, 'attictent')" type="file" accept="image/*,text/plain" id="pictureinput77"
              style="display: none;" />
            <button style="width: 20px;margin-bottom: 25px;" class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput77')">
              <span>
                <fa-icon [icon]="facamera"></fa-icon>
              </span>
            </button>
            <span [hidden]="!data.pics?.attictent"><button mat-button color="green"
                [hidden]="!data.pics?.attictent" (click)="viewPic('attictent')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button></span>

          </div>


          <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start" style="border: 1px solid lightgrey;
          display: flex !important;
          flex-direction: column !important;
          justify-content: center !important;
          align-items: center !important;">

            <label class="mb-auto" style="line-height: 50px;text-align:center;margin-right: 0px;"> Generator </label>
            <a *ngIf="data.pics.generator" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.generator)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.generator || ''}}">
          </a>
            <input (change)="photoTaken($event, 'generator')" type="file" accept="image/*,text/plain" id="pictureinput80"
              style="display: none;" />
            <button style="width: 20px;margin-bottom: 25px;" class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput80')">
              <span>
                <fa-icon [icon]="facamera"></fa-icon>
              </span>
            </button>
            <span [hidden]="!data.pics?.generator"><button mat-button color="green"
                [hidden]="!data.pics?.generator" (click)="viewPic('generator')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button></span>

          </div>

          <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start" style="border: 1px solid lightgrey;
          display: flex !important;
          flex-direction: column !important;
          justify-content: center !important;
          align-items: center !important;">
            <label class="mb-auto">Drain Cleanout</label>
            <a *ngIf="data.pics.draincleanout" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.draincleanout)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.draincleanout || ''}}">
          </a>
          <input (change)="photoTaken($event, 'draincleanout')" type="file" accept="image/*,text/plain" id="pictureinputdraincleanout"
            style="display: none;" />
          <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinputdraincleanout')">
            <span>
              <fa-icon [icon]="facamera"></fa-icon>
            </span>
          </button>
          <span [hidden]="!data.pics?.draincleanout"><button mat-button color="green"
              [hidden]="!data.pics?.draincleanout" (click)="viewPic('draincleanout')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button></span>
          </div>

      </div>


        <div class="d-flex flex-wrap row">
          <div class="col-12 px-lg-3 px-3 pb-3" style="margin-top:30px; display: flex; flex-direction: column;">
            <label style="text-align: center;
            text-decoration: underline;
            font-size: 22px;">Elevation Photos</label>

          </div>

          <div class="col-lg-6 col-12 p-3 elev-card">
            <label class="mb-auto">Front Image</label> <button class="mt-3" mat-flat-button color="primary" (click)="setElevNA(3)" *ngIf="this.elev_front != 'N/A'">N/A</button>
            <a class="upload-image-wrapper" *ngIf="this.elev_front != 'N/A'"
              href="javascript:void(0)" (click)="openPhotoViewer(elev_front)"
              ><img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
                src="{{this.elev_front || 'https://placehold.co/600x400?text=Front'}}">
            </a>
            <h4 class="naselectedelev" *ngIf="this.elev_front == 'N/A'"> (Rater selected N/A)</h4>

            <input (change)="elevphotoTaken($event, 2)" type="file" accept="image/*,text/plain" id="elevfront"
              style="display: none;" />
            <button class="mt-3" mat-flat-button color="primary" id="elevfrontpic" (click)="pictureClick('elevfront')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button>
          </div>

          <div class="col-lg-6 col-12 p-3 elev-card">
            <label class="mb-auto">Right Image</label> <button class="mt-3" mat-flat-button color="primary" (click)="setElevNA(2)" *ngIf="this.elev_right != 'N/A'">N/A</button>
            <a class="upload-image-wrapper" *ngIf="this.elev_right != 'N/A'"
              href="javascript:void(0)" (click)="openPhotoViewer(elev_right)"
              ><img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
                src="{{elev_right || 'https://placehold.co/600x400?text=Right'}}">
            </a>
            <h4 class="naselectedelev" *ngIf="this.elev_right == 'N/A'"> (Rater selected N/A)</h4>

            <input (change)="elevphotoTaken($event, 4)" type="file" accept="image/*,text/plain" id="elevright"
              style="display: none;" />
            <button class="mt-3" mat-flat-button color="primary" id="elevrighgtpic" (click)="pictureClick('elevright')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button>
          </div>

          <div class="col-lg-6 col-12 p-3 elev-card">
            <label class="mb-auto">Left Image</label> <button class="mt-3" mat-flat-button color="primary" (click)="setElevNA(1)" *ngIf="this.elev_left != 'N/A'">N/A</button>
            <a class="upload-image-wrapper" *ngIf="this.elev_left != 'N/A'"
              href="javascript:void(0)" (click)="openPhotoViewer(elev_left)"
              > <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
                src="{{elev_left || 'https://placehold.co/600x400?text=Left'}}" >
            </a>
            <h4 class="naselectedelev" *ngIf="this.elev_left == 'N/A'"> (Rater selected N/A)</h4>

            <input (change)="elevphotoTaken($event, 3)" type="file" accept="image/*,text/plain" id="elevleft"
              style="display: none;" />
            <button class="mt-3" mat-flat-button color="primary" id="elevleftpic" (click)="pictureClick('elevleft')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button>
          </div>

          <div class="col-lg-6 col-12 p-3 elev-card">
            <label class="mb-auto">Back Image</label> <button class="mt-3" mat-flat-button color="primary" (click)="setElevNA(4)" *ngIf="this.elev_back != 'N/A'">N/A</button>
            <a class="upload-image-wrapper" *ngIf="this.elev_back != 'N/A'"
              href="javascript:void(0)" (click)="openPhotoViewer(elev_back)"
              ><img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
                src="{{this.elev_back || 'https://placehold.co/600x400?text=Back'}}">
            </a>
            <h4 class="naselectedelev" *ngIf="this.elev_back == 'N/A'"> (Rater selected N/A)</h4>

            <input (change)="elevphotoTaken($event, 1)" type="file" accept="image/*,text/plain" id="elevback"
              style="display: none;" />
            <button class="mt-3" mat-flat-button color="primary" id="elevbackpic" (click)="pictureClick('elevback')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button>
          </div>


        </div>

        <!-- <div id="elev-photos" class="col-12 px-3 pb-3 d-flex flex-wrap">
          <div style="width:25%; text-align: center;">
            <a href="javascript:void(0)" (click)="openPhotoViewer(elev_left)"
              > <img loading='lazy' style="max-width:80px; max-height:80px;" mat-card-image
                src="{{this.elev_left || 'https://m3placement.com/wp-content/uploads/2021/03/image-placeholder-350x350-1.png'}}">
            </a>
          </div>

          <div style="width:25%; text-align: center;">
            <a href="javascript:void(0)" (click)="openPhotoViewer(elev_right)"
              ><img loading='lazy' style="max-width:80px; max-height:80px;" mat-card-image
                src="{{this.elev_right || 'https://m3placement.com/wp-content/uploads/2021/03/image-placeholder-350x350-1.png'}}">
            </a>
          </div>

          <div style="width:25%; text-align: center;">
            <a href="javascript:void(0)" (click)="openPhotoViewer(elev_front)"
              ><img loading='lazy' style="max-width:80px; max-height:80px;" mat-card-image
                src="{{this.elev_front || 'https://m3placement.com/wp-content/uploads/2021/03/image-placeholder-350x350-1.png'}}">
            </a>
          </div>

          <div style="width:25%; text-align: center;">
            <a href="javascript:void(0)" (click)="openPhotoViewer(elev_back)"
              ><img loading='lazy' style="max-width:80px; max-height:80px;" mat-card-image
                src="{{this.elev_back || 'https://m3placement.com/wp-content/uploads/2021/03/image-placeholder-350x350-1.png'}}">
            </a>
          </div>

        </div> -->

        <div class="d-flex flex-wrap row">
          <div class="col-lg-6 col-12 px-lg-3 px-3 pb-3 d-flex flex-column">
            <label>Predrywall notes summary</label>
            <em><pre>{{predrywallnotesSummary}}</pre></em>
          </div>
        </div>

        <div class="d-flex flex-wrap row">
          <div class="col-lg-6 col-12 px-lg-3 px-3 pb-3 d-flex flex-column">
            <label>Final notes summary</label>
            <em><pre>{{finalnotesSummary}}</pre></em>
          </div>
        </div>

        <div class="d-flex flex-wrap row">
          <div class="col-lg-6 col-12 px-lg-3 px-3 pb-3 d-flex flex-column">
            <label>Rater Notes</label>
            <textarea rows=6 formControlName="rater_notes" (focus)="setInitialValue('rater_notes')" (blur)="updateSingleField('rater_notes')" id='raternotes'>
        </textarea>
          </div>
          <div class="col-lg-6 col-12 px-lg-3 px-3 pb-3 d-flex flex-column">
            <label>Predrywall Notes</label>
            <textarea rows=6 formControlName="predrywallnotes4builder" (focus)="setInitialValue('predrywallnotes4builder')"
              (focus)="notesClick()" (blur)="updateSingleField('predrywallnotes4builder')" id='predrywallnotes4builder'>
        </textarea>
          </div>


          <div class="col-12 px-3 my-3" style="padding: 25px;">

            <mat-checkbox (change)="showHomePresets($event)"><p style="padding:25px;">Show Commonly needed corrections</p></mat-checkbox>
          </div>

          <div class="col-12 px-3" *ngIf="viewHomePresets" style="height: 400px;
          overflow-y: scroll;
          margin-bottom: 10%;
          border-top: 1px solid black;
          border-bottom: 1px solid black;">
            <div *ngFor="let item of presetArray">
                <div *ngIf="!finalnotes4builder.value.includes(item.descr)" style="white-space:normal !important;">
                    <button class="presetButton" (click)="addToNotes(true, item.descr, 917)"> >> </button>
                    <span style="vertical-align:middle;">{{item.descr}}</span>
                </div>
            </div>
        </div>


          <div class="d-flex flex-column col-12 px-3">
            <label>Final Notes</label>
            <textarea rows=6 formControlName="finalnotes4builder" (focus)="setInitialValue('finalnotes4builder')" #finalnotes4builder (blur)="updateSingleField('finalnotes4builder')"
              id='finalnotes4builder'>

        </textarea>
            <p style="padding:25px;">{{this.plan_name || 'No Plan Assigned'}}</p>
          </div>


          <div class="col-lg-6 col-12 px-3 pb-3" style="padding-top: 10px;">
            <table *ngIf="this.hvac_1_area > 0">
              <tr>
                <th class="planHeaderClass">System</th>
                <th class="planHeaderClass">Area</th>
                <th class="planHeaderClass">Height</th>
                <th class="planHeaderClass">Volume</th>
              </tr>
              <tr>
                <td>1</td>
                <td>
                  <p>{{this.hvac_1_area || 0 }}</p>
                </td>
                <td>{{this.hvac1_ceil_ht || 0}}</td>
                <td>{{(this.hvac_1_area || 0) * (hvac1_ceil_ht || 0)}}</td>
              </tr>
              <tr *ngIf="this.hvac_2_area > 0">
                <td>2</td>
                <td>
                  <p>{{this.hvac_2_area || 0 }}</p>
                </td>
                <td>{{this.hvac2_ceil_ht || 0}}</td>
                <td>{{(this.hvac_2_area || 0) * (hvac2_ceil_ht || 0)}}</td>
              </tr>
              <tr *ngIf="this.hvac_3_area > 0">
                <td>3</td>
                <td>
                  <p>{{this.hvac_3_area || 0 }}</p>
                </td>
                <td>{{this.hvac3_ceil_ht || 0}}</td>
                <td>{{(this.hvac_3_area || 0) * (hvac3_ceil_ht || 0)}}</td>
              </tr>
              <tr *ngIf="this.hvac_4_area > 0">
                <td>4</td>
                <td>
                  <p>{{this.hvac_4_area || 0 }}</p>
                </td>
                <td>{{this.hvac4_ceil_ht || 0}}</td>
                <td>{{(this.hvac_4_area || 0) * (hvac4_ceil_ht || 0)}}</td>
              </tr>

            </table>

          </div>
          <p style="text-align: center;">SFBE: {{sfbe}}</p>


            <h3 style="margin-top: 40px;
            text-align: center;
            text-decoration: underline;
            font-size: 24px;">Selected Tags</h3>

                <!-- The chip input control -->
            <div style="display: flex;
            width: 90%;
            height: 200px;
            margin-top: 30px;
            align-content: flex-start;
            flex-wrap: wrap;
            justify-content: space-evenly;">
            <mat-form-field style="width:85%;">
              <mat-chip-list #chipList>
                <mat-chip *ngFor="let tag of inputTags" [selectable]="true" [removable]="true" (removed)="removeTag(tag)">
                  {{tag.displayname}}
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip>
                <input placeholder="Add tag..."
                      [matAutocomplete]="auto"
                      [matChipInputFor]="chipList"
                      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                      (matChipInputTokenEnd)="addTag($event)"
                      (keyup.enter)="onEnter(auto)"
                      formControlName="tagControl" (focus)="setInitialValue('tagControl')">
              </mat-chip-list>
              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="addTag($event, $event.option.value)">
                <mat-option *ngFor="let tag of filteredTags | async" [value]="tag">
                  {{tag.displayname}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>

            <h3 style="margin-top: 40px;
            text-align: center;
            text-decoration: underline;
            font-size: 24px;">Avaliable Tags</h3>

            <div style="height: 300px;
            overflow-y: scroll;
            padding-bottom: 0px;
            margin-bottom: 100px;">
            <mat-chip-list>
              <mat-chip *ngFor="let tag of tags" (click)="addTag($event, tag)">{{tag.displayname}}</mat-chip>
            </mat-chip-list>

          </div>







        </div>



      <!--</cdk-virtual-scroll-viewport>-->
      </div>

      <div class="tab-content"  id="item1" [hidden]="selectedItem != 1 ">

        <h3>Checklists
          <span><button mat-raised-button color="orange" (click)="setInspectionType(1)">PDWI</button></span>
          <span><button mat-raised-button color="orange" (click)="setInspectionType(2)">Final</button></span>
          <span><button mat-raised-button color="orange" (click)="setInspectionType(0)">ALL</button></span>
        </h3>

        <div id="quickbuttons">

        </div>
        <div id="vertical" [hidden]="isHorizontal">
          <mat-accordion style="width:100%;">
            <div *ngFor="let item of checklistItems; let indexofelement = index;">

              <!--Headers Here-->

              <div *ngIf="indexofelement == 0" style="min-height: 100px; margin-top: 2em;
              background: #ffffff;
              padding: 5px;">
                <p style="display: flex;
                align-items: start;
                justify-content: center;
                flex-direction: column;
                height: 100%;
                ">1. High-Performance Fenestration & Insulation</p>
              </div>

              <div *ngIf="indexofelement == 3" style="min-height: 100px; margin-top: 2em;
              background: #ffffff;
              padding: 5px;">
                <p style="display: flex;
                height: 100%;
                align-items: start;
                flex-direction: column;
                justify-content: center;">2. Fully Aligned Barriers - <span style="margin-top: 1%;
    align-items: start;
    font-weight: 200;
    text-align: left;">At each insulated location below, a complete air barrier is provided that is fully aligned as follows:</span></p>
              </div>

              <div *ngIf="indexofelement == 3" style="min-height: 17em; margin-top: 2em;
              background: #ffffff;
              padding: 5px;">
                <p style="height: 100%;
                text-align: left;
                font-weight: 200;
                align-content: center;"><span style="text-decoration: underline;margin-right: 5%;">Ceilings</span> <span style="margin-top: 1%;align-items: start;font-weight: 200;text-align: left;">At interior or exterior horizontal surface of ceiling insulation in Climate Zones 1-3; at interior horizontal surface of ceiling insulation in
                Climate Zones 4-8. Also, at exterior vertical surface of ceiling insulation in all climate zones (e.g., using a wind baffle that extends to the full height of the insulation in every bay or a tabbed baffle in each bay with a soffit vent that prevents wind washing in adjacent bays).</span></p>
              </div>

              <div *ngIf="indexofelement == 4 && inspectionType != 2" style="min-height: 8em; margin-top: 2em;
              background: #ffffff;
              padding: 5px;">
                <p style="height: 100%;
                text-align: left;
                font-weight: 200;
                align-content: center;"><span style="text-decoration: underline;margin-right: 5%;">Walls</span> <span style="margin-top: 1%;
                align-items: start;
                font-weight: 200;
                text-align: left;">At exterior vertical surface of wall insulation in all climate zones; also at interior vertical surface of wall insulation in Climate Zones 4-8.</span></p>
              </div>


              <div *ngIf="indexofelement == 8 && inspectionType != 2" style="min-height: 9em; margin-top: 2em;
              background: #ffffff;
              padding: 5px;">
                <p style="height: 100%;
                text-align: left;
                font-weight: 200;
                align-content: center;"><span style="text-decoration: underline;margin-right: 5%;">Floors</span> <span style="margin-top: 1%;
                align-items: start;
                font-weight: 200;
                text-align: left;">At exterior vertical surface of floor insulation in all climate zones and, if over unconditioned space, also at interior horizontal surface
                  including supports to ensure alignment.</span></p>
              </div>


              <div *ngIf="indexofelement == 10" style="min-height: 60px; margin-top: 2em;
              background: #ffffff;
              padding: 5px;">
                <p style="height: 100%;
                display: flex;
                align-items: start;
                justify-content: center;
                flex-direction: column;
                ">3. Reduced Thermal Bridging</p>
              </div>

              <div *ngIf="indexofelement == 13 && inspectionType != 2" style="min-height: 8em; margin-top: 2em;
              border-radius: 16px;">
                <p style="height: 100%;
                display: flex;
                align-items: start;
                justify-content: center;
                text-align: left;
                align-items: center;">3.4 At above-grade walls separating conditioned from unconditioned space, one of the following options used (rim / band joists exempted): </p>
              </div>
              
              <div *ngIf="indexofelement == 20" style="min-height: 100px; margin-top: 2em;
              background: #ffffff;
              padding: 5px;margin-bottom: 4em;">
              <div style="padding-bottom: 2em; padding-top: 1em;" *ngIf="showAff">

                <span>
               Aff - 
                <svg style="color: green; width:2em;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                </svg>
                </span>

              </div>
                <p style="height: 100%;
                display: flex;
                align-items: start;
                justify-content: center;
                flex-direction: column;
                margin-bottom: 1em;">4. Air Sealing - <span style="margin-top: 1%;
                align-items: start;
                font-weight: 200;
                text-align: left;">4.1 Rater has verified each air sealing detail below. In addition, the home must meet Item 4.2. Unless otherwise noted below, "sealed" indicates the use of caulk, foam, or equivalent material.</span></p>

              </div>

              <div *ngIf="indexofelement == 30" style="min-height: 7em; margin-top: 2em;
              background: #ffffff;
              padding: 5px;">
                <p style="height: 100%;
                display: flex;
                align-items: start;
                justify-content: center;
                flex-direction: column;
                ">4.2 Rater-measured air leakage of Dwelling or Dwelling Unit meets one of the following: <span style="margin-top: 1%;
                align-items: start;
                font-weight: 200;
                text-align: left;">(Only Mandatory for 2026 Permits)</span></p>
              </div>

              <div *ngIf="indexofelement == 32 && inspectionType != 1" style="min-height: 100px; margin-top: 2em;
              background: #ffffff;">
                <p style="height: 100%;
                display: flex;
                align-items: start;
                justify-content: center;
                flex-direction: column;
                ">5. Heating & Cooling Equipment</p>
              </div>

              <div *ngIf="indexofelement == 36" style="min-height: 7em; margin-top: 2em;
              background: #ffffff;">
                <p style="height: 100%;
                display: flex;
                align-items: start;
                justify-content: center;
                flex-direction: column;
                ">6. Duct Quality Installation<span style="margin-top: 1%;
                align-items: start;
                font-weight: 200;
                text-align: left;">(Applies to Heating, Cooling, Ventilation, Exhaust, & Pressure Balancing Ducts)</span></p>
              </div>

              <div *ngIf="indexofelement == 42" style="min-height: 100px; margin-top: 2em;
              background: rgb(255 255 255);">
                <p style="height: 100%;
                display: flex;
                align-items: start;
                justify-content: center;
                flex-direction: column;
                ">7. Dwelling Unit Mechanical Ventilation Systems ("Vent System") & Inlets in Return Duct</p>
              </div>

              <div *ngIf="indexofelement == 54 && inspectionType != 1" style="min-height: 10em; margin-top: 2em;
              background: rgb(255 255 255);">
                <p style="height: 100%;
                display: flex;
                align-items: start;
                justify-content: center;
                flex-direction: column;
                ">8. Local Mechanical Exhaust - <span style="margin-top: 1%;
                align-items: start;
                font-weight: 200;
                text-align: left;">In each kitchen and bathroom, a system is installed that exhausts directly to the outdoors and meets one of
                the following Rater-measured airflow and manufacturer-rated sound level standards: </span></p>
              </div>

              <div *ngIf="indexofelement == 56 && inspectionType != 1" style="min-height: 100px; margin-top: 2em;
              background: rgb(255 255 255);">
                <p style="height: 100%;
                display: flex;
                align-items: start;
                justify-content: center;
                flex-direction: column;
                ">9. Filtration</p>
              </div>

              <div *ngIf="indexofelement == 59 && inspectionType != 1" style="min-height: 100px; margin-top: 2em;
              background: rgb(255 255 255);">
                <p style="height: 100%;
                display: flex;
                align-items: start;
                justify-content: center;
                flex-direction: column;
                ">10. Combustion Appliances</p>
              </div>

              <div *ngIf="indexofelement == 62" style="min-height: 100px; margin-top: 2em;
              background: rgb(255 255 255);">
                <p style="height: 100%;
                display: flex;
                align-items: start;
                justify-content: center;
                flex-direction: column;
                ">Indoor AirPlus </p>
              </div>



              <div *ngIf=" inspectionType == 0 || item.stage == inspectionType || item.stage == 0 || (item.stage == 3 && inspectionType == 1) || item.stage == 3 && item.value?.trim().toLowerCase().includes('must') ">                
                <mat-expansion-panel #thePanel (opened)="loadData(item, indexofelement)">
                  <mat-expansion-panel-header class="collapseButton check-list" style="min-height: 100px; overflow: hidden;"
                    [ngClass]=" {'verified blackHeader': item.value.trim().includes('Rater Verified'), 'na': item.value.trim().includes('N'), 'must-correct': item.value.trim().includes('Must Correct'), 'recommended':  item.value?.trim().includes('Recommended'), 'builderverified': item.value.trim().includes('Builder'), 'default': item.value.length < 1}">
                    <!--<mat-panel-title [ngStyle]="{'color: grey;' : item.value.trim().includes('N') }>-->
                    <mat-panel-title >
                   <a *ngIf="item.link?.length > 2" href="{{item.link}}" target="_blank" style="color:#343434; flex-shrink:0; margin-right: 8px;"> More Info </a>
                      <p [ngStyle]="{'font-size': getFontSize(item.description)}"
                      style="font-family: Calibri;
                             margin-bottom: 0;
                             padding: 5px;
                             flex:1;
                             text-overflow: ellipsis;
                             overflow: hidden;
                             font-weight: 700;
                             line-height: 1.5vh;
                             text-align: left;">
                     {{item.description}}
                      <fa-icon
                      *ngIf="item.showPhotoIcon || item.photoIcon"
                      [icon]="facamera"
                      title="Photos available for this item"
                      style = "flex-shrink:0;">
                 </fa-icon>
                   </p>

                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <mat-panel-description class="d-flex align-items-center" style="display: flex;
                  flex-direction: column;">

              <div class="photo-gallery" *ngIf="currentphotoobjects && currentphotoobjects.length > 0">
            <div *ngFor="let photoUrl of currentphotoobjects; let i = index" class="photo-thumbnail-wrapper">
                <a href="javascript:void(0)" (click)="openPhotoViewer(photoUrl)">
                    <img loading='lazy' class="photo-thumbnail" [src]="photoUrl" alt="Checklist item photo {{i + 1}}">
                </a>
                <button style="background-color: red;color: white;border: 0;border-radius: 9px;width: 4em;" 
                (click)="openDeleteModal(photoUrl)" title="Delete Photo">
                    <mat-icon style="font-family: 'Roboto';">X</mat-icon>
                </button>
            </div>
        </div>
        <p *ngIf="!currentphotoobjects || currentphotoobjects.length === 0">No photos uploaded yet.</p>

        <input (change)="onFilePicked($event, selectedIndex, selectedChecklistItem.field)" 
          type="file" accept="image/*, text/plain" 
          [id]= getPhotoCardID(selectedIndex)
          style="display: none;" />
        <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick(getPhotoCardID(selectedIndex))">
            <fa-icon [icon]="facamera"></fa-icon> 
          </button>
                    <!--
                    <a *ngIf="item.photo" class="upload-image-wrapper"
                    href="{{item.photo}}" target="_blank">
                    <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
                      src="{{item.photo}}">
                  </a>

                      <input (change)="onFilePicked($event, selectedIndex, selectedChecklistItem.field)" type="file" accept="image/*,text/plain" [id] = getPhotoCardID(selectedIndex)
                      style="display: none;" />
                    <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick(getPhotoCardID(selectedIndex))">
                      <fa-icon [icon]="facamera"></fa-icon>
                    </button>
-->
                  </mat-panel-description>



                  <div>

                    <div style="padding-bottom: 10px;" *ngIf="selectedChecklistItem?.value.trim().includes('Builder')">
                      <p style="text-align: center;">Builder Verified</p>
                    </div>

                    <div class="container-center" *ngIf="!(selectedChecklistItem?.value.trim().includes('Builder'))">
                      <mat-radio-group class="my-3" aria-label="Select an option"
                        [value]="selectedChecklistItem ? selectedChecklistItem.value : ''">
                        <mat-radio-button class="mr-3" value="Rater Verified"
                          (change)="selectionChanged('Rater Verified', selectedIndex)">Rater Verified</mat-radio-button>
                        <mat-radio-button class="mr-3" (change)="selectionChanged('Must Correct', selectedIndex)"
                          value="Must Correct">Must Correct</mat-radio-button>
                        <mat-radio-button class="mr-3" (change)="selectionChanged('NA', selectedIndex)" value="NA">N/A
                        </mat-radio-button>
                        <mat-radio-button *ngIf='!isEnergyStar' class="mr-3" (change)="selectionChanged('Recommended', selectedIndex)" value="Recommended">Recommended
                        </mat-radio-button>
                      </mat-radio-group>

                    </div>

                    <div
                      *ngIf="selectedChecklistItem ? (selectedChecklistItem.value == 'Must Correct' && presetArray.length > 0 ? true : false ) : false ">
                      <label>Pick a common correction (optional)</label>
                          <div *ngFor="let item of presetArray">
                              <div *ngIf="!noteThing.value.includes(item.descr)" style="white-space:normal !important;">
                                  <button class="presetButton" (click)="addToNotes(true, item.descr, selectedIndex)"> >> </button>
                                  <span style="vertical-align:middle;">{{item.descr}}</span>
                              </div>
                          </div>
                    </div>

                    <div class="row flex-column align-items-center">
                      <div class="col-lg-6 col-12 px-3 pb-3">
                        <textarea #noteThing rows=6 (onclick)='trimNotes(noteThing.value, selectedIndex)'
                          (blur)='notesBlur(noteThing.value, selectedIndex)' id='chklistnote'
                          value="{{selectedChecklistItem ? (selectedChecklistItem.note ? selectedChecklistItem.note : '') : ''}}"></textarea>
                      </div>

                      <div class="col-lg-6 col-12 px-3 pb-3">

                        <p style="color: lightgrey;
                        display: flex;" *ngIf="reviewMode">{{lastChanged}}</p>

                      </div>
                    </div>

                    <div [hidden]=" selectedChecklistItem ? selectedChecklistItem.photo : false"
                      class="container-center" style="padding: 10px; max-width: 300px; max-height: 300px;">

                    </div>
                  </div>

                </mat-expansion-panel>
                <p *ngIf="checklistPhotoCountWarning(item.field)"
                  style="color: red; font-weight: bold; margin: 4px 0 0 5px;">
                  {{ checklistPhotoCountWarning(item.field) }}
                </p>
              </div>
            </div>

          </mat-accordion>

        </div>




      </div>


      <div class="tab-content" id="item8" [hidden]="selectedItem != 8" *ngIf = "isESMFNC == true">

        <h3>Checklists
          <span><button mat-raised-button color="orange" (click)="setMFInspectionType(1)">PDWI</button></span>
          <span><button mat-raised-button color="orange" (click)="setMFInspectionType(2)">Final</button></span>
          <span><button mat-raised-button color="orange" (click)="setMFInspectionType(0)">ALL</button></span>
        </h3>


        <div id="vertical" [hidden]="isHorizontal">

          <div><p>Sampling does not allow any builder verifications. Also, all of our projects follow the ERI path.</p></div>
          


          <mat-accordion style="width:100%;">

            <div *ngFor="let item of mfChecklistItems; let indexofelement = index;">

              <!--Headers here-->

              <div *ngIf="item.description.startsWith('1.') && indexofelement === 0 || item.description.startsWith('1.') && !mfChecklistItems[indexofelement - 1]?.description.startsWith('1.')" style="height: 100px;
              background: #ffffff;
              padding: 5px;">
                <p style="display: flex;
                align-items: start;
                justify-content: center;
                flex-direction: column;
                height: 100%;
                font-size: 1.5em;">1. High-Performance Fenestration & Insulation</p>
              </div>

              <div *ngIf="item.description.startsWith('2.') && !mfChecklistItems[indexofelement - 1]?.description.startsWith('2.') && mfinspectionType != 2" style="height: 100px;
              background: #ffffff;
              padding: 5px;">
                <p style="display: flex;
                height: 100%;
                font-size: 1.5em;
                align-items: start;
                flex-direction: column;
                justify-content: center;">2. Fully Aligned Barriers - <span style="margin-top: 1%;
    align-items: start;
    font-weight: 200;
    text-align: left;">At each insulated location below, a complete air barrier is provided that is fully aligned as follows:</span></p>
              </div>

              <div *ngIf="item.description.startsWith('2.') && !mfChecklistItems[indexofelement - 1]?.description.startsWith('2.') && mfinspectionType != 2" style="height: 6em;
              background: #ffffff;
              padding: 5px;">
                <p style="height: 100%;
                text-align: left;
                font-size: 1.5em;
                font-weight: 200;
                overflow-y: scroll;
                align-content: center;"><span style="text-decoration: underline;margin-right: 5%;">Ceilings</span> <span style="margin-top: 1%;align-items: start;font-weight: 200;text-align: left;">At interior or exterior horizontal surface of ceiling insulation in Climate Zones 1-3; at interior horizontal surface of ceiling insulation in
                Climate Zones 4-8. Also, at exterior vertical surface of ceiling insulation in all climate zones (e.g., using a wind baffle that extends to the full height
                of the insulation in every bay or a tabbed baffle in each bay with a soffit vent that prevents wind washing in adjacent bays).</span></p>
              </div>

              <div *ngIf="item.description.startsWith('2.2') && !mfChecklistItems[indexofelement - 1]?.description.startsWith('2.2') && mfinspectionType != 2" style="height: 5em;
              background: #ffffff;
              padding: 5px;">
                <p style="height: 100%;
                text-align: left;
                font-size: 1.5em;
                font-weight: 200;
                overflow-y: scroll;
                align-content: center;">
                <span style="text-decoration: underline;margin-right: 5%;">Walls</span> <span style="margin-top: 1%;
                align-items: start;
                font-weight: 200;
                text-align: left;">At exterior vertical surface of wall insulation in all climate zones; also at interior vertical surface of wall insulation in Climate Zones 4-8.</span></p>
              </div>


              <div *ngIf="item.description.startsWith('2.4') && !mfChecklistItems[indexofelement - 1]?.description.startsWith('2.4') && mfinspectionType != 2" style="height: 6em;
              background: #ffffff;
              padding: 5px;">
                <p style="height: 100%;
                text-align: left;
                font-size: 1.5em;
                font-weight: 200;
                overflow-y: scroll;
                align-content: center;">
                <span style="text-decoration: underline;margin-right: 5%;">Floors</span> <span style="margin-top: 1%;
                align-items: start;
                font-weight: 200;
                text-align: left;">At exterior vertical surface of floor insulation in all climate zones and, if over unconditioned space, also at interior horizontal surface
                  including supports to ensure alignment.</span></p>
              </div>


              <div *ngIf="item.description.startsWith('3.') && !mfChecklistItems[indexofelement - 1]?.description.startsWith('3.') && mfinspectionType != 2" style="height: 60px;
              background: #ffffff;
              padding: 5px;">
                <p style="height: 100%;
                display: flex;
                align-items: start;
                justify-content: center;
                flex-direction: column;
                font-size: 1.5em;">3. Reduced Thermal Bridging</p>
              </div>

              <div *ngIf="item.description.startsWith('3.7') && !mfChecklistItems[indexofelement - 1]?.description.startsWith('3.7') && mfinspectionType != 2" style="height: 7em;
              background: #ffffff;
              padding: 5px;">
                <p style="height: 100%;
                display: flex;
                align-items: start;
                justify-content: center;
                text-align: left;
                font-size: 1.5em;
                align-items: center;">3.7 At above-grade walls separating conditioned from unconditioned space, one of the following options used (rim / band joists exempted): </p>
              </div>

              <div *ngIf="item.description.startsWith('4.') && !mfChecklistItems[indexofelement - 1]?.description.startsWith('4.')" style="height: 100px;
              background: #ffffff;
              padding: 5px;">
                <p style="height: 100%;
                display: flex;
                align-items: start;
                justify-content: center;
                flex-direction: column;
                font-size: 1.5em;">4. Air Sealing - <span style="margin-top: 1%;
                align-items: start;
                font-weight: 200;
                text-align: left;">(Unless otherwise noted below, "sealed" indicates the use of caulk, foam, or equivalent material)</span></p>
              </div>

              <div *ngIf="item.description.startsWith('4.') && !mfChecklistItems[indexofelement - 1]?.description.startsWith('4.')" style="height: 10em;
              background: #ffffff;">
                <p style="height: 100%;
                align-content: center;
                font-size: 1.5em;
                font-weight: 200;
                text-align: left;
                ">The following items must be verified in dwelling units and common spaces to reduce air leakage to exterior, adjacent buildings, or
unconditioned spaces. </p>
              </div>

              <div *ngIf="item.description.startsWith('4.9') && !mfChecklistItems[indexofelement - 1]?.description.startsWith('4.9')" style="height:10em;
              background: #ffffff;">
                <p style="height: 100%;
                align-content: center;
                font-size: 1.5em;
                font-weight: 200;
                text-align: left;
                ">The following items must be additionally verified in dwelling units, to reduce air leakage between conditioned spaces. </p>
              </div>

              <div *ngIf="item.description.startsWith('5.') && !mfChecklistItems[indexofelement - 1]?.description.startsWith('5.') && mfinspectionType != 1" style="height: 100px;
              background: #ffffff;">
                <p style="height: 100%;
                display: flex;
                align-items: start;
                justify-content: center;
                flex-direction: column;
                font-size: 1.5em;">5. Heating & Cooling Equipment</p>
              </div>

              <div *ngIf="item.description.startsWith('5.10') && !mfChecklistItems[indexofelement - 1]?.description.startsWith('5.10') && mfinspectionType != 1" style="height: 6em;
              background: #ffffff;
              padding: 5px;">
                <p style="height: 100%;
                align-content: center;
                text-align: left;
                font-size: 1.5em;
                font-weight: 200;">5.10 For all indoor / terminal units in dwelling units and common spaces:</p>
              </div>

              <div *ngIf="item.description.startsWith('6.') && !mfChecklistItems[indexofelement - 1]?.description.startsWith('6.')" style="height: 7em;
              background: #ffffff;">
                <p style="height: 100%;
                display: flex;
                align-items: start;
                justify-content: center;
                flex-direction: column;
                font-size: 1.5em;">6. Duct Quality Installation<span style="margin-top: 1%;
                align-items: start;
                font-weight: 200;
                text-align: left;">(Applies to Heating, Cooling, Ventilation, Exhaust, & Pressure Balancing Ducts)</span></p>
              </div>

              <div *ngIf="item.description.startsWith('7.') && !mfChecklistItems[indexofelement - 1]?.description.startsWith('7.')" style="height: 100px;
              background: rgb(255 255 255);">
                <p style="height: 100%;
                display: flex;
                align-items: start;
                justify-content: center;
                flex-direction: column;
                font-size: 1.5em;">7. Dwelling Unit Mechanical Ventilation Systems ("Vent System") & Inlets in Return Duct</p>
              </div>

              <div *ngIf="item.description.startsWith('8.') && !mfChecklistItems[indexofelement - 1]?.description.startsWith('8.') && mfinspectionType != 1" style="height: 100px;
              background: rgb(255 255 255);">
                <p style="    height: 100%;
                display: flex;
                align-items: start;
                justify-content: center;
                flex-direction: column;
                font-size: 1.5em;">8. Local Mechanical Exhaust - <span style="margin-top: 1%;
                align-items: start;
                font-weight: 200;
                text-align: left;">In each kitchen and bathroom, a system is installed that exhausts directly to the outdoors and meets one of
                the following Rater-measured airflow and manufacturer-rated sound level standards: </span></p>
              </div>

              <div *ngIf="item.description.startsWith('9.') && !mfChecklistItems[indexofelement - 1]?.description.startsWith('9.') && mfinspectionType != 1" style="height: 100px;
              background: rgb(255 255 255);">
                <p style="height: 100%;
                display: flex;
                align-items: start;
                justify-content: center;
                flex-direction: column;
                font-size: 1.5em;">9. Filtration</p>
              </div>

              <div *ngIf="item.description.startsWith('10.') && !mfChecklistItems[indexofelement - 1]?.description.startsWith('10.') && mfinspectionType != 1" style="height: 100px;
              background: rgb(255 255 255);">
                <p style="height: 100%;
                display: flex;
                align-items: start;
                justify-content: center;
                flex-direction: column;
                font-size: 1.5em;">10. Combustion Appliances</p>
              </div>

              <div *ngIf="item.description.startsWith('11.') && !mfChecklistItems[indexofelement - 1]?.description.startsWith('11.') && mfinspectionType != 1" style="height: 100px;
              background: rgb(255 255 255);">
                <p style="height: 100%;
                display: flex;
                align-items: start;
                justify-content: center;
                flex-direction: column;
                font-size: 1.5em;">11. Domestic Hot Water</p>
              </div>

              <div *ngIf="item.description.startsWith('12.') && !mfChecklistItems[indexofelement - 1]?.description.startsWith('12.') && mfinspectionType != 1" style="height: 100px;
              background: rgb(255 255 255);">
                <p style="height: 100%;
                display: flex;
                align-items: start;
                justify-content: center;
                flex-direction: column;
                font-size: 1.5em;">12. Lighting</p>
              </div>

              <div *ngIf="item.description.startsWith('13.') && !mfChecklistItems[indexofelement - 1]?.description.startsWith('13.') && mfinspectionType != 1" style="height: 100px;
              background: rgb(255 255 255);">
                <p style="height: 100%;
                display: flex;
                align-items: start;
                justify-content: center;
                flex-direction: column;
                font-size: 1.5em;">13. Appliances and Plumbing Fixtures </p>
              </div>               

              <div *ngIf="item.description.startsWith('14.') && !mfChecklistItems[indexofelement - 1]?.description.startsWith('14.') && mfinspectionType != 1" style="height: 100px;
              background: rgb(255 255 255);">
                <p style="height: 100%;
                display: flex;
                align-items: start;
                justify-content: center;
                flex-direction: column;
                font-size: 1.5em;">14. Whole Building Energy Consumption Data Acquisition Strategy </p>
              </div>




<!--Loop/section for creating collapsible objects for each checklist items-->
              <div *ngIf="item.isHeading" [hidden]="item.stage != 3 && item.stage != mfinspectionType && mfinspectionType != 0"
                style="padding: 10px 16px 6px; background: #fff;">
                <p style="font-family: Calibri; font-size: 1.05em; font-weight: 700; margin-bottom: 0;">{{item.description}}</p>
              </div>
              <div *ngIf="!item.isHeading" [hidden]="item.stage != 3 && item.stage != mfinspectionType && mfinspectionType != 0 ">
                <mat-expansion-panel #thePanel (opened)="loadData(item, indexofelement,true)">
                  <mat-expansion-panel-header class="collapseButton check-list" style="min-height: 100px; overflow: hidden;"
                    [ngClass]=" {'verified blackHeader': item.value?.trim().includes('Rater Verified'), 'na': item.value?.trim().includes('N'), 'must-correct': item.value?.trim().includes('Must Correct'), 'recommended':  item.value?.trim().includes('Recommended'), 'builderverified': item.value?.trim().includes('Builder'), 'default': item.value?.length < 1}">
                    <!--<mat-panel-title [ngStyle]="{'color: grey;' : item.value.trim().includes('N') }>-->
                    <mat-panel-title >
                      <p [ngStyle]="{'font-size': getFontSize(item.description)}"
                      style="font-family: Calibri;
                             margin-bottom: 0;
                             padding: 5px;
                             width: 100%;
                             text-overflow: ellipsis;
                             overflow: hidden;
                             font-weight: 700;
                             line-height: 1.5vh;
                             text-align: left;
                             letter-spacing: normal;">
                     {{item.description}}
                      <fa-icon
                      *ngIf="item.photos?.length > 0 || item.photo?.length > 0"
                      [icon]="facamera"
                      title="Photos available for this item"
                      style = "flex-shrink:0;">
                 </fa-icon>
                      <fa-icon
                      *ngIf="item.requiresPhoto && !(item.photos?.length > 0 || item.photo?.length > 0)"
                      [icon]="facamera"
                      title="Photo required for this item"
                      style="flex-shrink:0; color:#c30000; margin-left:6px;">
                 </fa-icon>
                   </p>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <mat-panel-description class="d-flex align-items-center" style="display: flex;
                  flex-direction: column;">

              <div class="photo-gallery" *ngIf="currentMFphotoobjects && currentMFphotoobjects.length > 0">
            <div *ngFor="let photoUrl of currentMFphotoobjects; let i = index" class="photo-thumbnail-wrapper">
                <a href="javascript:void(0)" (click)="openPhotoViewer(photoUrl)">
                    <img loading='lazy' class="photo-thumbnail" [src]="photoUrl" alt="Checklist item photo {{i + 1}}">
                </a>
                <button style="background-color: red;color: white;border: 0;border-radius: 9px;width: 4em;"
                (click)="openDeleteModalMF(photoUrl)" title="Delete Photo">
                    <mat-icon style="font-family: 'Roboto';">X</mat-icon>
                </button>
            </div>
        </div>
        <p *ngIf="!currentMFphotoobjects || currentMFphotoobjects.length === 0">No photos uploaded yet.</p>

        <input (change)="onFilePicked($event, selectedIndexMF, selectedMFChecklistItem.field, true)"
          type="file" accept="image/*, text/plain"
          [id]= getPhotoCardID(selectedIndexMF,true)
          style="display: none;" />
        <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick(getPhotoCardID(selectedIndexMF, true))">
            <fa-icon [icon]="facamera"></fa-icon>
          </button>
                  </mat-panel-description>

                  <div>
                    <div style="padding-bottom: 10px;" *ngIf="selectedMFChecklistItem?.value?.trim().includes('Builder')">
                      <p style="text-align: center;">Builder Verified</p>
                    </div>
                    <div class="container-center" *ngIf="!(selectedMFChecklistItem?.value?.trim().includes('Builder'))">
                      <mat-radio-group class="my-3" aria-label="Select an option"
                        [value]="selectedMFChecklistItem ? selectedMFChecklistItem.value : ''">
                        <mat-radio-button class="mr-3" value="Rater Verified"
                          (change)="selectionChangedMF('Rater Verified', indexofelement)">Rater Verified</mat-radio-button>
                        <mat-radio-button class="mr-3" (change)="selectionChangedMF('Must Correct', indexofelement)"
                          value="Must Correct">Must Correct</mat-radio-button>
                        <mat-radio-button class="mr-3" (change)="selectionChangedMF('NA', indexofelement)" value="NA">N/A
                        </mat-radio-button>
                        <mat-radio-button *ngIf="!isEnergyStar" class="mr-3" (change)="selectionChangedMF('NA', indexofelement)" value="Recommended">Recommended
                        </mat-radio-button>
                      </mat-radio-group>

                    </div>

                    <div
                      *ngIf="selectedMFChecklistItem ? (selectedMFChecklistItem.value == 'Must Correct' && presetArray.length > 0 ? true : false ) : false ">
                      <label>Pick a common correction (optional)</label>
                      <div *ngFor="let item of presetArray" class="mb-3">
                        <mat-checkbox (change)="addToNotes($event, item.descr, selectedIndexMF)">{{item.descr}}
                        </mat-checkbox>
                      </div>
                    </div>

                    <div class="row flex-column align-items-center">
                      <div class="col-lg-6 col-12 px-3 pb-3">
                        <textarea #mfnoteThing rows=6 (onclick)='trimNotes(mfnoteThing.value, selectedIndexMF)'
                          (blur)='notesBlur(mfnoteThing.value, selectedIndexMF,true)' id='mfchklistnote'
                          value="{{selectedMFChecklistItem ? (selectedMFChecklistItem.note ? selectedMFChecklistItem.note : '') : ''}}"></textarea>
                      </div>

                      <div class="col-lg-6 col-12 px-3 pb-3">
                        <p style="color: lightgrey;
                        display: flex;" *ngIf="reviewMode">{{lastChanged}}</p>
                      </div>
                    </div>

                    <div [hidden]="true"
                      class="container-center" style="padding: 10px; max-width: 300px; max-height: 300px;">
                    </div>

                    <!--pre[sets]-->




                  </div>

                </mat-expansion-panel>
              </div>
            </div>

          </mat-accordion>

        </div>


        <h3 class="collapseButton"><span>Additional Photos</span></h3>
        <div class="d-flex flex-wrap row">
          <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
            <label class="space-title">Above-Grade Walls: pre-insulation framing photo (use ruler / tape)</label>
            <a *ngIf="data.pics.env_framing_pic" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.env_framing_pic)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.env_framing_pic || ''}}">
            </a>
            <input (change)="photoTaken($event, 'env_framing_pic')" type="file" accept="image/*,text/plain" id="pictureinput96"
              style="display: none;" />
            <button class="my-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput96')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button>
            <div [hidden]="!data.pics?.env_framing_pic"><button mat-button color="green"
                [hidden]="!data.pics?.env_framing_pic" (click)="viewPic('env_framing_pic')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button></div>
          </div>

          <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
            <label class="space-title">Air Sealing: bath / kitchen exhaust-fan penetration air-sealing</label>
            <a *ngIf="data.pics.airseal_exhaust_pic" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.airseal_exhaust_pic)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.airseal_exhaust_pic || ''}}">
            </a>
            <input (change)="photoTaken($event, 'airseal_exhaust_pic')" type="file" accept="image/*,text/plain" id="pictureinput97"
              style="display: none;" />
            <button class="my-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput97')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button>
            <div [hidden]="!data.pics?.airseal_exhaust_pic"><button mat-button color="green"
                [hidden]="!data.pics?.airseal_exhaust_pic" (click)="viewPic('airseal_exhaust_pic')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button></div>
          </div>

          <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
            <label class="space-title">Pipe Freeze Protection: temperature controls w/ set point (riser rooms)</label>
            <a *ngIf="data.pics.pipe_freeze_pic" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.pipe_freeze_pic)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.pipe_freeze_pic || ''}}">
            </a>
            <input (change)="photoTaken($event, 'pipe_freeze_pic')" type="file" accept="image/*,text/plain" id="pictureinput98"
              style="display: none;" />
            <button class="my-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput98')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button>
            <div [hidden]="!data.pics?.pipe_freeze_pic"><button mat-button color="green"
                [hidden]="!data.pics?.pipe_freeze_pic" (click)="viewPic('pipe_freeze_pic')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button></div>
          </div>

          <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
            <label class="space-title">Ventilation: kitchen exhaust <b>ducted</b> to exterior or riser</label>
            <a *ngIf="data.pics.kitchen_exhaust_pic" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.kitchen_exhaust_pic)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.kitchen_exhaust_pic || ''}}">
            </a>
            <input (change)="photoTaken($event, 'kitchen_exhaust_pic')" type="file" accept="image/*,text/plain" id="pictureinput99"
              style="display: none;" />
            <button class="my-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput99')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button>
            <div [hidden]="!data.pics?.kitchen_exhaust_pic"><button mat-button color="green"
                [hidden]="!data.pics?.kitchen_exhaust_pic" (click)="viewPic('kitchen_exhaust_pic')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button></div>
          </div>
        </div>


      </div>






      <div class="tab-content" id="item2" [hidden]="selectedItem != 2" style="width:100%;">
        <label>TESTING

          <a [attr.href]="baseURL + '/rhAPI/raterform/rf_info/caztesting'" title="More info" target="_blank" style="color: black;
          margin-left: 1em;">
            <fa-icon title="Info" [icon]="fainfo"></fa-icon>
          </a>

        </label>



        <div style="justify-content: center;
        display: flex;
        align-items: center;
        text-align-last: left;">
          <div class="d-flex flex-wrap row row" style="margin-top: 20px;
          margin-bottom: 20px;
          width: 95%;">
            <!--<label>Test Specs </label> -->
            <h3 class="collapseButton"><span>Test Specs</span> </h3>
            <div class="content" style="text-align: left">
              <pre style="white-space:pre-wrap">{{testSpecs}}</pre>
            </div>
          </div>
        </div>

        <div class="d-flex flex-wrap row">

          <div class="d-flex flex-column col-lg-3 col-12 px-3 pb-3">
            <label class="space-title">Crawl Vents</label>
            <div class="box-border">
              <mat-radio-group class="mat-radio-grid" #cvnts formControlName="crawlvnts" (change)="updateSingleField('crawlvnts')"
                id='crawlvnts'>
                <mat-radio-button  value="Open">Open</mat-radio-button>
                <mat-radio-button  value="Closed">Closed</mat-radio-button>
                <mat-radio-button  value="N/A">N/A</mat-radio-button>
                <button class='radioClearButton' (click)= "clearOut('crawlvnts')" *ngIf="raterform.get('crawlvnts').value.length > 1"> Clear</button>
              </mat-radio-group>
            </div>
          </div>


          <div class="d-flex flex-column col-lg-3 col-12 px-3 pb-3">
            <label class="space-title">Basement Door</label>

            <div class="box-border" style="width: 79%;font-size: small;">
              <mat-radio-group class="mat-radio-grid" #bmd formControlName="bsmntdoor" (change)="updateSingleField('bsmntdoor')"
                id='bsmntdoor'>
                <mat-radio-button value="Open">Open</mat-radio-button>
                <mat-radio-button value="Closed">Closed</mat-radio-button>
                <mat-radio-button value="N/A">N/A</mat-radio-button>
                <button class='radioClearButton' (click)= "clearOut('bsmntdoor')" *ngIf="raterform.get('bsmntdoor').value.length > 1"> Clear</button>
              </mat-radio-group>
            </div>
          </div>

          <div class="d-flex flex-column col-lg-3 col-12 px-3 pb-3">
            <div style="width: 100%"><label class="space-title">Crawl Door</label></div>
            <div class="box-border" style="width: 79%;font-size: small;">
              <mat-radio-group class="mat-radio-grid" formControlName="crwldoor" (change)="updateSingleField('crwldoor')"
                id='crwldoor'>
                <mat-radio-button value="Open">Open</mat-radio-button>
                <mat-radio-button value="Closed">Closed</mat-radio-button>
                <mat-radio-button value="N/A">N/A</mat-radio-button>
                <button (click)= "clearOut('crwldoor')" class='radioClearButton' *ngIf="raterform.get('crwldoor').value.length > 1"> Clear</button>
              </mat-radio-group>
            </div>
          </div>


          <div class="d-flex flex-column col-lg-3 col-12 px-3 pb-3">
            <div style="width: 100%"><label class="space-title">Crawl Hatch</label></div>
            <div class="box-border" style="width: 79%;font-size: small;">
              <mat-radio-group class="mat-radio-grid" formControlName="crwlhatch" (change)="updateSingleField('crwlhatch')"
                id='crwlhatch'>
                <mat-radio-button value="Open">Open</mat-radio-button>
                <mat-radio-button value="Closed">Closed</mat-radio-button>
                <mat-radio-button value="N/A">N/A</mat-radio-button>
                <button (click)= "clearOut('crwlhatch')" class='radioClearButton' *ngIf="raterform.get('crwlhatch').value.length > 1"> Clear</button>
              </mat-radio-group>
            </div>
          </div>

          <div class="d-flex flex-column col-lg-3 col-12 px-3 pb-3">
            <div style="width: 100%;"><label class="space-title">Attic Door</label></div>
            <div class="box-border" style="width: 79%;font-size: small;">
              <mat-radio-group class="mat-radio-grid" formControlName="atticdoor" (change)="updateSingleField('atticdoor')"
                id='atticdoor'>
                <mat-radio-button value="Open">Open</mat-radio-button>
                <mat-radio-button value="Closed">Closed</mat-radio-button>
                <mat-radio-button value="N/A">N/A</mat-radio-button>
                <button (click)= "clearOut('atticdoor')" class='radioClearButton' *ngIf="raterform.get('atticdoor').value.length > 1"> Clear</button>
              </mat-radio-group>
            </div>
          </div>


          <div class="d-flex flex-column col-lg-3 col-12 px-3 pb-3">
            <div style="width: 100%;"><label class="space-title">AHU Panel</label></div>
            <div class="box-border" style="width: 79%;font-size: small;">
              <mat-radio-group class="mat-radio-grid" formControlName="ahupanel" (change)="updateSingleField('ahupanel')"
                id='ahuPanel'>
                <mat-radio-button value="On">On</mat-radio-button>
                <mat-radio-button value="Off">Off</mat-radio-button>
                <mat-radio-button value="N/A">N/A</mat-radio-button>
                <button (click)= "clearOut('ahupanel')" class='radioClearButton' *ngIf="raterform.get('ahupanel').value.length > 1"> Clear</button>
              </mat-radio-group>
            </div>
          </div>



        <!--
        <div class="d-flex flex-wrap row align-items-center">
          <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
            <label class="mb-auto">AHU Panel Picture</label>
            <a *ngIf="data.pics.ahupanel" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.ahupanel)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.ahupanel || ''}}">
          </a>
            <input (change)="photoTaken($event, 'ahupanel')" type="file" accept="image/*,text/plain" id="pictureinput93"
              style="display: none;" />
            <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput93')"  onclick="this.value = null">
              <fa-icon [icon]="facamera"></fa-icon>
            </button>
            <div [hidden]="!data.pics?.ahupanel"><button mat-button color="green" [hidden]="!data.pics?.ahupanel"
                (click)="viewPic('ahupanel')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button></div>

          </div>
        </div>
        -->

          <div class="d-flex flex-column col-lg-3 col-12 px-3 pb-3">
            <label class="space-title">Infiltration Testing Method</label>
            <div class="box-border" style="font-size: small;">
              <mat-radio-group class="mat-radio-grid" formControlName="infltestmet" (change)="updateSingleField('infltestmet')"
                id='infltestmet'>
                <mat-radio-button value="Pressurized">Pressurized</mat-radio-button>
                <mat-radio-button value="Depressurized">Depressurized</mat-radio-button>
                <button (click)= "clearOut('infltestmet')" class='radioClearButton' *ngIf="raterform.get('infltestmet').value.length > 1"> Clear</button>
              </mat-radio-group>
            </div>
          </div>

          <div class="d-flex flex-column col-lg-6 col-12 px-3 pb-3">
            <label class="space-title">Wind Observation</label>
            <mat-radio-group class="mat-radio-grid" formControlName="windobsrv"  (change)="updateSingleField('windobsrv')"
              id='windobsrv'>
              <mat-radio-button value="Still">Still</mat-radio-button>
              <mat-radio-button value="Calm">Calm</mat-radio-button>
              <mat-radio-button value="Light Breeze">Light Breeze</mat-radio-button>
              <mat-radio-button value="Gusty">Gusty</mat-radio-button>
              <mat-radio-button value="Thunderstorm">Thunderstorm</mat-radio-button>
              <button (click)= "clearOut('windobsrv')" class='radioClearButton' *ngIf="raterform.get('windobsrv').value.length > 1"> Clear</button>
            </mat-radio-group>
          </div>

          <div class="d-flex flex-column col-lg-12 col-12 px-3 pb-3">
            <label class="space-title">Precipitation Observation</label>
            <mat-radio-group class="mat-radio-grid" formControlName="precobsrv"  (change)="updateSingleField('precobsrv')"
              id='precobsrv'>
              <mat-radio-button value="Dry">Dry</mat-radio-button>
              <mat-radio-button value="Humid">Humid</mat-radio-button>
              <mat-radio-button value="Foggy">Foggy</mat-radio-button>
              <mat-radio-button value="Rainy">Rainy</mat-radio-button>
              <mat-radio-button value="Snowing">Snowing</mat-radio-button>
              <button (click)= "clearOut('precobsrv')" class='radioClearButton' *ngIf="raterform.get('precobsrv').value.length > 1"> Clear</button>
            </mat-radio-group>
          </div>

          <div class="d-flex flex-wrap row col-lg-6 col-12 flex-wrapper mb-4">

            <h3 style="color: #424242; padding-top: 1em;"> Used for calculating CFM50 only</h3>

            <div class="col-lg-6 col-12 px-3" matRipple [matRippleDisabled]="true" #tempinRipple>
              <div class="flex-section-external-pressure">
                <mat-label class="formLabel">Indoor Temp </mat-label>
                <mat-form-field>
                  <input matInput formControlName="indoortemp" (focus)="setInitialValue('indoortemp')" (blur)="updateSingleField('indoortemp');updateBDFactors('previousIndoor');" id='indoortemp'>
                </mat-form-field>
              </div>
            </div>

            <div class="col-lg-6 col-12 px-3" matRipple [matRippleDisabled]="true" #tempoutRipple>
              <div class="flex-section-external-pressure" #tempoutRipple>
                <mat-label class="formLabel">Outdoor Temp </mat-label>
                <mat-form-field>
                  <input matInput formControlName="outdoortemp" (focus)="setInitialValue('outdoortemp')" (blur)="updateSingleField('outdoortemp');updateBDFactors('previousOutdoor');"
                    id='outdoortemp'>
                </mat-form-field>
              </div>
            </div>

            <div class="col-lg-6 col-12 px-3" matRipple [matRippleDisabled]="true" #baselineRipple>
              <div class="flex-section-external-pressure" #baselineRipple>
                <mat-label class="formLabel">Baseline Pressure</mat-label>
                <mat-form-field>
                  <input matInput formControlName="envblnpres" (focus)="setInitialValue('envblnpres')" (blur)="updateSingleField('envblnpres');updateBDFactors('previousBaseline');" id='envblnpres'>
                </mat-form-field>
              </div>
            </div>

            <div class="col-lg-6 col-12 px-3" matRipple [matRippleDisabled]="true" #elevationRipple>
              <div class="flex-section-external-pressure" #elevationRipple>
                <mat-label class="formLabel">Default Elevation: </mat-label>
                <mat-form-field>
                  <input matInput formControlName="elevation" (focus)="setInitialValue('elevation');" (blur)="updateSingleField('elevation');updateBDFactors('previousElevation');" id='elevation'>
                </mat-form-field>
              </div>
            </div>


          </div>

          <div style="padding-top: 1em; padding-bottom: 1em;">
            <div id="warning" style="display: flex;" *ngIf="show_bd_factor_warning == true" style="display: flex;
                flex-direction: column;
                align-items: center;
                border: 1px solid grey;
                width: 40%;">

                <div>
                  <p style="padding-top: 1em;
                  color: #424242;">Factors changed. Click "Calculate Flow @ 50 Pascals" button below.</p>
                </div>

            <div style="display: flex; flex-direction: row; align-items: center;">

              <div>
                <p style="color: red;
                font-weight: 200;
                padding: 1em;" *ngIf="previousIndoor_changed == true">Indoor Temp - Previous value : {{previousIndoor}}</p>
                <p style="color: red;
                font-weight: 200;
                padding: 1em;" *ngIf="previousBaseline_changed == true">Baseline Pressure - Previous Value : {{previousBaseline}}</p>

              </div>

              <div>
                <p style="color: red;
                font-weight: 200;
                padding: 1em;" *ngIf="previousOutdoor_changed == true">Outdoor Temp - Previous value : {{previousOutdoor}}</p>
                <p style="color: red;
                font-weight: 200;
                padding: 1em;" *ngIf="previousElevation_changed == true">Elevation - Previous Value : {{previousElevation}}</p>
              </div>


            </div>
          </div>

        </div>

        </div>

        <h5 style="text-align: center;">Multi Point Testing</h5>

        <!--
        <div class="title-row my-3">
          <h5> Pressure (Pa)</h5>
        </div>
        -->

        <div class="d-flex flex-wrap row">

          <div class="flex-section-external-pressure col-lg-3 col-12 px-3">
            <mat-label style="color:black !important;">Pa #1 </mat-label>
            <mat-form-field>
              <input matInput formControlName="multipa1" (focus)="setInitialValue('multipa1')" (blur)="updateSingleField('multipa1')" id='multipa1'>
            </mat-form-field>
          </div>

          <div class="flex-section-external-pressure col-lg-3 col-12 px-3" style="margin-bottom: 20px;">
            <mat-label>Flow #1 </mat-label>
            <mat-form-field>
              <input matInput formControlName="multiflo1" (focus)="setInitialValue('multiflo1')" (blur)="updateSingleField('multiflo1')">
            </mat-form-field>
          </div>

          <div class="flex-section-external-pressure col-lg-3 col-12 px-3">
            <mat-label style="color:black !important;">Pa #2 </mat-label>
            <mat-form-field>
              <input matInput formControlName="multipa2" (focus)="setInitialValue('multipa2')" (blur)="updateSingleField('multipa2')" id='multipa2'>
            </mat-form-field>
          </div>

          <div class="flex-section-external-pressure col-lg-3 col-12 px-3" style="margin-bottom: 20px;">
            <mat-label>Flow #2 </mat-label>
            <mat-form-field>
              <input matInput formControlName="multiflo2" (focus)="setInitialValue('multiflo2')" (blur)="updateSingleField('multiflo2')">
            </mat-form-field>
          </div>

          <div class="flex-section-external-pressure col-lg-3 col-12 px-3">
            <mat-label style="color:black !important;">Pa #3 </mat-label>
            <mat-form-field>
              <input matInput formControlName="multipa3" (focus)="setInitialValue('multipa3')" (blur)="updateSingleField('multipa3')" id='multipa3'>
            </mat-form-field>
          </div>

          <div class="flex-section-external-pressure col-lg-3 col-12 px-3" style="margin-bottom: 20px;">
            <mat-label>Flow #3 </mat-label>
            <mat-form-field>
              <input matInput formControlName="multiflo3" (focus)="setInitialValue('multiflo3')" (blur)="updateSingleField('multiflo3')">
            </mat-form-field>
          </div>

          <div class="flex-section-external-pressure col-lg-3 col-12 px-3">
            <mat-label style="color:black !important;">Pa #4</mat-label>
            <mat-form-field>
              <input matInput formControlName="multipa4" (focus)="setInitialValue('multipa4')" (blur)="updateSingleField('multipa4')" id='multipa4'>
            </mat-form-field>
          </div>

          <div class="flex-section-external-pressure col-lg-3 col-12 px-3" style="margin-bottom: 20px;">
            <mat-label>Flow #4</mat-label>
            <mat-form-field>
              <input matInput formControlName="multiflo4" (focus)="setInitialValue('multiflo4')" (blur)="updateSingleField('multiflo4')">
            </mat-form-field>
          </div>

          <div class="flex-section-external-pressure col-lg-3 col-12 px-3">
            <mat-label style="color:black !important;">Pa #5</mat-label>
            <mat-form-field>
              <input matInput formControlName="multipa5" (focus)="setInitialValue('multipa5')" (blur)="updateSingleField('multipa5')" id='multipa5'>
            </mat-form-field>
          </div>

          <div class="flex-section-external-pressure col-lg-3 col-12 px-3" style="margin-bottom: 20px;">
            <mat-label>Flow #5</mat-label>
            <mat-form-field>
              <input matInput formControlName="multiflo5" (focus)="setInitialValue('multiflo5')" (blur)="updateSingleField('multiflo5')">
            </mat-form-field>
          </div>


          <div class="flex-section-external-pressure col-lg-3 col-12 px-3">
            <mat-label style="color:black !important;">Pa #6</mat-label>
            <mat-form-field>
              <input matInput formControlName="multipa6" (focus)="setInitialValue('multipa6')" (blur)="updateSingleField('multipa6')" id='multipa6'>
            </mat-form-field>
          </div>

          <div class="flex-section-external-pressure col-lg-3 col-12 px-3" style="margin-bottom: 20px;">
            <mat-label>Flow #6</mat-label>
            <mat-form-field>
              <input matInput formControlName="multiflo6" (focus)="setInitialValue('multiflo6')" (blur)="updateSingleField('multiflo6')">
            </mat-form-field>
          </div>


        </div>


      <!--
        <div class="title-row my-3">
          <h5> Flow (CFM)</h5>
        </div>
        <div class="d-flex flex-wrap row">
          <div class="flex-section-external-pressure col-lg-3 col-12 px-3">
            <mat-label>1 </mat-label>
            <mat-form-field>
              <input matInput formControlName="multiflo1" (focus)="setInitialValue('multiflo1')" (blur)="updateSingleField('multiflo1')">
            </mat-form-field>
          </div>

          <div class="flex-section-external-pressure col-lg-3 col-12 px-3">
            <mat-label>2 </mat-label>
            <mat-form-field>
              <input matInput formControlName="multiflo2" (focus)="setInitialValue('multiflo2')" (blur)="updateSingleField('multiflo2')">
            </mat-form-field>
          </div>

          <div class="flex-section-external-pressure col-lg-3 col-12 px-3">
            <mat-label>3 </mat-label>
            <mat-form-field>
              <input matInput formControlName="multiflo3" (focus)="setInitialValue('multiflo3')" (blur)="updateSingleField('multiflo3')">
            </mat-form-field>
          </div>

          <div class="flex-section-external-pressure col-lg-3 col-12 px-3">
            <mat-label>4</mat-label>
            <mat-form-field>
              <input matInput formControlName="multiflo4" (focus)="setInitialValue('multiflo4')" (blur)="updateSingleField('multiflo4')">
            </mat-form-field>
          </div>

          <div class="flex-section-external-pressure col-lg-3 col-12 px-3">
            <mat-label>5</mat-label>
            <mat-form-field>
              <input matInput formControlName="multiflo5" (focus)="setInitialValue('multiflo5')" (blur)="updateSingleField('multiflo5')">
            </mat-form-field>
          </div>

          <div class="flex-section-external-pressure col-lg-3 col-12 px-3">
            <mat-label>6</mat-label>
            <mat-form-field>
              <input matInput formControlName="multiflo6" (focus)="setInitialValue('multiflo6')" (blur)="updateSingleField('multiflo6')">
            </mat-form-field>
          </div>
        </div>
      -->

        <div class="col-lg-6 col-12 px-3 pb-3 mt-4">
          <button *ngIf = 'show_bd_factor_warning == false' mat-raised-button color="green" (click)="calculateFlowAt()">Calculate Flow "&#64;" 50 Pascals</button>
          <div *ngIf = 'show_bd_factor_warning == true' class="wrap"><button  style="padding: 1em;
            font-size: 1.2em; background: red !important;" mat-raised-button color="red" (click)="calculateFlowAt()">Calculate Flow "&#64;" 50 Pascals</button></div>
        </div>

        <div class="col-lg-6 col-12 px-3 pb-3" style="border: 1px solid black;
        box-shadow: 4px 4px;
        background: #d8f2d8;
        margin-bottom: 30px;" *ngIf="show_bd_factor_warning == false">
          <mat-label class="formLabel">Flow at 50 Pascals (Blower Door)</mat-label>
          <mat-form-field>
            <input matInput formControlName="flowat50" (focus)="setInitialValue('flowat50')" (blur)="updateSingleField('flowat50')">
          </mat-form-field>
        </div>
        <div *ngIf='thresholds.cfm50 != 0 && targetset' class="col-lg-6 col-12 px-3 pb-3">
            <p id="threshtext_2" class="thresholdtext">Threshold {{ thresholds.cfm50 }}</p>
        </div>

        <div class="col-lg-6 col-12 px-3 pb-3" style="border: 1px solid black;
        box-shadow: 4px 4px;
        background: #efbdbd;
        margin-bottom: 30px;" *ngIf="show_bd_factor_warning == true">
          <mat-label class="formLabel">Click Re-calculate button to see updated blower door value.</mat-label>
          <mat-form-field>
            <input matInput formControlName="flowat50" (focus)="setInitialValue('flowat50')" (blur)="updateSingleField('flowat50')">
          </mat-form-field>
        </div>


        <div class="d-flex flex-wrap row">

          <div class="flex-section-external-pressure col-lg-3 col-12 px-3">
            <mat-label class="formLabel importanthighlight">Blower Door </mat-label>
            <mat-form-field>
              <input matInput formControlName="blower_door" (focus)="setInitialValue('blower_door')" (blur)="updateSingleField('blower_door')" id='blower_door'
                (input)='recalcACH50(location_id)'>
            </mat-form-field>
          </div>
          <div *ngIf="thresholds.cfm50 != 0 && targetset" class="col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
            <p id='threshtext_1' class="thresholdtext" 
            [class.error]="blowerDoorControl.value * 1 > thresholds.cfm50">Threshold {{ thresholds.cfm50 }}</p>
          </div>

        </div>

        <div class="flex-container-external-pressure col-lg-3 col-12 px-3 mx-auto">
          <div class="flex-section-external-pressure mb-3">
            <mat-label class="formLabel">ACH 50</mat-label>
            <mat-form-field>
              <input matInput formControlName="ach50" (focus)="setInitialValue('ach50')" (blur)="updateSingleField('ach50')" id='ach50'>
            </mat-form-field>
          </div>

          <button mat-raised-button color="green" (click)="recalcACH50(location_id)">Re-calculate</button>

        </div>
        <p style="text-align: center;">Volume: {{volume}}</p>

        <div class="d-flex flex-wrap row align-items-center">
          <div class="flex-section-external-pressure col-lg-3 col-12 px-3">
            <mat-label class="formLabel">Multi-Family .30cfm50 </mat-label>
            <mat-form-field>
              <input matInput formControlName="mfcfm" (blur)="updateSingleField('mfcfm')" id='mfcfm'>
            </mat-form-field>
          </div>
        </div>

        <div class="d-flex flex-wrap row align-items-center">
          <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
            <label class="mb-auto">Blower Door/ACH50 Picture</label>
            <a *ngIf="data.pics.ach50" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.ach50)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.ach50 || ''}}">
          </a>
            <input (change)="photoTaken($event, 'ach50')" type="file" accept="image/*,text/plain" id="pictureinput56"
              style="display: none;" />
            <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput56')"  onclick="this.value = null">
              <fa-icon [icon]="facamera"></fa-icon>
            </button>
            <div [hidden]="!data.pics?.ach50"><button mat-button color="green" [hidden]="!data.pics?.ach50"
                (click)="viewPic('ach50')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button></div>

          </div>
        </div>


        <div class="d-flex flex-wrap row">

          <div class=" col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
            <label >BD Notes</label>
              <textarea rows=5 formControlName="bdnotes" (focus)="setInitialValue('bdnotes')" (blur)="updateSingleField('bdnotes')"  id='bdnotes'>
              </textarea>
          </div>

          <div class="flex-section-external-pressure col-lg-3 col-12 px-3">
            <mat-label class="formLabel"> <p style="text-align:left;"><span style="font-size: 16px;font-weight: bold;">MF Only</span></p><p style="font-size: 16px;
              line-height: 12px;
              font-weight: 200;margin-bottom: 10px;text-align: left;">Units with no ducted returns and an AHU located in a closet/space adjacent to unconditioned space (wall/floor/ceiling), during the compartmentilization test (blower door @50pa), the pressure difference between AHU closet/space and rest of the unit is ≤ 5 Pa.</p> </mat-label>
            <mat-form-field>  
              <input matInput formControlName="bdahucloset" (focus)="setInitialValue('bdahucloset')" (blur)="updateSingleField('bdahucloset')" id='bdahucloset'>
            </mat-form-field>
          </div>

          <div class="d-flex flex-wrap row align-items-center">
            <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
              <label class="mb-auto">Pr. Diff. picture</label>
              <a *ngIf="data.pics.bdahucloset" class="upload-image-wrapper"
              href="javascript:void(0)" (click)="openPhotoViewer(data.pics.bdahucloset)">
              <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
                src="{{data.pics.bdahucloset || ''}}">
            </a>
              <input (change)="photoTaken($event, 'bdahucloset')" type="file" accept="image/*,text/plain" id="pictureinput87"
                style="display: none;" />
              <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput87')"  onclick="this.value = null">
                <fa-icon [icon]="facamera"></fa-icon>
              </button>
              <div [hidden]="!data.pics?.bdahucloset"><button mat-button color="green" [hidden]="!data.pics?.bdahucloset"
                  (click)="viewPic('bdahucloset')">
                  <fa-icon [icon]="facamera"></fa-icon>
                </button></div>
  
            </div>
          </div>

         <!-- <div class="col-lg-6 col-12 px-3 pb-3">
            <p style="text-align: center;padding: 5px; ">ELR value: {{elr}}</p>
          </div> -->

        </div>

        <div class="box-border">
          <mat-label class="formLabel">Supplies in unfinished/insulated areas (ex. Basement mech room) 

            <a [attr.href]="baseURL + '/rhAPI/raterform/rf_info/suppliesinareas'" title="More info" target="_blank" style="color: black;
            margin-left: 1em;">
              <fa-icon title="Info" [icon]="fainfo"></fa-icon>
            </a>
            
          </mat-label>
          <mat-form-field>
            <mat-select matNativeControl formControlName="suppliesinareas" (selectionChange)="updateSingleField('suppliesinareas', false)">
              <mat-option value=''></mat-option>
              <mat-option value='Yes'>Yes</mat-option>
              <mat-option value='No'>No</mat-option>
              <mat-option value='N/A'>N/A</mat-option>
            </mat-select>
          </mat-form-field>
        </div>


        <label>HVAC Systems</label>

        <mat-expansion-panel id="hvac1panel">
          <mat-expansion-panel-header class="collapseButton check-list">
            {{raterform.get('hvac1name').value.length > 1 ? raterform.get('hvac1name').value : 'HVAC System 1'}}
          </mat-expansion-panel-header>
          <!--
          <label>{{raterform.get('hvac1name').value.length > 1 ?
            raterform.get('hvac1name').value : 'HVAC System 1'}}</label>-->
          <div class="flex-container-external-pressure d-flex flex-wrap row">

            <div class="d-flex justify-content-center">
              <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
                <mat-label class="formLabel">Name</mat-label>
                <mat-form-field>
                  <input matInput formControlName="hvac1name"  (blur)="updateSingleField('hvac1name');systemnamed(1);" id='hvac1name'>
                </mat-form-field>
              </div>
            </div>
            <div class="d-flex flex-wrap row">
              <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
                <label class="space-title">Tested At: </label>
                <mat-radio-group formControlName="stagedone1" id="stagedone1" (change)="updateSingleField('stagedone1')"
                  class="mat-radio-grid">
                  <mat-radio-button value="Rough-In">Rough-In</mat-radio-button>
                  <mat-radio-button value="Final">Final</mat-radio-button>
                  <mat-radio-button value="Post Construction">Post Construction</mat-radio-button>
                  <mat-radio-button value="Other">Other</mat-radio-button>
                </mat-radio-group>
              </div>

              <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
                <label class="space-title">Duct Tester Location</label>
                <mat-radio-group formControlName="dcttestloc1" id="dcttestloc1"
                  (change)="updateSingleField('dcttestloc1')" class="mat-radio-grid"
                  [value]="'Largest Return Grille'">
                  <mat-radio-button value="Return Closest to Air Handler">Return Closest to
                    Air
                    Handler</mat-radio-button>
                  <mat-radio-button value="Air Handler">Air Handler</mat-radio-button>
                  <mat-radio-button value="Largest Return Grille">Largest Return Grille
                  </mat-radio-button>
                </mat-radio-group>
              </div>

              <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
                <label class="space-title">Supply Duct Reference Location</label>
                <mat-radio-group formControlName="spldctref1" (change)="updateSingleField('spldctref1')" class="mat-radio-grid"
                  id="spldctref1">
                  <mat-radio-button value="Supply Closest to Air Handler">Supply Closest to
                    Air
                    Handler</mat-radio-button>
                  <mat-radio-button value="Supply Plenum">Supply Plenum</mat-radio-button>
                  <mat-radio-button value="S/R Closest2AirHandler(4+ Ret)">Supply and Return
                    Closest to Air Handler (4 or More Returns)</mat-radio-button>

                </mat-radio-group>
              </div>

              <div style="display:flex; flex-direction:column;">
                <div>
                  <h3 style="text-align:center;">Duct Location </h3>

                  <div class="d-flex flex-wrap row" style="justify-content: center;">
                    <div class="d-flex flex-column col-lg-6 col-12 px-0" style="width: 90%;">

                      <label class="d-block text-center"> Location 1: </label>
                      <div class="d-flex flex-wrap row">
                        <div class="col-lg-6 col-12 px-3">
                          <mat-label class="formLabel">Duct Location : </mat-label>
                          <mat-form-field>
                            <mat-select formControlName="dctlc1sys1" (blur)="updateSingleField('dctlc1sys1')">
                              <mat-option *ngFor="let item of ductlocations" [value]="item.value">
                                {{item.viewValue}}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>


                        <div class=" col-lg-6 col-12 px-3">
                          <mat-label class="formLabel">%: </mat-label>
                          <mat-form-field>
                            <mat-select formControlName="dctpc1sys1"  (blur)="updateSingleField('dctpc1sys1')">
                              <mat-option *ngFor="let item of ductpercentages" [value]="item.value">
                                {{item.viewValue}}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>



                    </div>

                    <div class="d-flex flex-column col-lg-6 col-12 px-0 " style="width: 90%;">

                      <label class="d-block text-center"> Location 2: </label>
                      <div class="d-flex flex-wrap row">
                        <div class="col-lg-6 col-12 px-3">
                          <mat-label class="formLabel">Duct Location : </mat-label>
                          <mat-form-field>
                            <mat-select formControlName="dctlc2sys1"  (blur)="updateSingleField('dctlc2sys1')" id='dctlc2sys1'>
                              <mat-option *ngFor="let item of ductlocations" [value]="item.value">
                                {{item.viewValue}}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <div class="col-lg-6 col-12 px-3">
                          <mat-label class="formLabel">%: </mat-label>
                          <mat-form-field>
                            <mat-select formControlName="dctpc2sys1"  (blur)="updateSingleField('dctpc2sys1')" id='dctpc2sys1'>
                              <mat-option *ngFor="let item of ductpercentages" [value]="item.value">
                                {{item.viewValue}}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>

                      </div>
                    </div>

                    <div class="flex-container-external-pressure d-flex flex-column col-lg-6 col-12 px-0" style="width: 90%;">

                      <h3> Location 3: </h3>
                      <div class="d-flex flex-wrap row">
                        <div class="col-lg-6 col-12 px-3">
                          <mat-label class="formLabel">Duct Location : </mat-label>
                          <mat-form-field>
                            <mat-select formControlName="dctlc3sys1" (blur)="updateSingleField('dctlc3sys1')">
                              <mat-option *ngFor="let item of ductlocations" [value]="item.value">
                                {{item.viewValue}}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <div class=" col-lg-6 col-12 px-3">
                          <mat-label class="formLabel">%: </mat-label>
                          <mat-form-field>
                            <mat-select formControlName="dctpc3sys1" (blur)="updateSingleField('dctpc3sys1')">
                              <mat-option *ngFor="let item of ductpercentages" [value]="item.value">
                                {{item.viewValue}}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>

                      </div>

                    </div>
                  </div>

                </div>

                <div style="padding-top:40px;">
                  <h3 style="text-align:center;">AHU Location </h3>
                  <div class="d-flex flex-column col-lg-6 col-12 px-0">
                    <label class="d-block text-center"> Location 1: </label>
                    <div class="col-lg-6 col-12 px-3">
                      <mat-label class="formLabel">Location : </mat-label>
                      <mat-form-field>
                        <mat-select formControlName="ahulc1sys1"  (blur)="updateSingleField('ahulc1sys1')" id='ahulc1sys1'>
                          <mat-option *ngFor="let item of ahlocations2" [value]="item.value">
                            {{item.viewValue}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex flex-wrap row">

              <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
                <label class="mb-auto importanthighlight">DB 1 Total Picture</label>
                <a *ngIf="data.pics.db1_total" class="upload-image-wrapper"
                href="javascript:void(0)" (click)="openPhotoViewer(data.pics.db1_total)">
                <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
                  src="{{data.pics.db1_total || ''}}">
              </a>
                <input (change)="photoTaken($event, 'db1_total')" type="file" accept="image/*,text/plain" id="pictureinput48"
                  style="display: none;" />
                <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput48')">
                  <fa-icon [icon]="facamera"></fa-icon>
                </button>

                <div [hidden]="!data.pics?.db1_total"><button mat-button color="green"
                    [hidden]="!data.pics?.db1_total" (click)="viewPic('db1_total')">
                    <fa-icon [icon]="facamera"></fa-icon>
                  </button></div>

              </div>  


              <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
                <label class="mb-auto importanthighlight">DB 1 Ext Picture</label>
                <a *ngIf="data.pics.db1_ext" class="upload-image-wrapper"
                href="javascript:void(0)" (click)="openPhotoViewer(data.pics.db1_ext)">
                <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
                  src="{{data.pics.db1_ext || ''}}">
              </a>
                <input (change)="photoTaken($event, 'db1_ext')" type="file" accept="image/*,text/plain" id="pictureinput49"
                  style="display: none;" />
                <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput49')">
                  <fa-icon [icon]="facamera"></fa-icon>
                </button>

                <!-- <div [hidden]="!data.pics?.db1_ext"><button mat-button color="green"
                    [hidden]="!data.pics?.db1_ext" (click)="viewPic('db1_ext')">
                    <fa-icon [icon]="facamera"></fa-icon>
                  </button></div> -->

              </div>


              <!--<div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
                <mat-label class="formLabel">Baseline Pressure</mat-label>
                <mat-form-field>
                  <input matInput formControlName="duct1bspr" (focus)="setInitialValue('duct1bspr')" (blur)="updateSingleField('duct1bspr')" id='duct1bspr'>
                </mat-form-field>
              </div> -->



              <div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
                <mat-label class="formLabel importanthighlight">Ducted Returns</mat-label>
                <mat-form-field>
                  <input matInput formControlName="noreturn1" (focus)="setInitialValue('noreturn1')" (change)="warningCheck(false,1)" (blur)="updateSingleField('noreturn1')" id='noreturn1'>
                </mat-form-field>
              </div>

              <div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
                <mat-label class="formLabel importanthighlight">Total % </mat-label>
                <mat-form-field>
                  <input matInput formControlName="hvac1totpcnt" (focus)="setInitialValue('hvac1totpcnt')" (blur)="updateSingleField('hvac1totpcnt')">
                </mat-form-field>
              </div>

              <div *ngIf="(this.raterform.get('noreturn1').value < 3 && this.raterform.get('hvac1totpcnt').value > 8) || (this.raterform.get('noreturn1').value >= 3 && this.raterform.get('hvac1totpcnt').value > 12) || (this.raterform.get('hvac1extpcnt').value > 4)" style="display: flex; justify-content:center;color :red; padding:10px 0px;">
                <fa-icon [icon]="faExclamationCircle" ></fa-icon>
                <span  style="padding-left :10px;" > Warning: The leakage to exterior % or the total % may be too high, meaning this home may fail.  </span>
              </div>

              <div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
                <mat-label class="formLabel importanthighlight">Ext %</mat-label>
                <mat-form-field>
                  <input matInput formControlName="hvac1extpcnt" (focus)="setInitialValue('hvac1extpcnt')"  (blur)="updateSingleField('hvac1extpcnt');">
                </mat-form-field>
              </div>





              <div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
                <mat-label class="formLabel importanthighlight">DB Total </mat-label>
                <mat-form-field>
                  <input matInput formControlName="db1_total" (focus)="setInitialValue('db1_total')" (blur)="warningCheck(false,1); updateSingleField('db1_total');warningCheck(false,1);" id='db1_total'
                    (input)="dbtotalCalc(raterform.get('db1_total').value, raterform.get('hvac1_option1_sf').value, raterform.get('hvac1_option2_sf').value, hvac_1_area, 1, true)">
                </mat-form-field>
              </div>

              <div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
                <mat-label class="formLabel importanthighlight">DB Ext</mat-label>
                <mat-form-field>
                  <input matInput formControlName="db1_ext" (focus)="setInitialValue('db1_ext')"  (blur)=" warningCheck(false,1);updateSingleField('db1_ext');" id='db1_ext'
                    (input)="dbextCalc(raterform.get('db1_ext').value, raterform.get('hvac1_option1_sf').value, raterform.get('hvac1_option2_sf').value, hvac_1_area, 1, true)">
                </mat-form-field>
              </div>

              <div style="margin: auto;" class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
                
                <p style="font-size: 20px;
                height: 40px;
                align-content: center;">Total Sq.Ft: {{totalSF1}}</p>
                <button mat-raised-button color="green" (click)="clearSquareFootage(1)">Reset Optional SF</button>

                <!-- <mat-label class="formLabel">Total Sq.ft: </mat-label>
                <mat-form-field>
                  <input matInput 
                    id='totalsf1' [value]="totalSF1" disabled>
                </mat-form-field> -->


              </div>

              <div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
                <mat-label class="formLabel">1st Option Sq Ft</mat-label>
                <mat-form-field>
                  <input matInput formControlName="hvac1_option1_sf" (focus)="setInitialValue('hvac1_option1_sf')"  (blur)="updateSingleField('hvac1_option1_sf');warningCheck(false,1)"
                    id='hvac1_option1_sf'
                    (input)="optionalSFCalc(raterform.get('db1_ext').value, raterform.get('db1_total').value, raterform.get('hvac1_option1_sf').value, raterform.get('hvac1_option2_sf').value, hvac_1_area, 1)">
                </mat-form-field>
              </div>

              <div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
                <mat-label class="formLabel">2nd Option Sq Ft</mat-label>
                <mat-form-field>
                  <input matInput formControlName="hvac1_option2_sf" (focus)="setInitialValue('hvac1_option2_sf')" (blur)="updateSingleField('hvac1_option2_sf'); warningCheck(false,1)"
                    id='hvac1_option2_sf'
                    (input)="optionalSFCalc(raterform.get('db1_ext').value, raterform.get('db1_total').value, raterform.get('hvac1_option1_sf').value, raterform.get('hvac1_option2_sf').value, hvac_1_area, 1)">
                </mat-form-field>
              </div>

              <div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
                <mat-label class="formLabel">Optional Ceiling Ht <span *ngIf="heightdisabledtext === true"> (Disabled) </span></mat-label>
                <mat-form-field>
                  <input matInput formControlName="hvac1_optceilheight" (focus)="setInitialValue('hvac1_optceilheight')"
                    (blur)="updateSingleField('hvac1_optceilheight');warningCheck(false,1);optionalSFHeightWarningCheck();"
                    (input)="optionalSFCalc(raterform.get('db1_ext').value, raterform.get('db1_total').value, raterform.get('hvac1_option1_sf').value, raterform.get('hvac1_option2_sf').value, hvac_1_area, 1)"
                    id='hvac1_optceilheight'>
                </mat-form-field>
              </div>


              <div class="flex-section-external-pressure col-lg-3 col-12 px-3">
                <mat-label class="formLabel"> <p style="text-align:left;"><span style="font-size: 16px;font-weight: bold;">MF Only</span></p><p style="font-size: 16px;
                  line-height: 12px;
                  font-weight: 200;margin-bottom: 10px;text-align: left;">Units with no ducted returns, the pressure difference between the space containing the AHU and the rest of the unit, with the air handler running at high speed, is ≤ 5 Pa. For systems > 1 ton, increase by 1 Pa per half ton. 18k=6pa, 24k=7pa, 30k=8pa, 36k=9pa, etc.</p> </mat-label>
                <mat-form-field>
                  <input matInput formControlName="ahucloset" (focus)="setInitialValue('ahucloset')" (blur)="updateSingleField('ahucloset')" id='ahucloset'>
                </mat-form-field>
              </div>
    
              <div class="d-flex flex-wrap row align-items-center">
                <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
                  <label class="mb-auto">Pressure difference picture</label>
                  <a *ngIf="data.pics.ahucloset" class="upload-image-wrapper"
                  href="javascript:void(0)" (click)="openPhotoViewer(data.pics.ahucloset)">
                  <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
                    src="{{data.pics.ahucloset || ''}}">
                </a>
                  <input (change)="photoTaken($event, 'ahucloset')" type="file" accept="image/*,text/plain" id="pictureinput86"
                    style="display: none;" />
                  <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput86')"  onclick="this.value = null">
                    <fa-icon [icon]="facamera"></fa-icon>
                  </button>
                  <div [hidden]="!data.pics?.ahucloset"><button mat-button color="green" [hidden]="!data.pics?.ahucloset"
                      (click)="viewPic('ahucloset')">
                      <fa-icon [icon]="facamera"></fa-icon>
                    </button></div>
      
                </div>
              </div>


              <div class="d-flex flex-wrap row align-items-center">
                <div class="col-lg-3 col-12 px-lg-3 px-3 p-3 d-flex flex-row align-items-center">
                  <mat-checkbox formControlName="hvac1_exempt" (change)="updateSingleField('hvac1_exempt')" id="hvac1_exempt"><p style="margin-left: 20px;">Exempt</p></mat-checkbox>
                </div>
                <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
                  <mat-label class="formLabel">Exempt Reason</mat-label>
                  <mat-form-field>
                    <mat-select matNativeControl formControlName="hvac1_exempt_reason"
                      (blur)="updateSingleField('hvac1_exempt_reason', true)">
                      <mat-option value="All inside conditioned space">All inside conditioned space</mat-option>
                      <mat-option value="Ductless (mini-split)">Ductless (mini-split)</mat-option>
                      <mat-option value="<750sqft (NC ONLY)">&lt;750sqft (NC ONLY)</mat-option>
                      <mat-option value="Other - please describe in system notes below">Other - please describe in system notes below</mat-option>
                      <mat-option value=""></mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>


              <div class=" col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
                <label >System 1 Notes</label>
                  <textarea rows=5 formControlName="sys1notes" (focus)="setInitialValue('sys1notes')" (blur)="updateSingleField('sys1notes')" id='sys1notes'>
                  </textarea>
              </div>

              <p style="margin-top: 20px;
              margin-bottom: 20px;
              font-size: 16px;
              font-weight: 200;
              letter-spacing: 0.1px;
              line-height: 16px;
              text-align: left;">
                <span style="font-weight: bold;">MF DUCT REQ:</span></p>
                <p style="margin-top: 20px;
              margin-bottom: 20px;
              font-size: 16px;
              font-weight: 200;
              letter-spacing: 0.1px;
              line-height: 16px;
              text-align: left;"><span style="font-weight: bold;">6.4.2 Final:</span> Tested per allowances below, with the air handler & all ducts, building cavities used as ducts, duct boots, & register grilles atop the finished surface (e.g., drywall, floor) installed.
                No ducted returns: The greater of ≤ 6 CFM25 per 100 sq. ft. of CFA or ≤ 60 CFM. Additionally, the Rater-measured pressure difference between the space containing the air handler and the conditioned space, with the air handler running at high speed, is ≤ 5 Pa. For systems > 1 ton, increase by 1 Pa per half ton.
                One or two ducted returns: The greater of ≤ 8 CFM25 per 100 sq. ft. of CFA or ≤ 80 CFM.
                Three or more ducted returns: The greater of ≤ 12 CFM25 per 100 sq. ft. of CFA or ≤ 120 CFM.</p>
                <p style="margin-top: 20px;
              margin-bottom: 20px;
              font-size: 16px;
              font-weight: 200;
              letter-spacing: 0.1px;
              line-height: 16px;
              text-align: left;"><span style="font-weight: bold;">6.5 Townhouses only:</span> Rater-measured duct leakage to the outside the greater of ≤ 4 CFM25 per 100 sq. ft. of CFA or ≤ 40 CFM25.
              </p>

            </div>
          </div>


        </mat-expansion-panel>

        <mat-expansion-panel id="hvac2panel" *ngIf='raterform.get("hvac1name").value.length > 1'>
          <mat-expansion-panel-header class="collapseButton check-list">
            {{raterform.get('hvac2name').value.length > 1 ? raterform.get('hvac2name').value : 'HVAC System 2'}}
          </mat-expansion-panel-header>
          <!--<label>{{raterform.get('hvac2name').value.length > 1 ?
            raterform.get('hvac2name').value : 'HVAC System 2'}}</label>-->

          <div class="d-flex justify-content-center">
            <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
              <mat-label class="formLabel">Name</mat-label>
              <mat-form-field>
                <input matInput formControlName="hvac2name" (focus)="setInitialValue('hvac2name')" (blur)="updateSingleField('hvac2name');systemnamed(2);" id='hvac2name'>
              </mat-form-field>
            </div>
          </div>

          <div class="d-flex flex-wrap row">
            <div class="col-lg-6 col-12 px-3 pb-3">
              <label class="space-title">Tested At: </label>
              <mat-radio-group formControlName="stagedone2" (change)="updateSingleField('stagedone2')" class="mat-radio-grid">
                <mat-radio-button value="Rough-In">Rough-In</mat-radio-button>
                <mat-radio-button value="Final">Final</mat-radio-button>
                <mat-radio-button value="Post Construction">Post Construction</mat-radio-button>
                <mat-radio-button value="Other">Other</mat-radio-button>
              </mat-radio-group>
            </div>

            <div class="col-lg-6 col-12 px-3 pb-3">
              <label class="space-title">Duct Tester Location</label>
              <mat-radio-group formControlName="dcttestloc2"  (change)="updateSingleField('dcttestloc2')" class="mat-radio-grid">
                <mat-radio-button value="Return Closest to Air Handler">Return Closest to Air
                  Handler</mat-radio-button>
                <mat-radio-button value="Air Handler">Air Handler</mat-radio-button>
                <mat-radio-button value="Largest Return Grille">Largest Return Grille
                </mat-radio-button>

              </mat-radio-group>
            </div>

            <div class="flex-section-external-pressure col-12 px-3 pb-3">
              <label class="space-title">Supply Duct Reference Location</label>
              <mat-radio-group formControlName="spldctref2" (change)="updateSingleField('spldctref2')" class="mat-radio-grid">
                <mat-radio-button value="Supply Closest to Air Handler">Supply Closest to Air
                  Handler</mat-radio-button>
                <mat-radio-button value="Supply Plenum">Supply Plenum</mat-radio-button>
                <mat-radio-button value="S/R Closest2AirHandler(4+ Ret)">Supply and Return
                  Closest to Air Handler (4 or More Returns)</mat-radio-button>

              </mat-radio-group>
            </div>

            <label>Duct Location </label>
            <div class="d-flex flex-wrap row">


              <div class="flex-container-external-pressure col-lg-6 col-12 px-3">

                <h3>Location 1:</h3>
                <div class="d-flex flex-wrap row">
                  <div class="col-lg-6 col-12 px-3">
                    <mat-label class="formLabel">Duct Location :</mat-label>
                    <mat-form-field>
                      <mat-select formControlName="dctlc1sys2"  (blur)="updateSingleField('dctlc1sys2')" id='dctlc1sys2'>
                        <mat-option *ngFor="let item of ductlocations" [value]="item.value">
                          {{item.viewValue}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-6 col-12 px-3">
                    <mat-label class="formLabel">%: </mat-label>
                    <mat-form-field>
                      <mat-select formControlName="dctpc1sys2" (blur)="updateSingleField('dctpc1sys2')" id='dctpc1sys2'>
                        <mat-option *ngFor="let item of ductpercentages" [value]="item.value">
                          {{item.viewValue}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>


                </div>
              </div>

              <div class="flex-container-external-pressure col-lg-6 col-12 px-3">

                <h3> Location 2: </h3>
                <div class="d-flex flex-wrap row">
                  <div class="col-lg-6 col-12 px-3">
                    <mat-label class="formLabel">Duct Location : </mat-label>
                    <mat-form-field>
                      <mat-select formControlName="dctlc2sys2"  (blur)="updateSingleField('dctlc2sys2')" id='dctlc2sys2'>
                        <mat-option *ngFor="let item of ductlocations" [value]="item.value">
                          {{item.viewValue}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-6 col-12 px-3">
                    <mat-label class="formLabel">%: </mat-label>
                    <mat-form-field>
                      <mat-select formControlName="dctpc2sys2" (blur)="updateSingleField('dctpc2sys2')" id='dctpc2sys2'>
                        <mat-option *ngFor="let item of ductpercentages" [value]="item.value">
                          {{item.viewValue}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>

              </div>

              <div class="flex-container-external-pressure col-lg-6 col-12 px-3">

                <h3> Location 3: </h3>
                <div class="d-flex flex-wrap row">
                  <div class="col-lg-6 col-12 px-3">
                    <mat-label class="formLabel">Duct Location : </mat-label>
                    <mat-form-field>
                      <mat-select formControlName="dctlc3sys2"  (blur)="updateSingleField('dctlc3sys2')">
                        <mat-option *ngFor="let item of ductlocations" [value]="item.value">
                          {{item.viewValue}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-6 col-12 px-3">
                    <mat-label class="formLabel">%: </mat-label>
                    <mat-form-field>
                      <mat-select formControlName="dctpc3sys2"  (blur)="updateSingleField('dctpc3sys2')">
                        <mat-option *ngFor="let item of ductpercentages" [value]="item.value">
                          {{item.viewValue}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
            <label class ="importanthighlight">AHU Location </label>
            <div class="flex-container-external-pressure col-lg-6 col-12 px-3">

              <h3> Location 1: </h3>
              <div class="col-lg-6 col-12 px-3">
                <mat-label class="formLabel">Location : </mat-label>
                <mat-form-field>
                  <mat-select formControlName="ahulc1sys2"  (blur)="updateSingleField('ahulc1sys2')" id='ahulc1sys2'>
                    <mat-option *ngFor="let item of ahlocations2" [value]="item.value">
                      {{item.viewValue}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>


            <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
              <label class="space-title importanthighlight">DB 2 Total Picture</label>
              <a *ngIf="data.pics.db2_total" class="upload-image-wrapper"
              href="javascript:void(0)" (click)="openPhotoViewer(data.pics.db2_total)">
              <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
                src="{{data.pics.db2_total || ''}}">
            </a>
              <input (change)="photoTaken($event, 'db2_total')" type="file" accept="image/*,text/plain" id="pictureinput50"
                style="display: none;" />
              <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput50')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button>
              <div [hidden]="!data.pics?.db2_total"><button mat-button color="green"
                  [hidden]="!data.pics?.db2_total" (click)="viewPic('db2_total')">
                  <fa-icon [icon]="facamera"></fa-icon>
                </button></div>

            </div>

            <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
              <label class="space-title importanthighlight">DB 2 Ext Picture</label>
              <a *ngIf="data.pics.db2_ext" class="upload-image-wrapper"
              href="javascript:void(0)" (click)="openPhotoViewer(data.pics.db2_ext)">
              <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
                src="{{data.pics.db2_ext || ''}}">
            </a>
              <input (change)="photoTaken($event, 'db2_ext')" type="file" accept="image/*,text/plain" id="pictureinput51"
                style="display: none;" />
              <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput51')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button>
              <div [hidden]="!data.pics?.db2_ext"><button mat-button color="green" [hidden]="!data.pics?.db2_ext"
                  (click)="viewPic('db2_ext')">
                  <fa-icon [icon]="facamera"></fa-icon>
                </button></div>
            </div>


            <!--<div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
              <mat-label class="formLabel">Baseline Pressure</mat-label>
              <mat-form-field>
                <input matInput formControlName="duct2bspr" (focus)="setInitialValue('duct2bspr')" (blur)="updateSingleField('duct2bspr')" id='duct2bspr'>
              </mat-form-field>
            </div> -->

            <div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
              <mat-label class="formLabel importanthighlight">Ducted Returns</mat-label>
              <mat-form-field>
              <input matInput formControlName="noreturn2" (focus)="setInitialValue('noreturn2')" (blur)="warningCheck(false,2); updateSingleField('noreturn2')" id='noreturn2'>
              </mat-form-field>
            </div>

            <div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
              <mat-label class="formLabel importanthighlight">Total % </mat-label>
              <mat-form-field>
                <input matInput formControlName="hvac2totpcnt" (focus)="setInitialValue('hvac2totpcnt')" (blur)="updateSingleField('hvac2totpcnt')">
              </mat-form-field>
            </div>

            <div  *ngIf="(this.raterform.get('noreturn2').value < 3 && this.raterform.get('hvac2totpcnt').value > 8) || (this.raterform.get('noreturn2').value >= 3 && this.raterform.get('hvac2totpcnt').value > 12) || (this.raterform.get('hvac2extpcnt').value > 4)" style="display: flex; justify-content:center;color :red; padding:10px 0px;">
              <fa-icon [icon]="faExclamationCircle" ></fa-icon>
              <span style="padding-left :10px;" > Warning: The leakage to exterior % or the total % may be too high, meaning this home may fail.  </span>
            </div>

            <div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
              <mat-label class="formLabel">Ext %</mat-label>
              <mat-form-field>
                <input matInput formControlName="hvac2extpcnt" (focus)="setInitialValue('hvac2extpcnt')" (blur)="updateSingleField('hvac2extpcnt')">
              </mat-form-field>
            </div>

            <div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
              <mat-label class="formLabel importanthighlight">DB Total </mat-label>
              <mat-form-field>
                <input matInput formControlName="db2_total" (focus)="setInitialValue('db2_total')" (blur)="warningCheck(false,2);updateSingleField('db2_total')" id='db2_total'
                  (input)="dbtotalCalc(raterform.get('db2_total').value, raterform.get('hvac2_option1_sf').value, raterform.get('hvac2_option2_sf').value, hvac_2_area, 2, true)">
              </mat-form-field>
            </div>

            <div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
              <mat-label class="formLabel importanthighlight">DB Ext</mat-label>
              <mat-form-field>
                <input matInput formControlName="db2_ext" (focus)="setInitialValue('db2_ext')" (blur)="warningCheck(false,2);updateSingleField('db2_ext')" id='db2_ext'
                  (input)="dbextCalc(raterform.get('db2_ext').value, raterform.get('hvac2_option1_sf').value,raterform.get('hvac2_option2_sf').value, hvac_2_area, 2, true)">
              </mat-form-field>
            </div>

            <div style="margin: auto;" class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
              <p style="font-size: 20px;
              height: 40px;
              align-content: center;">Total Sq.Ft: {{totalSF2}}</p>
            <button mat-raised-button color="green" (click)="clearSquareFootage(2)">Reset Optional SF</button>
          </div>


            <div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
              <mat-label class="formLabel">1st Option Sq Ft</mat-label>
              <mat-form-field>
                <input matInput formControlName="hvac2_option1_sf" (focus)="setInitialValue('hvac2_option1_sf')" (blur)="warningCheck(false,2);updateSingleField('hvac2_option1_sf')"
                  id='hvac2_option1_sf'
                  (input)="optionalSFCalc(raterform.get('db2_ext').value, raterform.get('db2_total').value, raterform.get('hvac2_option1_sf').value, raterform.get('hvac2_option2_sf').value, hvac_2_area, 2)">
              </mat-form-field>
            </div>

            <div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
              <mat-label class="formLabel">2nd Option Sq Ft</mat-label>
              <mat-form-field>
                <input matInput formControlName="hvac2_option2_sf" (focus)="setInitialValue('hvac2_option2_sf')" (blur)="warningCheck(false,2);updateSingleField('hvac2_option2_sf')"
                  id='hvac2_option2_sf'
                  (input)="optionalSFCalc(raterform.get('db2_ext').value, raterform.get('db2_total').value, raterform.get('hvac2_option1_sf').value, raterform.get('hvac2_option2_sf').value, hvac_2_area, 2)">
              </mat-form-field>
            </div>

            <div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
              <mat-label class="formLabel">Optional Ceiling Ht</mat-label>
              <mat-form-field>
                <input matInput formControlName="hvac2_optceilheight" (focus)="setInitialValue('hvac2_optceilheight')" (blur)="warningCheck(false,2);updateSingleField('hvac2_optceilheight'); optionalSFHeightWarningCheck();"
                (input)="optionalSFCalc(raterform.get('db2_ext').value, raterform.get('db2_total').value, raterform.get('hvac2_option1_sf').value, raterform.get('hvac2_option2_sf').value, hvac_2_area, 2)"
                id='hvac2_optceilheight'>
              </mat-form-field>
            </div>

            <div class="d-flex flex-wrap row align-items-center">
              <div class="col-lg-3 col-12 px-lg-3 px-3 p-3 d-flex flex-row align-items-center">
                <mat-checkbox formControlName="hvac2_exempt" (change)="updateSingleField('hvac2_exempt')" id="hvac2_exempt"><p style="margin-left: 20px;">Exempt</p></mat-checkbox>
              </div>
              <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
                <mat-label class="formLabel">Exempt Reason</mat-label>
                <mat-form-field>
                  <mat-select matNativeControl formControlName="hvac2_exempt_reason"
                    (blur)="updateSingleField('hvac2_exempt_reason', true)">
                    <mat-option value="All inside conditioned space">All inside conditioned space</mat-option>
                    <mat-option value="Ductless (mini-split)">Ductless (mini-split)</mat-option>
                    <mat-option value="<750sqft (NC ONLY)">&lt;750sqft (NC ONLY)</mat-option>
                    <mat-option value="Other - please describe in system notes below">Other - please describe in system notes below</mat-option>
                    <mat-option value=""></mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class=" col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
              <label class="formLabel">System 2 Notes</label>
                <textarea rows=5 formControlName="sys2notes" (focus)="setInitialValue('sys2notes')"  (blur)="updateSingleField('sys2notes')" id='sys2notes'>
                </textarea>
            </div>

            <p style="margin-top: 20px;
            margin-bottom: 20px;
            font-size: 16px;
            font-weight: 200;
            letter-spacing: 0.1px;
            line-height: 16px;
            text-align: left;">
              <span style="font-weight: bold;">MF DUCT REQ:</span></p>
              <p style="margin-top: 20px;
            margin-bottom: 20px;
            font-size: 16px;
            font-weight: 200;
            letter-spacing: 0.1px;
            line-height: 16px;
            text-align: left;"><span style="font-weight: bold;">6.4.2 Final:</span> Tested per allowances below, with the air handler & all ducts, building cavities used as ducts, duct boots, & register grilles atop the finished surface (e.g., drywall, floor) installed.
              No ducted returns: The greater of ≤ 6 CFM25 per 100 sq. ft. of CFA or ≤ 60 CFM. Additionally, the Rater-measured pressure difference between the space containing the air handler and the conditioned space, with the air handler running at high speed, is ≤ 5 Pa. For systems > 1 ton, increase by 1 Pa per half ton.
              One or two ducted returns: The greater of ≤ 8 CFM25 per 100 sq. ft. of CFA or ≤ 80 CFM.
              Three or more ducted returns: The greater of ≤ 12 CFM25 per 100 sq. ft. of CFA or ≤ 120 CFM.</p>
              <p style="margin-top: 20px;
            margin-bottom: 20px;
            font-size: 16px;
            font-weight: 200;
            letter-spacing: 0.1px;
            line-height: 16px;
            text-align: left;"><span style="font-weight: bold;">6.5 Townhouses only:</span> Rater-measured duct leakage to the outside the greater of ≤ 4 CFM25 per 100 sq. ft. of CFA or ≤ 40 CFM25.
            </p>


          </div>




        </mat-expansion-panel>

        <mat-expansion-panel id="hvac3panel" *ngIf='raterform.get("hvac2name").value.length > 1'>
          <mat-expansion-panel-header class="collapseButton check-list">
            {{raterform.get('hvac3name').value.length > 1 ? raterform.get('hvac3name').value : 'HVAC System 3'}}
          </mat-expansion-panel-header>

          <!-- <h3 style="text-align: center;">{{raterform.get('hvac3name').value.length > 1 ?
            raterform.get('hvac3name').value : 'HVAC System 3'}}</h3> -->

          <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
            <mat-label class="formLabel">Name</mat-label>
            <mat-form-field>
              <input matInput formControlName="hvac3name" (focus)="setInitialValue('hvac3name')" (blur)="updateSingleField('hvac3name');systemnamed(3);" id='hvac3name'>
            </mat-form-field>
          </div>

          <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
            <label class="space-title">Tested At: </label>
            <mat-radio-group style="display:grid;" formControlName="stagedone3" (change)="updateSingleField('stagedone3')" class="mat-radio-grid">
              <mat-radio-button value="Rough-In">Rough-In</mat-radio-button>
              <mat-radio-button value="Final">Final</mat-radio-button>
              <mat-radio-button value="Post Construction">Post Construction</mat-radio-button>
              <mat-radio-button value="Other">Other</mat-radio-button>
            </mat-radio-group>
          </div>

          <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">

            <label class="space-title">Supply Duct Reference Location</label>

            <div class="rf-basic-div">
              <div style="width: 100%"><label class="space-title">Duct Tester Location</label></div>
              <div class="box-border" style="font-size: small;">
                <mat-radio-group formControlName="dcttestloc3" (change)="updateSingleField('dcttestloc3')" class="mat-radio-grid">
                  <mat-radio-button value="Return Closest to Air Handler">Return Closest to Air
                    Handler</mat-radio-button>
                  <mat-radio-button value="Air Handler">Air Handler</mat-radio-button>
                  <mat-radio-button value="Largest Return Grille">Largest Return Grille
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          </div>

          <h4>Duct Location </h4>
          <div class="d-flex flex-wrap row">



            <h3> Location 1: </h3>
            <div class="d-flex flex-column col-lg-6 col-12 px-0">
              <mat-label class="formLabel">Duct Location :</mat-label>
              <mat-form-field>
                <mat-select formControlName="dctlc1sys3"  (blur)="updateSingleField('dctlc1sys3')">
                  <mat-option *ngFor="let item of ductlocations" [value]="item.value">
                    {{item.viewValue}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="d-flex flex-column col-lg-6 col-12 px-3" style="width:100%">
              <mat-label class="formLabel">%: </mat-label>
              <mat-form-field>
                <mat-select formControlName="dctpc1sys3" (blur)="updateSingleField('dctpc1sys3')">
                  <mat-option *ngFor="let item of ductpercentages" [value]="item.value">
                    {{item.viewValue}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>





            <div class="flex-container-external-pressure col-lg-6 col-12 px-3">

              <p style="padding-right: 15px"> Location 2: </p>
              <div class="d-flex flex-column col-lg-6 col-12 px-3" style="width: 100%">
                <mat-label class="formLabel">Duct Location :</mat-label>
                <mat-form-field>
                  <mat-select formControlName="dctlc2sys3" (blur)="updateSingleField('dctlc2sys3')" id='dctlc2sys3'>
                    <mat-option *ngFor="let item of ductlocations" [value]="item.value">
                      {{item.viewValue}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="d-flex flex-column col-lg-6 col-12 px-3" style="width:100%">
                <mat-label class="formLabel">%: </mat-label>
                <mat-form-field>
                  <mat-select formControlName="dctpc2sys3" (blur)="updateSingleField('dctpc2sys3')" id='dctpc2sys3'>
                    <mat-option *ngFor="let item of ductpercentages" [value]="item.value">
                      {{item.viewValue}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>


            </div>

            <div class="flex-container-external-pressure col-lg-6 col-12 px-3">

              <h3> Location 3: </h3>
              <div class="d-flex flex-column col-lg-6 col-12 px-3" style="width: 100%">
                <mat-label class="formLabel">Duct Location :</mat-label>
                <mat-form-field>
                  <mat-select formControlName="dctlc3sys3"  (blur)="updateSingleField('dctlc3sys3')">
                    <mat-option *ngFor="let item of ductlocations" [value]="item.value">
                      {{item.viewValue}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="d-flex flex-column col-lg-6 col-12 px-3" style="width:100%">
                <mat-label class="formLabel">%: </mat-label>
                <mat-form-field>
                  <mat-select formControlName="dctpc3sys3"  (blur)="updateSingleField('dctpc3sys3')">
                    <mat-option *ngFor="let item of ductpercentages" [value]="item.value">
                      {{item.viewValue}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>



            </div>

          </div>
          <h4 class ="importanthighlight">AHU Location </h4>

          <div class="col-lg-6 col-12 px-3">
            <mat-label class="formLabel">Location : </mat-label>
            <mat-form-field>
              <mat-select formControlName="ahulc1sys3" (blur)="updateSingleField('ahulc1sys3')" id='ahulc1sys3'>
                <mat-option *ngFor="let item of ahlocations2" [value]="item.value">
                  {{item.viewValue}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
            <label class="space-titleSupply Duct Reference Location"></label>
            <mat-radio-group formControlName="spldctref3" (change)="updateSingleField('spldctref3')" class="mat-radio-grid">
              <mat-radio-button value="Supply Closest to Air Handler">Supply Closest to Air
                Handler</mat-radio-button>
              <mat-radio-button value="Supply Plenum">Supply Plenum</mat-radio-button>
              <mat-radio-button value="S/R Closest2AirHandler(4+ Ret)">Supply and Return
                Closest to Air Handler (4 or More Returns)</mat-radio-button>

            </mat-radio-group>
          </div>


          <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
            <label class="space-title importanthighlight">DB 3 Total Picture</label>
            <a *ngIf="data.pics.db3_total" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.db3_total)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.db3_total || ''}}">
          </a>
            <input (change)="photoTaken($event, 'db3_total')" type="file" accept="image/*,text/plain" id="pictureinput52"
              style="display: none;" />
            <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput52')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button>
            <div [hidden]="!data.pics?.db3_total"><button mat-button color="green"
                [hidden]="!data.pics?.db3_total" (click)="viewPic('db3_total')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button></div>

          </div>

          <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
            <label class="space-title importanthighlight">DB 3 Ext Picture</label>
            <a *ngIf="data.pics.db3_ext" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.db3_ext)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.db3_ext || ''}}">
          </a>
            <input (change)="photoTaken($event, 'db3_ext')" type="file" accept="image/*,text/plain" id="pictureinput53"
              style="display: none;" />
            <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput53')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button>
            <div [hidden]="!data.pics?.db3_ext"><button mat-button color="green" [hidden]="!data.pics?.db3_ext"
                (click)="viewPic('db3_ext')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button></div>
          </div>


          <!--<div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
            <mat-label class="formLabel">Baseline Pressure</mat-label>
            <mat-form-field>
              <input matInput formControlName="duct3bspr" (focus)="setInitialValue('duct3bspr')" (blur)="updateSingleField('duct3bspr')" id='duct3bspr'>
            </mat-form-field>
          </div> -->


          <div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
            <mat-label class="formLabel importanthighlight">Ducted Returns</mat-label>
            <mat-form-field>
              <input matInput formControlName="noreturn3" (focus)="setInitialValue('noreturn3')" (blur)="updateSingleField('noreturn3')" id='noreturn3'>
            </mat-form-field>
          </div>

          <div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
            <mat-label class="formLabel importanthighlight">Total % </mat-label>
            <mat-form-field>
              <input matInput formControlName="hvac3totpcnt" (focus)="setInitialValue('hvac3totpcnt')" (blur)="updateSingleField('hvac3totpcnt')">
            </mat-form-field>
          </div>

          <div  *ngIf="(this.raterform.get('noreturn3').value < 3 && this.raterform.get('hvac3totpcnt').value > 8) || (this.raterform.get('noreturn3').value >= 3 && this.raterform.get('hvac3totpcnt').value > 12) || (this.raterform.get('hvac3extpcnt').value > 4)" style="display: flex; justify-content:center;color :red; padding:10px 0px;">
            <fa-icon [icon]="faExclamationCircle" ></fa-icon>
            <span style="padding-left :10px;" > Warning: The leakage to exterior % or the total % may be too high, meaning this home may fail.  </span>
          </div>

          <div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
            <mat-label class="formLabel importanthighlight">Ext %</mat-label>
            <mat-form-field>
              <input matInput formControlName="hvac3extpcnt" (focus)="setInitialValue('hvac3extpcnt')" (blur)="updateSingleField('hvac3extpcnt')">
            </mat-form-field>
          </div>




          <div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
            <mat-label class="formLabel importanthighlight">DB Total </mat-label>
            <mat-form-field>
              <input matInput formControlName="db3_total" (focus)="setInitialValue('db3_total')" (blur)="updateSingleField('db3_total')" id='db3_total'
                (input)="dbtotalCalc(raterform.get('db3_total').value, raterform.get('hvac3_option_sf').value, 0, hvac_3_area, 3, true)">
            </mat-form-field>
          </div>

          <div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
            <mat-label class="formLabel importanthighlight">DB Ext</mat-label>
            <mat-form-field>
              <input matInput formControlName="db3_ext" (focus)="setInitialValue('db3_ext')" (blur)="updateSingleField('db3_ext')" id='db3_ext'
                (input)="dbextCalc(raterform.get('db3_ext').value, raterform.get('hvac3_option_sf').value, 0, hvac_3_area, 3, true)">
            </mat-form-field>
          </div>

          <div style="margin: auto;" class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
            <p style="font-size: 20px;
            height: 40px;
            align-content: center;">Total Sq.Ft: {{totalSF3}}</p>
            <button mat-raised-button color="green" (click)="clearSquareFootage(3)">Reset Optional SF</button>

          </div>

          <div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
            <mat-label class="formLabel">1st Option Sq Ft</mat-label>
            <mat-form-field>
              <input matInput formControlName="hvac3_option_sf" (focus)="setInitialValue('hvac3_option_sf')" (blur)="updateSingleField('hvac3_option_sf')"
                id='hvac3_option_sf'
                (input)="optionalSFCalc(raterform.get('db3_ext').value, raterform.get('db3_total').value, raterform.get('hvac3_option_sf').value, 0, hvac_3_area, 3)">
            </mat-form-field>
          </div>

          <!--
          <div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
            <mat-label class="formLabel">2nd Option Sq Ft</mat-label>
            <mat-form-field>
              <input matInput formControlName="hvac3_option2_sf" (focus)="setInitialValue('hvac3_option2_sf')" (blur)="updateSingleField('hvac3_option2_sf')"
                id='hvac3_option2_sf'
                (input)="optionalSFCalc(raterform.get('db3_ext').value, raterform.get('db3_total').value, raterform.get('hvac3_option1_sf').value, raterform.get('hvac3_option2_sf').value, hvac_3_area, 3)">
            </mat-form-field>
          </div>
          -->

          <div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
            <mat-label class="formLabel">Optional Ceiling Ht</mat-label>
            <mat-form-field>
              <input matInput formControlName="hvac3_optceilheight" (focus)="setInitialValue('hvac3_optceilheight')" (blur)="updateSingleField('hvac3_optceilheight'); optionalSFHeightWarningCheck();warningCheck(false,3);"
              (input)="optionalSFCalc(raterform.get('db3_ext').value, raterform.get('db3_total').value, raterform.get('hvac3_option_sf').value, 0, hvac_3_area, 3)"
                id='hvac3_optceilheight'>
            </mat-form-field>
          </div>

          <div class="d-flex flex-wrap row align-items-center">
            <div class="col-lg-3 col-12 px-lg-3 px-3 p-3 d-flex flex-row align-items-center">
              <mat-checkbox formControlName="hvac3_exempt" (change)="updateSingleField('hvac3_exempt')" id="hvac3_exempt"><p style="margin-left: 20px;">Exempt</p></mat-checkbox>
            </div>
            <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
              <mat-label class="formLabel">Exempt Reason</mat-label>
              <mat-form-field>
                <mat-select matNativeControl formControlName="hvac3_exempt_reason"
                  (blur)="updateSingleField('hvac3_exempt_reason', true)">
                  <mat-option value="All inside conditioned space">All inside conditioned space</mat-option>
                  <mat-option value="Ductless (mini-split)">Ductless (mini-split)</mat-option>
                  <mat-option value="<750sqft (NC ONLY)">&lt;750sqft (NC ONLY)</mat-option>
                  <mat-option value="Other - please describe in system notes below">Other - please describe in system notes below</mat-option>
                  <mat-option value=""></mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class=" col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
            <label class="formLabel">System 3 Notes</label>
              <textarea rows=5 formControlName="sys3notes" (focus)="setInitialValue('sys3notes')" (blur)="updateSingleField('sys3notes')"  id='sys3notes'>
              </textarea>
          </div>

          <p style="margin-top: 20px;
          margin-bottom: 20px;
          font-size: 16px;
          font-weight: 200;
          letter-spacing: 0.1px;
          line-height: 16px;
          text-align: left;">
            <span style="font-weight: bold;">MF DUCT REQ:</span></p>
            <p style="margin-top: 20px;
          margin-bottom: 20px;
          font-size: 16px;
          font-weight: 200;
          letter-spacing: 0.1px;
          line-height: 16px;
          text-align: left;"><span style="font-weight: bold;">6.4.2 Final:</span> Tested per allowances below, with the air handler & all ducts, building cavities used as ducts, duct boots, & register grilles atop the finished surface (e.g., drywall, floor) installed.
            No ducted returns: The greater of ≤ 6 CFM25 per 100 sq. ft. of CFA or ≤ 60 CFM. Additionally, the Rater-measured pressure difference between the space containing the air handler and the conditioned space, with the air handler running at high speed, is ≤ 5 Pa. For systems > 1 ton, increase by 1 Pa per half ton.
            One or two ducted returns: The greater of ≤ 8 CFM25 per 100 sq. ft. of CFA or ≤ 80 CFM.
            Three or more ducted returns: The greater of ≤ 12 CFM25 per 100 sq. ft. of CFA or ≤ 120 CFM.</p>
            <p style="margin-top: 20px;
          margin-bottom: 20px;
          font-size: 16px;
          font-weight: 200;
          letter-spacing: 0.1px;
          line-height: 16px;
          text-align: left;"><span style="font-weight: bold;">6.5 Townhouses only:</span> Rater-measured duct leakage to the outside the greater of ≤ 4 CFM25 per 100 sq. ft. of CFA or ≤ 40 CFM25.
          </p>

        </mat-expansion-panel>

        <mat-expansion-panel id="hvac4panel" *ngIf='raterform.get("hvac3name").value.length > 1'>
          <mat-expansion-panel-header class="collapseButton check-list">
            {{raterform.get('hvac4name').value.length > 1 ? raterform.get('hvac4name').value : 'HVAC System 4'}}
          </mat-expansion-panel-header>
          <!--<mat-card style="background:white; color:black;"> -->
            <h3 style="text-align: center;">{{raterform.get('hvac4name').value.length > 1 ?
              raterform.get('hvac4name').value : 'HVAC System 4'}}
            </h3>

            <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
              <mat-label class="formLabel">Name</mat-label>
              <mat-form-field>
                <input matInput formControlName="hvac4name" (focus)="setInitialValue('hvac4name')" (blur)="updateSingleField('hvac4name');systemnamed(4);" id='hvac4name'>
              </mat-form-field>
            </div>

            <div class="col-lg-6 col-12 px-3 pb-3">
              <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
                <div style="width: 100%"><label class="space-title">Tested At: </label></div>
                <div class="box-border" style="font-size: small;">
                  <mat-radio-group formControlName="stagedone4" (change)="updateSingleField('stagedone4')" class="mat-radio-grid">
                    <mat-radio-button value="Rough-In">Rough-In</mat-radio-button>
                    <mat-radio-button value="Final">Final</mat-radio-button>
                    <mat-radio-button value="Post Construction">Post Construction</mat-radio-button>
                    <mat-radio-button value="Other">Other</mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>
            </div>

            <div class="col-lg-6 col-12 px-3 pb-3">
              <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">

                <div class="rf-basic-div">
                  <div style="width: 100%"><label class="space-title">Duct Tester Location</label></div>
                  <div class="box-border" style="font-size: small;">
                    <mat-radio-group formControlName="dcttestloc4" (change)="updateSingleField('dcttestloc4')" class="mat-radio-grid">
                      <mat-radio-button value="Return Closest to Air Handler">Return Closest to Air
                        Handler</mat-radio-button>
                      <mat-radio-button value="Air Handler">Air Handler</mat-radio-button>
                      <mat-radio-button value="Largest Return Grille">Largest Return Grille
                      </mat-radio-button>

                    </mat-radio-group>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
              <label class="space-title">Supply Duct Reference Location</label>
              <mat-radio-group formControlName="spldctref4" (change)="updateSingleField('spldctref4')" class="mat-radio-grid">
                <mat-radio-button value="Supply Closest to Air Handler">Supply Closest to Air
                  Handler</mat-radio-button>
                <mat-radio-button value="Supply Plenum">Supply Plenum</mat-radio-button>
                <mat-radio-button value="S/R Closest2AirHandler(4+ Ret)">Supply and Return
                  Closest to Air Handler (4 or More Returns)</mat-radio-button>

              </mat-radio-group>
            </div>

            <h4>Duct Location </h4>


            <div class="d-flex col-lg-6 col-12 px-0 flex-column">

              <h3> Location 1: </h3>
              <div class="d-flex flex-wrap row">
                <div class="flex-section-external-pressure col-lg-6 col-12 px-3">
                  <mat-label class="formLabel">Duct Location : ,./</mat-label>
                  <mat-form-field>
                    <mat-select formControlName="dctlc1sys4" (blur)="updateSingleField('dctlc1sys4')">
                      <mat-option *ngFor="let item of ductlocations" [value]="item.value">
                        {{item.viewValue}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="flex-section-external-pressure col-lg-6 col-12 px-3">
                  <mat-label class="formLabel">%: </mat-label>
                  <mat-form-field>
                    <mat-select formControlName="dctpc1sys4" (blur)="updateSingleField('dctpc1sys4')">
                      <mat-option *ngFor="let item of ductpercentages" [value]="item.value">
                        {{item.viewValue}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>


            </div>

            <div class="col-lg-6 col-12 px-0">

              <h3> Location 2: </h3>
              <div class="col-lg-6 col-12 px-3">
                <mat-label class="formLabel">Duct Location :</mat-label>
                <mat-form-field>
                  <mat-select formControlName="dctlc2sys4" (blur)="updateSingleField('dctlc2sys4')" id='dctlc2sys4'>
                    <mat-option *ngFor="let item of ductlocations" [value]="item.value">
                      {{item.viewValue}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="d-flex flex-column col-lg-6 col-12 px-3" style="width:100%">
                <mat-label class="formLabel">%: </mat-label>
                <mat-form-field>
                  <mat-select formControlName="dctpc2sys4" (blur)="updateSingleField('dctpc2sys4')" id='dctpc2sys4'>
                    <mat-option *ngFor="let item of ductpercentages" [value]="item.value">
                      {{item.viewValue}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>


            </div>

            <div class="flex-container-external-pressure d-flex flex-column col-lg-6 col-12 px-0">

              <h3> Location 3: </h3>
              <div class="col-lg-6 col-12 px-3">
                <mat-label class="formLabel">Duct Location:</mat-label>
                <mat-form-field>
                  <mat-select formControlName="dctlc4sys4" (blur)="updateSingleField('dctlc4sys4')">
                    <mat-option *ngFor="let item of ductlocations" [value]="item.value">
                      {{item.viewValue}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-lg-6 col-12 px-3">
                <mat-label class="formLabel">%: </mat-label>
                <mat-form-field>
                  <mat-select formControlName="dctpc4sys4"  (blur)="updateSingleField('dctpc4sys4')">
                    <mat-option *ngFor="let item of ductpercentages" [value]="item.value">
                      {{item.viewValue}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>



            </div>

            <h4>AHU Location </h4>
            <div class="flex-container-external-pressure col-lg-6 col-12 px-3">

              <h3> Location 1: </h3>
              <div class="d-flex flex-column col-lg-6 col-12 px-3" style="width: 100%">
                <mat-label class="formLabel">Location : </mat-label>
                <mat-form-field>
                  <mat-select formControlName="ahulc1sys3"  (blur)="updateSingleField('ahulc1sys3')" id='ahulc1sys3'>
                    <mat-option *ngFor="let item of ahlocations2" [value]="item.value">
                      {{item.viewValue}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
              <label class="space-title">DB 4 Total Picture</label>
              <a *ngIf="data.pics.db4_total" class="upload-image-wrapper"
              href="javascript:void(0)" (click)="openPhotoViewer(data.pics.db4_total)">
              <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
                src="{{data.pics.db4_total || ''}}">
            </a>
              <input (change)="photoTaken($event, 'db4_total')" type="file" accept="image/*,text/plain" id="pictureinput54"
                style="display: none;" />
              <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput54')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button>
              <div [hidden]="!data.pics?.db4_total"><button mat-button color="green"
                  [hidden]="!data.pics?.db4_total" (click)="viewPic('db4_total')">
                  <fa-icon [icon]="facamera"></fa-icon>
                </button></div>

            </div>

            <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
              <label class="space-title">DB 4 Ext Picture</label>
              <a *ngIf="data.pics.db4_ext" class="upload-image-wrapper"
              href="javascript:void(0)" (click)="openPhotoViewer(data.pics.db4_ext)">
              <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
                src="{{data.pics.db4_ext || ''}}">
            </a>
              <button mat-button color="grey" id="db4_extpic">
                <input (change)="photoTaken($event, 'db4_ext')" type="file" accept="image/*,text/plain" id="pictureinput55"
                  style="display: none;" />
                <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput55')">
                  <fa-icon [icon]="facamera"></fa-icon>
                </button>
              </button>
              <div [hidden]="!data.pics?.db4_ext"><button mat-button color="green" [hidden]="!data.pics?.db4_ext"
                  (click)="viewPic('db4_ext')">
                  <fa-icon [icon]="facamera"></fa-icon>
                </button></div>

            </div>



            <!--<div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
              <mat-label class="formLabel">Baseline Pressure</mat-label>
              <mat-form-field>
                <input matInput formControlName="duct4bspr" (focus)="setInitialValue('duct4bspr')" (blur)="updateSingleField('duct4bspr')" id='duct4bspr'>
              </mat-form-field>
            </div> -->


            <div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
              <mat-label class="formLabel importanthighlight">Ducted Returns</mat-label>
              <mat-form-field>
                <input matInput formControlName="noreturn4" (focus)="setInitialValue('noreturn4')" (blur)="updateSingleField('noreturn4')" id='noreturn4'>
              </mat-form-field>
            </div>

            <div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
              <mat-label class="formLabel">Total % </mat-label>
              <mat-form-field>
                <input matInput formControlName="hvac4totpcnt" (focus)="setInitialValue('hvac4totpcnt')" (blur)="updateSingleField('hvac4totpcnt')">
              </mat-form-field>
            </div>

            <div  *ngIf="(this.raterform.get('noreturn4').value < 3 && this.raterform.get('hvac4totpcnt').value > 8) || (this.raterform.get('noreturn4').value >= 3 && this.raterform.get('hvac4totpcnt').value > 12) || (this.raterform.get('hvac4extpcnt').value > 4)" style="display: flex; justify-content:center;color :red; padding:10px 0px;">
              <fa-icon [icon]="faExclamationCircle" ></fa-icon>
              <span style="padding-left :10px;" > Warning: The leakage to exterior % or the total % may be too high, meaning this home may fail.  </span>
            </div>

            <div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
              <mat-label class="formLabel">Ext %</mat-label>
              <mat-form-field>
                <input matInput formControlName="hvac4extpcnt" (focus)="setInitialValue('hvac4extpcnt')" (blur)="updateSingleField('hvac4extpcnt')">
              </mat-form-field>
            </div>



            <div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
              <mat-label class="formLabel importanthighlight">DB Total </mat-label>
              <mat-form-field>
                <input matInput formControlName="db4_total" (focus)="setInitialValue('db4_total')" (blur)="updateSingleField('db4_total')" id='db4_total'
                  (input)="dbtotalCalc(raterform.get('db4_total').value, raterform.get('hvac4_option_sf').value, 0, hvac_4_area, 4,true)">
              </mat-form-field>
            </div>

            <div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
              <mat-label class="formLabel importanthighlight">DB Ext</mat-label>
              <mat-form-field>
                <input matInput formControlName="db4_ext" (focus)="setInitialValue('db4_ext')" (blur)="updateSingleField('db4_ext')" id='db4_ext'
                  (input)="dbextCalc(raterform.get('db4_ext').value, raterform.get('hvac4_option_sf').value, 0, hvac_4_area, 4, true)">
              </mat-form-field>
            </div>

            <div style="margin: auto;" class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
              <p style="font-size: 20px;
              height: 40px;
              align-content: center;">Total Sq.Ft: {{totalSF4}}</p>
              <button mat-raised-button color="green" (click)="clearSquareFootage(4)">Reset Optional SF</button>

            </div>

            <div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
              <mat-label class="formLabel importanthighlight">1st Option Sq Ft</mat-label>
              <mat-form-field>
                <input matInput formControlName="hvac4_option1_sf" (focus)="setInitialValue('hvac4_option1_sf')" (blur)="updateSingleField('hvac4_option1_sf')"
                  id='hvac4_option1_sf'
                  (input)="optionalSFCalc(raterform.get('db4_ext').value, raterform.get('db4_total').value, raterform.get('hvac4_option1_sf').value, 0, hvac_4_area, 4)">
              </mat-form-field>
            </div>

            <div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
              <mat-label class="formLabel importanthighlight">2nd Option Sq Ft</mat-label>
              <mat-form-field>
                <input matInput formControlName="hvac4_option2_sf" (focus)="setInitialValue('hvac4_option2_sf')" (blur)="updateSingleField('hvac4_option2_sf')"
                  id='hvac4_option2_sf'
                  (input)="optionalSFCalc(raterform.get('db4_ext').value, raterform.get('db4_total').value, raterform.get('hvac4_option1_sf').value, raterform.get('hvac4_option2_sf').value, hvac_4_area, 4)">
              </mat-form-field>
            </div>

            <!--
            <div class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
              <mat-label class="formLabel importanthighlight">Optional Ceiling Ht</mat-label>
              <mat-form-field>
                <input matInput formControlName="hvac3_optceilheight" (focus)="setInitialValue('hvac3_optceilheight')" (blur)="updateSingleField('hvac3_optceilheight')"
                (input)="optionalSFCalc(raterform.get('db4_ext').value, raterform.get('db4_total').value, raterform.get('hvac4_option1_sf').value, raterform.get('hvac4_option2_sf').value, hvac_4_area, 4)"
                id='hvac3_optceilheight'>
              </mat-form-field>
            </div>
-->

            <div class="d-flex flex-wrap row align-items-center">
              <div class="col-lg-3 col-12 px-lg-3 px-3 p-3 d-flex flex-row align-items-center">
                <mat-checkbox formControlName="hvac4_exempt" (change)="updateSingleField('hvac4_exempt')" id="hvac4_exempt"><p style="margin-left: 20px;">Exempt</p></mat-checkbox>
              </div>
              <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
                <mat-label class="formLabel">Exempt Reason</mat-label>
                <mat-form-field>
                  <mat-select matNativeControl formControlName="hvac4_exempt_reason"
                    (blur)="updateSingleField('hvac4_exempt_reason', true)">
                    <mat-option value="All inside conditioned space">All inside conditioned space</mat-option>
                    <mat-option value="Ductless (mini-split)">Ductless (mini-split)</mat-option>
                    <mat-option value="<750sqft (NC ONLY)">&lt;750sqft (NC ONLY)</mat-option>
                    <mat-option value="Other - please describe in system notes below">Other - please describe in system notes below</mat-option>
                    <mat-option value=""></mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class=" col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
              <label >System 4 Notes</label>
                <textarea rows=5 formControlName="sys4notes" (focus)="setInitialValue('sys4notes')"  (blur)="updateSingleField('sys4notes')" id='sys4notes'>
                </textarea>
            </div>

            <p style="margin-top: 20px;
            margin-bottom: 20px;
            font-size: 16px;
            font-weight: 200;
            letter-spacing: 0.1px;
            line-height: 16px;
            text-align: left;">
              <span style="font-weight: bold;">MF DUCT REQ:</span></p>
              <p style="margin-top: 20px;
            margin-bottom: 20px;
            font-size: 16px;
            font-weight: 200;
            letter-spacing: 0.1px;
            line-height: 16px;
            text-align: left;"><span style="font-weight: bold;">6.4.2 Final:</span> Tested per allowances below, with the air handler & all ducts, building cavities used as ducts, duct boots, & register grilles atop the finished surface (e.g., drywall, floor) installed.
              No ducted returns: The greater of ≤ 6 CFM25 per 100 sq. ft. of CFA or ≤ 60 CFM. Additionally, the Rater-measured pressure difference between the space containing the air handler and the conditioned space, with the air handler running at high speed, is ≤ 5 Pa. For systems > 1 ton, increase by 1 Pa per half ton.
              One or two ducted returns: The greater of ≤ 8 CFM25 per 100 sq. ft. of CFA or ≤ 80 CFM.
              Three or more ducted returns: The greater of ≤ 12 CFM25 per 100 sq. ft. of CFA or ≤ 120 CFM.</p>
              <p style="margin-top: 20px;
            margin-bottom: 20px;
            font-size: 16px;
            font-weight: 200;
            letter-spacing: 0.1px;
            line-height: 16px;
            text-align: left;"><span style="font-weight: bold;">6.5 Townhouses only:</span> Rater-measured duct leakage to the outside the greater of ≤ 4 CFM25 per 100 sq. ft. of CFA or ≤ 40 CFM25.
            </p>
          <!--</mat-card> -->
        </mat-expansion-panel>



        <mat-expansion-panel>

          <mat-expansion-panel-header class="collapseButton check-list">

            <mat-panel-title>
              External Static Pressure
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="d-flex flex-wrap row row">

            <div class="flex-container-external-pressure col-lg-6 col-12 px-3">
              <h3> System 1: </h3>
              <div class="d-flex flex-wrap row">
                <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
                  <mat-label class="formLabel">Return Side: </mat-label>

                  <mat-form-field>
                    <input matInput formControlName="rsesp1" (focus)="setInitialValue('rsesp1')" (click)="setInitialValue('rsesp1')" (blur)="updateSingleField('rsesp1')" id='rsesp1'>
                  </mat-form-field>
                </div>
                <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
                  <mat-label class="formLabel">Supply Side: </mat-label>
                  <mat-form-field>
                    <input matInput formControlName="ssesp1" (focus)="setInitialValue('ssesp1')" (blur)="updateSingleField('ssesp1')" id='ssesp1'>
                  </mat-form-field>
                </div>
              </div>
            </div>


            <div class="flex-container-external-pressure col-lg-6 col-12 px-3">

              <h3>System 2: </h3>
              <div class="d-flex flex-wrap row">
                <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
                  <mat-label class="formLabel">Return Side: </mat-label>
                  <mat-form-field>
                    <input matInput formControlName="rsesp2" (focus)="setInitialValue('rsesp2')" (blur)="updateSingleField('rsesp2')" id='rsesp2'>
                  </mat-form-field>
                </div>
                <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
                  <mat-label class="formLabel">Supply Side: </mat-label>

                  <mat-form-field>
                    <input matInput formControlName="ssesp2" (focus)="setInitialValue('ssesp2')" (blur)="updateSingleField('ssesp2')" id='ssesp2'>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="flex-container-external-pressure col-lg-6 col-12 px-3">

              <h3> System 3: </h3>
              <div class="d-flex flex-wrap row">
                <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
                  <mat-label class="formLabel">Return Side: </mat-label>

                  <mat-form-field>
                    <input matInput formControlName="rsesp3" (focus)="setInitialValue('rsesp3')" (blur)="updateSingleField('rsesp3')" id='rsesp3'>
                  </mat-form-field>
                </div>
                <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
                  <mat-label class="formLabel">Supply Side: </mat-label>

                  <mat-form-field>
                    <input matInput formControlName="ssesp3" (focus)="setInitialValue('ssesp3')" (blur)="updateSingleField('ssesp3')" id='ssesp3'>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="flex-container-external-pressure col-lg-6 col-12 px-3">

              <h3>System 4: </h3>
              <div class="d-flex flex-wrap row">
                <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
                  <mat-label class="formLabel">Return Side: </mat-label>

                  <mat-form-field>
                    <input matInput formControlName="rsesp4" (focus)="setInitialValue('rsesp4')" (blur)="updateSingleField('rsesp4')" id='rsesp4'>
                  </mat-form-field>
                </div>



                <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
                  <mat-label class="formLabel">Supply Side: </mat-label>

                  <mat-form-field>
                    <input matInput formControlName="ssesp4" (focus)="setInitialValue('ssesp4')" (blur)="updateSingleField('ssesp4')" id='ssesp4'>
                  </mat-form-field>
                </div>
              </div>
            </div>


            <!-- </div> -->

          </div>




        </mat-expansion-panel>


        <mat-expansion-panel>

          <mat-expansion-panel-header class="collapseButton check-list">
              
              <mat-panel-title>
                CAZ Testing 
              </mat-panel-title>


          </mat-expansion-panel-header>

          <div class="d-flex flex-wrap row row">

            <div class="flex-container-external-pressure col-lg-6 col-12 px-3">
              <div class="d-flex flex-wrap row">
                <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
                  <mat-label class="formLabel">CAZ 1: </mat-label>

                  <mat-form-field appearance="outline">
                    <input matInput formControlName="caz1" placeholder="Enter Zone Name" (focus)="setInitialValue('caz1')" (click)="setInitialValue('caz1')" (blur)="updateSingleField('caz1')" id='caz1'>
                  </mat-form-field>
                </div>

              </div>

                <label class="mb-auto">CAZ 1 Picture</label>
                <a *ngIf="data.pics.caz1" class="upload-image-wrapper"
                href="javascript:void(0)" (click)="openPhotoViewer(data.pics.caz1)">
                <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
                  src="{{data.pics.caz1 || ''}}">
              </a>
                <input (change)="photoTaken($event, 'caz1')" type="file" accept="image/*,text/plain" id="pictureinput84"
                  style="display: none;" />
                <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput84')">
                  <fa-icon [icon]="facamera"></fa-icon>
                </button>
  
                <div [hidden]="!data.pics?.caz1"><button mat-button color="green"
                    [hidden]="!data.pics?.caz1" (click)="viewPic('caz1')">
                    <fa-icon [icon]="facamera"></fa-icon>
                  </button></div>
  
            </div>



            <div class="flex-container-external-pressure col-lg-6 col-12 px-3">
              <div class="d-flex flex-wrap row">
                <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
                  <mat-label class="formLabel">CAZ 2: </mat-label>

                  <mat-form-field appearance="outline">
                    <input matInput placeholder="Enter Zone Name" formControlName="caz2" (focus)="setInitialValue('caz2')" (click)="setInitialValue('caz2')" (blur)="updateSingleField('caz2')" id='caz2'>
                  </mat-form-field>
                </div>

              </div>

              <label class="mb-auto">CAZ 2 Picture</label>
              <a *ngIf="data.pics.caz2" class="upload-image-wrapper"
              href="javascript:void(0)" (click)="openPhotoViewer(data.pics.caz2)">
              <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
                src="{{data.pics.caz2 || ''}}">
            </a>
              <input (change)="photoTaken($event, 'caz2')" type="file" accept="image/*,text/plain" id="pictureinput85"
                style="display: none;" />
              <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput85')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button>

              <div [hidden]="!data.pics?.caz2"><button mat-button color="green"
                  [hidden]="!data.pics?.caz2" (click)="viewPic('caz2')">
                  <fa-icon [icon]="facamera"></fa-icon>
                </button></div>

            </div>

          </div>

          </mat-expansion-panel>

        <hr />

        <div class="d-flex flex-column col-lg-6 col-12 px-3 pb-3">

              <div class="flex-section-external-pressure">
                <mat-label class="formLabel">Envelope Pressure Testing Result</mat-label>
                <mat-form-field>
                  <input matInput formControlName="condcrawlpt" (focus)="setInitialValue('condcrawlpt')" (blur)="updateSingleField('condcrawlpt');updateBDFactors('previousOutdoor');"
                    id='condcrawlpt'>
                </mat-form-field>
              </div>

        </div>

          <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
            <label class="mb-auto">Envelope Pressure Testing Result Photo</label>
            <a *ngIf="data.pics.condcrawlpt" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.condcrawlpt)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.condcrawlpt || ''}}">
          </a>
            <input (change)="photoTaken($event, 'condcrawlpt')" type="file" accept="image/*,text/plain" id="pictureinput92"
              style="display: none;" />
            <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput92')" onclick="this.value = null" >
              <fa-icon [icon]="facamera"></fa-icon>
            </button>
            <div [hidden]="!data.pics?.condcrawlpt"><button mat-button color="green" [hidden]="!data.pics?.condcrawlpt"
                (click)="viewPic('condcrawlpt')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button></div>
          </div>


        <div class="d-flex flex-column col-lg-6 col-12 px-3 pb-3">

          <label class="space-title"> Pressure Zone Tested
          </label>
          <mat-form-field>
            <mat-select matNativeControl formControlName="pztested"  (blur)="updateSingleField('pztested', true)"
              id='pztested'>
              <mat-option value='Conditioned Crawl'>Conditioned Crawl</mat-option>
              <mat-option value='Sealed Attic'>Sealed Attic</mat-option>
              <mat-option value='Basement'>Basement</mat-option>
              <mat-option value='Mechanical Closet'>Mechanical Closet</mat-option>
              <mat-option value='Other'>Other</mat-option>
              <mat-option value=''></mat-option>
            </mat-select>
          </mat-form-field>
        </div>


        <div class="d-flex flex-column col-lg-6 col-12 px-3 pb-3">

          <label class="space-title">Pressure Test Type</label>
          <mat-form-field>
            <mat-select matNativeControl formControlName="pztesttype"  (blur)="updateSingleField('pztesttype', true)"
              id='pztesttype'>
              <mat-option value='Pressure Difference'>Pressure Difference</mat-option> 
              <mat-option value='Pressure Reading'>Pressure Reading</mat-option>
              <mat-option value=''></mat-option>
            </mat-select>
          </mat-form-field>
        </div>


        <div class="d-flex flex-column col-lg-6 col-12 px-3 pb-3">
          <label class="space-title">
            Whole House Mechanical Ventilation Strategy

              <a [attr.href]="baseURL + '/rhAPI/raterform/rf_info/ventilationOptions'" title="More info" target="_blank" style="color: black;
              margin-left: 1em;">
                <fa-icon title="Info" [icon]="fainfo"></fa-icon>
              </a>

          </label>
          <mat-form-field>
            <mat-select matNativeControl formControlName="mechanical_ventilation"
              (blur)="updateSingleField('mechanical_ventilation', true)" id='mechanical_ventilation'>
              <mat-option value = "N/A">N/A</mat-option>
              <mat-option value='Air Cycler + Booster Fan without AHU Fan'>Air Cycler + Booster Fan without AHU Fan</mat-option>
              <mat-option value='Air Cycler + Booster Fan w/ AHU Fan'>Air Cycler + Booster Fan w/ AHU Fan</mat-option>
              <mat-option value = "Air Cycler">Air Cycler</mat-option>
              <mat-option value = "Balanced (supply + exhaust)">Balanced (supply + exhaust)</mat-option>
              <mat-option value = "ERV">ERV </mat-option>
              <mat-option value = "Exhaust (continuous)">Exhaust (continuous w/override)</mat-option>
              <mat-option value = "Exhaust (smart switch)">Exhaust (smart switch)</mat-option>
              <mat-option value = "HRV">HRV</mat-option>
              <mat-option value = "Supply">Supply</mat-option>
              <mat-option value = "Air Cycler + Booster Fan" disabled>Air Cycler + Booster Fan</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="d-flex flex-column col-lg-6 col-12 px-3 pb-3">

          <label class="space-title">Ventilation Model
          </label>
          <mat-form-field>
            <mat-select matNativeControl formControlName="vent_brand"  (blur)="updateSingleField('vent_brand', true)"
              id='vent_brand' (selectionChange)="ventBrandChanged(raterform.get('vent_brand').value)">
              <mat-option value='12'>Aprilaire E070</mat-option>
              <mat-option value='13'>Aprilaire E080</mat-option>
              <mat-option value='14'>Aprilaire E100</mat-option>
              <mat-option value='15'>Aprilaire 8100 (V22BEC)</mat-option>
              <mat-option value='2'>Aprilaire 8140</mat-option>
              <mat-option value='10'>Aprilaire 8145</mat-option>
              <mat-option value='4'>Broan ERV70</mat-option>
              <mat-option value='6'>Honeywell VNT2200</mat-option>
              <mat-option value='8'>Lennox ERV5-130</mat-option>
              <mat-option value='9'>Lennox ERV5-150</mat-option>
              <mat-option value='5'>Lennox ERV3-150 (discont'd)</mat-option>
              <mat-option value='3'>Lennox ERV3-200 (discont'd)</mat-option>
              <mat-option value='1'>Panasonic FV-20NLF1 </mat-option>
              <mat-option value='11'>QFAM QFRESH</mat-option>
              <mat-option value='7'>Other</mat-option>
              <mat-option value=""></mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Bedrooms sits above the runtime readout on purpose: the count has to be verified
             before the rater sets the controller, and it feeds the ASHRAE target below. -->
        <div class="note-wrapper my-3">
          <div class="col-lg-6 col-12 px-3">
            <mat-label class="formLabel">Bedrooms (from plan): </mat-label>
            <div class="d-flex align-items-center">
              <h4 style="margin-bottom: 0;">{{ bedrooms }}</h4>
              <!-- type="button" is required: this sits inside the raterform <form>, so a bare button submits it -->
              <button mat-icon-button type="button" color="primary" style="margin-left: 4px;"
                aria-label="What counts as a bedroom?" matTooltip="What counts as a bedroom?"
                (click)="openBedroomInfo()">
                <mat-icon>info</mat-icon>
              </button>
            </div>
          </div>

          <div class="col-lg-6 col-12 px-3">
            <mat-label class="formLabel">Bedroom count verification: </mat-label>
            <mat-form-field>
              <!-- Stored values are unchanged ('Incorrect' keeps its meaning); only the labels
                   carry the "override" wording, so no data migration was needed.
                   selectionChange recomputes the runtime the moment the option is picked;
                   blur is what persists (recalcAshrae writes nothing). -->
              <mat-select formControlName="bedroom_verify" id='bedroom_verify'
                (focus)="setInitialValue('bedroom_verify')" (selectionChange)="recalcAshrae()"
                (blur)="onBedroomVerifyChange()">
                <mat-option value=""></mat-option>
                <mat-option value="Verified">Verified</mat-option>
                <mat-option value="Incorrect">Incorrect, override</mat-option>
                <mat-option value="Unsure">Unsure, potential override</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-lg-6 col-12 px-3" *ngIf="bedroomOverrideActive()">
            <mat-label class="formLabel">Corrected bedroom count: </mat-label>
            <mat-form-field>
              <input matInput type="number" min="0" step="1" formControlName="bedroom_override"
                id="bedroom_override" placeholder="Enter the correct number of bedrooms"
                (focus)="setInitialValue('bedroom_override')" (blur)="onBedroomOverrideBlur()">
            </mat-form-field>
          </div>

          <!-- Deliberately not gated on bedroomOverrideActive(): once an override is recorded the
               original count stays on screen even if the rater switches back to Verified. -->
          <div *ngIf="bedroomOverrideValue() !== null && bedroomOriginalValue() !== null"
            style="background-color: #fafafa; border: 1px solid #d0d0d0; color: #4f4f4f; padding: 0.5em 0.75em; margin: 0.5em 0.75em; border-radius: 4px;">
            Bedroom override, original bedroom count {{ bedroomOriginalValue() }}
          </div>

          <p *ngIf="bedroomOverrideActive()" style="color: red;">The bedroom count affects the
            ventilation runtime listed below. Enter the corrected count here and the runtime will
            recalculate</p>
        </div>

        <div class="vent-runtime-callout my-3">
          <mat-label class="formLabel">Minimum controller runtime setting: </mat-label>
          <h4 style="margin-bottom: 0;">{{ ventRuntimeDisplay() }}</h4>

          <div class="d-flex flex-wrap" *ngIf="ventRuntimeDisplay()">
            <div style="margin-right: 2.5em;">
              <mat-label>Percentage of an hour: </mat-label>
              <h4 style="margin-bottom: 0;">{{ ventRuntimePercentDisplay() }}</h4>
            </div>
            <div>
              <mat-label>Hours per day: </mat-label>
              <h4 style="margin-bottom: 0;">{{ ventRuntimeHoursPerDayDisplay() }}</h4>
            </div>
          </div>

          <mat-label class="d-block mt-2">ASHRAE 62.2 whole house required ventilation in CFM
            operating continuously: {{ ashrae }}</mat-label>
          <mat-label class="d-block mt-2" *ngIf="ventRuntimeDisplay()">
            Result:
            <strong [style.color]="ventRuntimePasses() ? '#2e7d32' : '#c62828'">
              {{ ventRuntimePasses() ? 'Pass' : 'Fail' }}
            </strong>
            <span *ngIf="!ventRuntimePasses()" style="color: #c62828;">
              (required runtime exceeds 100% of the hour)
            </span>
          </mat-label>
        </div>

        <!-- Mirrors the bedroom verify/override above, minus the runtime hooks: nothing computes
             off this count, so it sits below the controller readout rather than above it. -->
        <div class="note-wrapper my-3">
          <div class="col-lg-6 col-12 px-3">
            <mat-label class="formLabel">Bathrooms (from plan): </mat-label>
            <h4 style="margin-bottom: 0;">{{ bathrooms }}</h4>
          </div>

          <!--
          <div class="col-lg-6 col-12 px-3">
            <mat-label class="formLabel">Bathroom count verification: </mat-label>
            <mat-form-field>
              <mat-select formControlName="bathroom_verify" id='bathroom_verify'
                (focus)="setInitialValue('bathroom_verify')" (blur)="updateSingleField('bathroom_verify')">
                <mat-option value=""></mat-option>
                <mat-option value="Verified">Verified</mat-option>
                <mat-option value="Incorrect">Incorrect, override</mat-option>
                <mat-option value="Unsure">Unsure, potential override</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        -->

          <div class="col-lg-6 col-12 px-3" *ngIf="bathroomOverrideActive()">
            <mat-label class="formLabel">Corrected bathroom count: </mat-label>
            <mat-form-field>
              <input matInput type="number" min="0" step="0.5" formControlName="bathroom_override"
                id="bathroom_override" placeholder="Enter the correct number of bathrooms"
                (focus)="setInitialValue('bathroom_override')" (blur)="onBathroomOverrideBlur()">
            </mat-form-field>
          </div>

          <div *ngIf="bathroomOverrideValue() !== null && bathroomOriginalValue() !== null"
            style="background-color: #fafafa; border: 1px solid #d0d0d0; color: #4f4f4f; padding: 0.5em 0.75em; margin: 0.5em 0.75em; border-radius: 4px;">
            Bathroom override, original bathroom count {{ bathroomOriginalValue() }}
          </div>
        </div>

        <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
          <label class="mb-auto">Ventilation Controller</label>
          <!-- Multi-photo gallery for vent_ctrl -->
          <div class="photo-gallery" *ngIf="ventCtrlPhotos && ventCtrlPhotos.length > 0">
            <div *ngFor="let photoUrl of ventCtrlPhotos; let i = index" class="photo-thumbnail-wrapper" style="display: inline-block; margin: 5px;">
              <a href="javascript:void(0)" (click)="openPhotoViewer(photoUrl)">
                <img loading='lazy' class="photo-thumbnail" [src]="photoUrl" alt="Ventilation controller photo {{i + 1}}"
                  style="max-width: 150px; max-height: 150px; width: auto; height: auto;">
              </a>
              <button style="background-color: red; color: white; border: 0; border-radius: 9px; width: 4em; display: block; margin-top: 5px;"
                (click)="openDeleteModalVentCtrl(photoUrl)" title="Delete Photo">
                <mat-icon style="font-family: 'Roboto';">X</mat-icon>
              </button>
            </div>
          </div>
          <p *ngIf="!ventCtrlPhotos || ventCtrlPhotos.length === 0">No photos uploaded yet.</p>

          <input (change)="photoTaken($event, 'vent_ctrl')" type="file" accept="image/*,text/plain" id="pictureinput95"
            style="display: none;" />
          <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput95')">
            <fa-icon [icon]="facamera"></fa-icon>
          </button>
        </div>

        <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
          <label class="mb-auto">Ventilation Model Photo</label>
          <a *ngIf="data.pics.ven_mn" class="upload-image-wrapper"
          href="javascript:void(0)" (click)="openPhotoViewer(data.pics.ven_mn)">
          <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
            src="{{data.pics.ven_mn || ''}}">
        </a>
          <input (change)="photoTaken($event, 'ven_mn')" type="file" accept="image/*,text/plain" id="pictureinput57"
            style="display: none;" />
          <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput57')" onclick="this.value = null" >
            <fa-icon [icon]="facamera"></fa-icon>
          </button>
          <div [hidden]="!data.pics?.ven_mn"><button mat-button color="green" [hidden]="!data.pics?.ven_mn"
              (click)="viewPic('ven_mn')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button></div>
        </div>

        <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
          <label class="mb-auto">Total House Ventilation Pic</label>
          <a *ngIf="data.pics.vent_rate_total" class="upload-image-wrapper"
          href="javascript:void(0)" (click)="openPhotoViewer(data.pics.vent_rate_total)">
          <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
            src="{{data.pics.vent_rate_total || ''}}">
        </a>
          <input (change)="photoTaken($event, 'vent_rate_total')" type="file" accept="image/*,text/plain" id="pictureinput58"
            style="display: none;" />
          <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput58')"  onclick="this.value = null">
            <fa-icon [icon]="facamera"></fa-icon>
          </button>
          <div [hidden]="!data.pics?.vent_rate_total"><button mat-button color="green"
              [hidden]="!data.pics?.vent_rate_total" (click)="viewPic('vent_rate_total')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button></div>
        </div>

        <div>
                        <div class="col-lg-6 col-12 px-3">
                          <mat-label class="formLabel">If applicable, which distribution system is the ventilation connected to?
                            (You must assign duct systems prior to this step)</mat-label>
                          <mat-form-field>
                            <mat-select formControlName="vent_tied_to" (blur)="updateSingleField('vent_tied_to')">
                              <mat-option *ngFor="let sys of labeledSystems" [value]="sys">
                                {{sys}}
                              </mat-option>
                              <mat-option value="None">None</mat-option>  
                            </mat-select>
                          </mat-form-field>
                        </div>
        </div>

        <div class="flex-section-external-pressure col-lg-3 col-12 px-3">
          <mat-label class="formLabel">Pascal Reading </mat-label>
          <mat-form-field>
            <input matInput formControlName="numpa" min="0" (focus)="setInitialValue('numpa')" (blur)="updateSingleField('numpa')" id='numpa'
              (change)="cfmCalculation(raterform.get('vent_brand').value)">
          </mat-form-field>
        </div>

        <div class="flex-section-external-pressure col-lg-3 col-12 px-3">
          <mat-label class="formLabel importanthighlight">Total House Ventilation CFM <small><span style="font-size: 14px;">(Operating Continuously)</span></small></mat-label>
          <mat-form-field>
            <input matInput formControlName="vent_rate_total" (focus)="setInitialValue('vent_rate_total')" #ventRate [ngClass]="ventRateClass()" (blur)="updateSingleField('vent_rate_total')"
              id='vent_rate_total'>
          </mat-form-field>

          <mat-checkbox formControlName="manualentry" (change)="updateSingleField('manualentry')" id='manualentry'><p style="margin-left: 20px;">Manual Entry</p>
          </mat-checkbox>
        </div>
        <p *ngIf="ventRate.value < ashrae" style="color: red;">The Total House CFM is less than what is required by ASHRAE 62.2 </p>








      </div>
      <!--Testing 1-->
      <!--TESTING 2 -->
      <div class="tab-content" id="item3" [hidden]="selectedItem != 3">

        <div style="justify-content: center;
        display: flex;
        align-items: center;
        text-align-last: left;">
          <div *ngIf="showStickerPlacementInfo || showStickerLocation" class="d-flex flex-wrap row row" style="margin-top: 20px;
          margin-bottom: 20px;
          width: 95%;">
            <!-- Not .collapseButton: ngOnInit wires a click toggle onto every .collapseButton
                 and this section must always render expanded. -->
            <h3 class="staticHeader"><span>Sticker Placement Info</span></h3>
            <div class="content content-static" style="text-align: left">
              <pre *ngIf="showStickerPlacementInfo" style="white-space:pre-wrap">{{stickerPlacementInfo}}</pre>
              <div *ngIf="showStickerLocation">
                <p *ngIf="showStickerPlacementInfo" style="font-weight: 700; margin: 8px 0 0 0;">Subdivision:</p>
                <pre style="white-space:pre-wrap">{{stickerLocation}}</pre>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
          <label class="space-title">Code Sticker</label>
          <a *ngIf="data.pics.codesticker" class="upload-image-wrapper"
          href="javascript:void(0)" (click)="openPhotoViewer(data.pics.codesticker)">
          <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
            src="{{data.pics.codesticker || ''}}">
        </a>
          <input (change)="photoTaken($event, 'codesticker')" type="file" accept="image/*,text/plain" id="pictureinput60"
            style="display: none;" />
          <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput60')" onclick="this.value = null" >
            <span>
              <fa-icon [icon]="facamera"></fa-icon>
            </span>
          </button>
          <span [hidden]="!data.pics?.codesticker"><button mat-button color="green"
              [hidden]="!data.pics?.codesticker" (click)="viewPic('codesticker')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button></span>
        </div>

        <!-- Sticker Tab: R401.9 Energy Efficiency Certificate -->
        <h3>R401.9 Energy Efficiency Certificate</h3>

        <div style="border: 2px solid #333; padding: 20px; max-width: 800px; margin: 0 auto; font-family: Calibri, sans-serif;">

          <!-- Property Address -->
          <div style="margin-bottom: 20px; border-bottom: 1px solid #ccc; padding-bottom: 10px;">
            <h4 style="margin: 0 0 5px 0;">Property Address</h4>
            <p style="font-size: 16px; margin: 0;">{{street_address}}</p>
          </div>

          <!-- Insulation Section -->
          <div style="margin-bottom: 20px; border-bottom: 1px solid #ccc; padding-bottom: 10px;">
            <h4 style="margin: 0 0 10px 0;">Insulation</h4>
            <div class="d-flex flex-wrap">
              <div style="width: 50%; padding: 5px 10px;">
                <span style="font-weight: bold;">Ceiling/Roof:</span> {{raterform.get('foamceilings').value ? raterform.get('vaulted_ceilings').value : raterform.get('flat_ceilings').value}}
              </div>
              <div style="width: 50%; padding: 5px 10px;">
                <span style="font-weight: bold;">Wall:</span> {{raterform.get('agw').value}}
              </div>
              <div style="width: 50%; padding: 5px 10px;">
                <span style="font-weight: bold;">Floor:</span> {{getStickerFloorValue()}}
              </div>
              <div style="width: 50%; padding: 5px 10px;">
                <span style="font-weight: bold;">Closed Crawl Space Wall:</span> {{raterform.get('crawlwall').value}}
              </div>
              <div style="width: 50%; padding: 5px 10px;">
                <span style="font-weight: bold;">Slab:</span> {{raterform.get('fdn_r').value}}
              </div>
              <div style="width: 50%; padding: 5px 10px;">
                <span style="font-weight: bold;">Basement Wall:</span> ---
              </div>
            </div>
          </div>

          <!-- Fenestration Section -->
          <div style="margin-bottom: 20px; border-bottom: 1px solid #ccc; padding-bottom: 10px;">
            <h4 style="margin: 0 0 10px 0;">Fenestration</h4>
            <div class="d-flex flex-wrap">
              <div style="width: 50%; padding: 5px 10px;">
                <span style="font-weight: bold;">U Factor:</span> {{raterform.get('window_u').value}}
              </div>
              <div style="width: 50%; padding: 5px 10px;">
                <span style="font-weight: bold;">SHGC:</span> {{raterform.get('window_shgc').value}}
              </div>
            </div>
          </div>

          <!-- Building Air Leakage Section -->
          <div style="margin-bottom: 20px; border-bottom: 1px solid #ccc; padding-bottom: 10px;">
            <h4 style="margin: 0 0 10px 0;">Building Air Leakage</h4>
            <div class="d-flex flex-wrap">
              <div style="width: 50%; padding: 5px 10px;">
                <span style="font-weight: bold;">ACH50:</span> {{raterform.get('ach50').value}}
              </div>
            </div>
          </div>

          <!-- Ducts Section -->
          <div style="margin-bottom: 10px;">
            <h4 style="margin: 0 0 10px 0;">Ducts</h4>
            <div *ngIf="raterform.get('hvac1name').value.length > 1" style="padding: 5px 10px; margin-bottom: 5px;">
              <span style="font-weight: bold;">{{raterform.get('hvac1name').value}}:</span>
              Total {{raterform.get('hvac1totpcnt').value}}% | Ext {{raterform.get('hvac1extpcnt').value}}%
            </div>
            <div *ngIf="raterform.get('hvac2name').value.length > 1" style="padding: 5px 10px; margin-bottom: 5px;">
              <span style="font-weight: bold;">{{raterform.get('hvac2name').value}}:</span>
              Total {{raterform.get('hvac2totpcnt').value}}% | Ext {{raterform.get('hvac2extpcnt').value}}%
            </div>
            <div *ngIf="raterform.get('hvac3name').value.length > 1" style="padding: 5px 10px; margin-bottom: 5px;">
              <span style="font-weight: bold;">{{raterform.get('hvac3name').value}}:</span>
              Total {{raterform.get('hvac3totpcnt').value}}% | Ext {{raterform.get('hvac3extpcnt').value}}%
            </div>
            <div *ngIf="raterform.get('hvac4name').value.length > 1" style="padding: 5px 10px; margin-bottom: 5px;">
              <span style="font-weight: bold;">{{raterform.get('hvac4name').value}}:</span>
              Total {{raterform.get('hvac4totpcnt').value}}% | Ext {{raterform.get('hvac4extpcnt').value}}%
            </div>
          </div>

        </div>

        <!-- Original Special tab content preserved below -->
        <!--
        <h3>Special</h3>

        <div class="d-flex flex-wrap row">
          <div class="col-lg-6 col-12 px-3">
            <label class="space-title">Exterior Wall Sheathing Radiant Barrier</label>
            <mat-radio-group class="d-flex" formControlName="extallsheath" (change)="updateSingleField('extallsheath')"
              id='extallsheath' class="mat-radio-grid">
              <mat-radio-button value="Yes">Yes</mat-radio-button>
              <mat-radio-button value="No">No</mat-radio-button>
            </mat-radio-group>
          </div>

          <div class="col-lg-6 col-12 px-3 d-flex flex-column" style="margin-top:25px;">
            <mat-checkbox formControlName="codetector" (change)="updateSingleField('codetector')" id='codetector'><p style="margin-left: 20px;">Co Detector</p>
            </mat-checkbox>
          </div>

          <div class="flex-section-external-pressure col-lg-6 col-12 px-3">
            <mat-label>LED%</mat-label>
            <mat-form-field>
              <input matInput formControlName="ledpercnt" (focus)="setInitialValue('ledpercnt')" (blur)="updateSingleField('ledpercnt')" id='ledpercnt'>
            </mat-form-field>
          </div>

          <div class="clearfix"></div>
          <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
            <label class="space-title">Wifi Thermostat</label>

            <input (change)="photoTaken($event, 'wifitherm')" type="file" accept="image/*,text/plain" id="pictureinput62"
              style="display: none;" />
            <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput62')">
              <span>
                <fa-icon [icon]="facamera"></fa-icon>
              </span>
            </button>
            <span [hidden]="!data.pics?.wifitherm"><button mat-button color="green"
                [hidden]="!data.pics?.wifitherm" (click)="viewPic('wifitherm')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button></span>

          </div>


          <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
            <label class="space-title">Code Sticker</label>
            <input (change)="photoTaken($event, 'codesticker')" type="file" accept="image/*,text/plain" id="pictureinput60"
              style="display: none;" />
            <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput60')">
              <span>
                <fa-icon [icon]="facamera"></fa-icon>
              </span>
            </button>
            <span [hidden]="!data.pics?.codesticker"><button mat-button color="green"
                [hidden]="!data.pics?.codesticker" (click)="viewPic('codesticker')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button></span>

          </div>

          <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
            <label class="mb-auto">Code Permit or Unit Number</label>
            <a *ngIf="data.pics.codepermit" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.codepermit)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.codepermit || ''}}">
          </a>
            <input (change)="photoTaken($event, 'codepermit')" type="file" accept="image/*,text/plain" id="pictureinput61"
              style="display: none;" />
            <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput61')">
              <span>
                <fa-icon [icon]="facamera"></fa-icon>
              </span>
            </button>
            <span [hidden]="!data.pics?.codepermit"><button mat-button color="green"
                [hidden]="!data.pics?.codepermit" (click)="viewPic('codepermit')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button></span>

          </div>

          <div class="col-lg-6 col-12 px-3">
            <mat-label>Comments</mat-label>
            <textarea rows=6 style="width: 95%" formControlName="specialnotes" (focus)="setInitialValue('specialnotes')"
              (blur)="updateSingleField('specialnotes')" id='specialnotes'>

        </textarea>
          </div>
        </div>
        -->
      </div>

      <div class="tab-content" id="item4" [hidden]="selectedItem != 4">
        <h3>Final</h3>

        <div class="row">
          <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
            <label class="mb-0 importanthighlight">Veneer Type (75% coverage)</label>
            <a *ngIf="data.pics.veneertype" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.veneertype)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.veneertype || ''}}">
          </a>
            <input (change)="photoTaken($event, 'veneertype')" type="file" accept="image/*,text/plain" id="pictureinput2"
              style="display: none;" />
            <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput2')">
              <span>
                <fa-icon [icon]="facamera"></fa-icon>
              </span>
            </button>
            <div [hidden]="!data.pics?.veneertype"><button mat-button color="green"
                [hidden]="!data.pics?.veneertype" (click)="viewPic('veneertype')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button></div>
          </div>
        </div>


        <h4 class="importanthighlight">Light Counts: </h4>



        <div class="d-flex flex-wrap row">

          <div class="col-lg-6 col-12 px-3 pb-3">
            <table>
              <tr>
                <th width="100">Location</th>
                <th>Tier I</th>
                <th>Tier II</th>
                <th>Non-Qualifying</th>
              </tr>
              <tr>
                <td> Inside</td>
                <td><input class="table-input" type="text" size="3" (change)="recalculateLightPct()"
                    formControlName="insidet1" (focus)="setInitialValue('insidet1')" (blur)="updateSingleField('insidet1')" id='insidet1'> </td>
                <td><input type="text" size="3" (change)="recalculateLightPct()" formControlName="insidet2" (focus)="setInitialValue('insidet2')"
                    (blur)="updateSingleField('insidet2')" id='insidet2'></td>
                <td><input type="text" size="3" (change)="recalculateLightPct()" formControlName="insidenq" (focus)="setInitialValue('insidenq')"
                    (blur)="updateSingleField('insidenq')" id='insidenq'></td>
              </tr>
              <tr>
                <td>Outside</td>
                <td><input class="table-input" type="text" size="3" (change)="recalculateLightPct()"
                    formControlName="outsidet1" (focus)="setInitialValue('outsidet1')" (blur)="updateSingleField('outsidet1')" id='outsidet1'> </td>
                <td><input type="text" size="3" (change)="recalculateLightPct()" formControlName="outsidet2" (focus)="setInitialValue('outsidet2')"
                    (blur)="updateSingleField('outsidet2')" id='outsidet2'></td>
                <td><input type="text" size="3" (change)="recalculateLightPct()" formControlName="outsidenq" (focus)="setInitialValue('outsidenq')"
                    (blur)="updateSingleField('outsidenq')" id='outsidenq'></td>
              </tr>
              <tr>
                <td>Garage</td>
                <td><input type="text" size="3" (change)="recalculateLightPct()" formControlName="garaget1" (focus)="setInitialValue('garaget1')"
                    (blur)="updateSingleField('garaget1')" id='garaget1'> </td>
                <td><input type="text" size="3" (change)="recalculateLightPct()" formControlName="garaget2" (focus)="setInitialValue('garaget2')"
                    (blur)="updateSingleField('garaget2')" id='garaget2'></td>
                <td><input type="text" size="3" (change)="recalculateLightPct()" formControlName="garagenq" (focus)="setInitialValue('garagenq')"
                    (blur)="updateSingleField('garagenq')" id='garagenq'></td>
              </tr>
              <tr>
                <th></th>
                <th>Percent Tier I</th>
                <th>Percent Tier II</th>
              </tr>
              <tr>
                <th>Inside</th>
                <td><input type="text" size="3" maxlength="4" formControlName="insidet1pct" (focus)="setInitialValue('insidet1pct')"
                    (blur)="updateSingleField('insidet1pct')"></td>
                <td><input type="text" size="3" maxlength="4" maxlength="4" formControlName="insidet2pct" (focus)="setInitialValue('insidet2pct')"
                    (blur)="updateSingleField('insidet2pct')" id='insidet2pct'></td>
              </tr>
              <tr>
                <th>Outside</th>
                <td><input type="text" size="3" maxlength="4" formControlName="outsidet1pct" (focus)="setInitialValue('outsidet1pct')"
                    (blur)="updateSingleField('outsidet1pct')" id='outsidet1pct'></td>
                <td><input type="text" size="3" maxlength="4" formControlName="outsidet2pct" (focus)="setInitialValue('outsidet2pct')"
                    (blur)="updateSingleField('outsidet2pct')" id='outsidet2pct'></td>
              </tr>
              <tr>
              <tr>
                <th>Garage</th>
                <td><input type="text" size="3" maxlength="4" formControlName="garaget1pct" (focus)="setInitialValue('garaget1pct')"
                    (blur)="updateSingleField('garaget1pct')" id='garaget1pct'></td>
                <td><input type="text" size="3" maxlength="4" formControlName="garaget2pct" (focus)="setInitialValue('garaget2pct')"
                    (blur)="updateSingleField('garaget2pct')" id='garaget2pct'></td>
              </tr>
              <tr>
                <td>Whole House % High Efficacy</td>
                <td>
                <td><input type="text" size="3" maxlength="4" formControlName="whpcteff" (focus)="setInitialValue('whpcteff')"
                    (blur)="updateSingleField('whpcteff')" id='whpcteff'></td>
              </tr>
            </table>
          </div>


          <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start" id="majlightyp-div">
            <label class="space-title">Majority Lighting Type (Photo)</label>
            <a *ngIf="data.pics.majlightyp" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.majlightyp)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.majlightyp || ''}}">
          </a>
            <input (change)="photoTaken($event, 'majlightyp')" type="file" accept="image/*,text/plain" id="pictureinput67"
              style="display: none;" />
            <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput67')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button>
            <div [hidden]="!data.pics?.majlightyp"><button mat-button color="green" [hidden]="!data.pics?.majlightyp"
                (click)="viewPic('majlightyp')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button></div>

          </div>


          <div class="clearfix"></div>

          <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
            <div class="flex-section-external-pressure col-12">
              <mat-label class="formLabel">Refrigeration Model #
              </mat-label>
              <a *ngIf="data.pics.refrigerator_mn" class="upload-image-wrapper"
              href="javascript:void(0)" (click)="openPhotoViewer(data.pics.refrigerator_mn)">
              <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
                src="{{data.pics.refrigerator_mn || ''}}">
            </a>
              <mat-form-field>
                <input matInput formControlName="refrigerator_mn" (focus)="setInitialValue('refrigerator_mn')" (blur)="updateSingleField('refrigerator_mn')"
                  id='refrigerator_mn'>
              </mat-form-field>
            </div>

            <input (change)="photoTaken($event, 'refrigerator_mn')" type="file" accept="image/*,text/plain" id="pictureinput44"
            style="display: none;" />
          <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput44')">
            <fa-icon [icon]="facamera"></fa-icon>
          </button>
          <div [hidden]="!data.pics?.refrigerator_mn"><button mat-button color="green"
              [hidden]="!data.pics?.refrigerator_mn" (click)="viewPic('refrigerator_mn')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button></div>

          </div>


          <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">


            <div class="flex-section-external-pressure col-12">
              <mat-label class="formLabel">Dishwasher Model #
              </mat-label>
              <a *ngIf="data.pics.dishwasher_mn" class="upload-image-wrapper"
              href="javascript:void(0)" (click)="openPhotoViewer(data.pics.dishwasher_mn)">
              <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
                src="{{data.pics.dishwasher_mn || ''}}">
            </a>
              <mat-form-field>
                <input style="padding-bottom: 10px; padding-top: 10px;" matInput formControlName="dishwasher_mn" (focus)="setInitialValue('dishwasher_mn')"
                  (blur)="updateSingleField('dishwasher_mn')" id='dishwasher_mn'>
              </mat-form-field>
            </div>

            <input (change)="photoTaken($event, 'dishwasher_mn')" type="file" accept="image/*,text/plain" id="pictureinput45"
              style="display: none;" />
            <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput45')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button>
            <div [hidden]="!data.pics?.dishwasher_mn"><button mat-button color="green"
                [hidden]="!data.pics?.dishwasher_mn" (click)="viewPic('dishwasher_mn')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button></div>

          </div>

          <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">

            <div class="flex-section-external-pressure col-12">
              <mat-label class="formLabel">Dryer Model #
              </mat-label>
              <a *ngIf="data.pics.dryer_mn" class="upload-image-wrapper"
              href="javascript:void(0)" (click)="openPhotoViewer(data.pics.dryer_mn)">
              <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
                src="{{data.pics.dryer_mn || ''}}">
            </a>
              <mat-form-field>
                <input style="padding-bottom: 10px; padding-top: 10px;" matInput formControlName="dryer_mn" (focus)="setInitialValue('dryer_mn')"
                  (blur)="updateSingleField('dryer_mn')" id='dryer_mn'>
              </mat-form-field>
            </div>

            <input (change)="photoTaken($event, 'dryer_mn')" type="file" accept="image/*,text/plain" id="pictureinput46"
            style="display: none;" />
          <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput46')">
            <fa-icon [icon]="facamera"></fa-icon>
          </button>
          <div [hidden]="!data.pics?.dryer_mn"><button mat-button color="green" [hidden]="!data.pics?.dryer_mn"
              (click)="viewPic('dryer_mn')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button></div>

          </div>

          <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">

            <div class="flex-section-external-pressure col-12">
              <mat-label class="formLabel">Washer Model #
              </mat-label>
              <a *ngIf="data.pics.washer_mn" class="upload-image-wrapper"
              href="javascript:void(0)" (click)="openPhotoViewer(data.pics.washer_mn)">
              <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
                src="{{data.pics.washer_mn || ''}}">
            </a>
              <mat-form-field>
                <input style="padding-bottom: 10px; padding-top: 10px;" matInput formControlName="washer_mn" (focus)="setInitialValue('washer_mn')"
                  (blur)="updateSingleField('washer_mn')" id='washer_mn'>
              </mat-form-field>
            </div>

            <input (change)="photoTaken($event, 'washer_mn')" type="file" accept="image/*,text/plain" id="pictureinput47"
            style="display: none;" />
          <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput47')">
            <fa-icon [icon]="facamera"></fa-icon>
          </button>
          <div [hidden]="!data.pics?.washer_mn"><button mat-button color="green"
              [hidden]="!data.pics?.washer_mn" (click)="viewPic('washer_mn')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button></div>

          </div>

          <!--
          <div class="flex-section-external-pressure col-lg-6 col-12 px-3 mb-2">
            <mat-label class="formLabel">Older Washer/Dryer #</mat-label>
            <mat-form-field>
              <input matInput formControlName="washerdryermodnum" (focus)="setInitialValue('washerdryermodnum')" (blur)="updateSingleField('washerdryermodnum')"
                id='washerdryermodnum'>
            </mat-form-field>
          </div>
-->

          <div class="col-lg-6 col-12 px-3">
            <mat-label class="formLabel">Clothes Dryer Fuel</mat-label>
            <mat-form-field>
              <mat-select formControlName="close_dryer_fuel"
                (blur)="updateSingleField('close_dryer_fuel')" id='close_dryer_fuel'>
                <mat-option value="Natural Gas">Natural Gas</mat-option>
                <mat-option value="Propane">Propane</mat-option>
                <mat-option value="Fuel Oil">Fuel Oil</mat-option>
                <mat-option value="Electric">Electric</mat-option>
                <mat-option value="Kerosene">Kerosene</mat-option>
                <mat-option value="Wood">Wood</mat-option>
                <mat-option value=""></mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-lg-6 col-12 px-3 mb-2">
            <label class="space-title">Range Fuel Type</label>
            <mat-form-field>
              <mat-select matNativeControl formControlName="rangefueltype" (blur)="updateSingleField('rangefueltype')"
                id='rangefueltype'>
                <mat-option value="Natural Gas">Natural Gas</mat-option>
                <mat-option value="Propane">Propane</mat-option>
                <mat-option value="Fuel Oil">Fuel Oil</mat-option>
                <mat-option value="Electric">Electric</mat-option>
                <mat-option value="Kerosene">Kerosene</mat-option>
                <mat-option value="Wood">Wood</mat-option>
                <mat-option value=""></mat-option>
              </mat-select>
            </mat-form-field>
          </div>




          <div class="clearfix"></div>
          <div class="flex-section-external-pressure col-lg-6 col-12 px-3" style="margin-top:50px;">
            <mat-checkbox formControlName="conv_oven"  (change)="updateSingleField('conv_oven')" id='conv_oven'> <p style="margin-left:20px;">Convection Oven</p>
            </mat-checkbox>
          </div>

          <div class="flex-section-external-pressure col-lg-6 col-12 px-3" style="margin-top:50px;">
            <mat-checkbox formControlName="ind_range"  (change)="updateSingleField('ind_range')" id='ind_range'><p style="margin-left:20px;">Induction Range</p>
            </mat-checkbox>
          </div>

          <div
            class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start mt-3 flex-section-external-pressure">
            <mat-label class="mb-auto">Number of Ceiling Fans</mat-label>
            <mat-form-field>
              <input matInput formControlName="es_ceiling_fans" (focus)="setInitialValue('es_ceiling_fans')" (blur)="updateSingleField('es_ceiling_fans')"
                id='es_ceiling_fans'>
            </mat-form-field>

            <label class="formLabel mt-3">Pic of each model number</label>

            <!-- Multi-photo gallery for es_ceiling_fans -->
            <div class="photo-gallery" *ngIf="esCeilingFansPhotos && esCeilingFansPhotos.length > 0">
              <div *ngFor="let photoUrl of esCeilingFansPhotos; let i = index" class="photo-thumbnail-wrapper" style="display: inline-block; margin: 5px;">
                <a href="javascript:void(0)" (click)="openPhotoViewer(photoUrl)">
                  <img loading='lazy' class="photo-thumbnail" [src]="photoUrl" alt="Ceiling fan photo {{i + 1}}"
                    style="max-width: 150px; max-height: 150px; width: auto; height: auto;">
                </a>
                <button style="background-color: red; color: white; border: 0; border-radius: 9px; width: 4em; display: block; margin-top: 5px;"
                  (click)="openDeleteModalEsCeilingFans(photoUrl)" title="Delete Photo">
                  <mat-icon style="font-family: 'Roboto';">X</mat-icon>
                </button>
              </div>
            </div>
            <p *ngIf="!esCeilingFansPhotos || esCeilingFansPhotos.length === 0">No photos uploaded yet.</p>

            <input (change)="photoTaken($event, 'es_ceiling_fans')" type="file" accept="image/*,text/plain" id="pictureinput3"
              style="display: none;" />
            <button class="my-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput3')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button>

          </div>
        </div>

        <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">

          <div class="flex-section-external-pressure col-12">
            <mat-label class="formLabel">Dehumidifier Model #/Notes
            </mat-label>
            <a *ngIf="data.pics.dehumidmod" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.dehumidmod)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.dehumidmod || ''}}">
          </a>
            <mat-form-field>
              <input style="padding-bottom: 10px; padding-top: 10px;" matInput formControlName="dehumidmod" (focus)="setInitialValue('dehumidmod')"
                (blur)="updateSingleField('dehumidmod')" id='dehumidmod'>
            </mat-form-field>
          </div>

          <input (change)="photoTaken($event, 'dehumidmod')" type="file" accept="image/*,text/plain" id="pictureinput63"
          style="display: none;" />
        <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput63')">
          <fa-icon [icon]="facamera"></fa-icon>
        </button>
        <div [hidden]="!data.pics?.dehumidmod"><button mat-button color="green" [hidden]="!data.pics?.dehumidmod"
            (click)="viewPic('dehumidmod')">
            <fa-icon [icon]="facamera"></fa-icon>
          </button></div>


        </div>


        <h3>HVAC Systems</h3>
        <hr>

        <div>
          <h3>System 1: {{raterform.get('hvac1name').value}} </h3>

          <!--
          <div style="padding-right: 20px">
            <mat-label> Programmable Thermostat? </mat-label>
            <mat-checkbox formControlName="programstat1" (focus)="setInitialValue('programstat1')" (blur)="updateSingleField('programstat1')" id='programstat1'>
            </mat-checkbox>
          </div>
-->

          <div class="col-lg-6 col-12 px-3 pb-3">
            <label class="space-title">Thermostat Type
            </label>

            <a *ngIf="data.pics.tstattype1" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.tstattype1)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.tstattype1 || ''}}">
            </a>


            <mat-form-field>
              <mat-select matNativeControl formControlName="tstattype1"
                (blur)="updateSingleField('tstattype1',true)">
                <mat-option value="Non-Programmable">Non-Programmable</mat-option>
                <mat-option value="Programmable (Non-wifi)">Programmable (Non-wifi)</mat-option>
                <mat-option value="Smart Wifi">Smart Wifi</mat-option>
                <mat-option value=""></mat-option>
              </mat-select>
            </mat-form-field>

            <input (change)="photoTaken($event, 'tstattype1')" type="file" accept="image/*,text/plain" id="pictureinput72"
            style="display: none;" />
            <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput72')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button>
            <div [hidden]="!data.pics?.tstattype1"><button mat-button color="green" [hidden]="!data.pics?.tstattype1"
              (click)="viewPic('tstattype1')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button></div>


          </div>

          <div class="col-lg-6 col-12 px-3 pb-3">
            <mat-label class="formLabel">Thermostat Count</mat-label>
            <mat-form-field>
              <input matInput type="number" formControlName="tstatcount" (focus)="setInitialValue('tstatcount')" (blur)="updateSingleField('tstatcount')" id="tstatcount">
            </mat-form-field>
          </div>

          <div class="d-flex flex-wrap row">
            <div class="col-lg-6 col-12 px-3 pb-3" id="heat1fuel-div">
              <mat-label>Heat Fuel
              </mat-label>
              <mat-form-field>
                <mat-select matNativeControl formControlName="heat1fuel"
                  (blur)="updateSingleField('heat1fuel', true)">
                  <mat-option value="NG">NG</mat-option>
                  <mat-option value="LP">LP</mat-option>
                  <mat-option value="Elct">Elct</mat-option>
                  <mat-option value="Solar">Solar</mat-option>
                  <mat-option value="Dual">Dual</mat-option>
                  <mat-option value=""></mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-lg-6 col-12 px-3 pb-3" id="hvac_1_mfr-div">
              <label class="space-title"
                style="width: 98%;font-size: 15px;position: relative;left: -11px;text-align: center;">Heat
                Manufacturer
              </label>
              <div>
                <mat-form-field>
                  <mat-select matNativeControl formControlName="hvac_1_mfr"
                    (blur)="updateSingleField('hvac_1_mfr', true)">
                    <mat-option value="Amana/Goodman">Amana/Goodman</mat-option>
                    <mat-option value="Carrier/Bryant">Carrier/Bryant</mat-option>
                    <mat-option value="Comfortmaker">Comfortmaker</mat-option>
                    <mat-option value="Lennox">Lennox</mat-option>
                    <mat-option value="Mitsubishi">Mitsubishi</mat-option>
                    <mat-option value="Rheem/Rudd">Rheem/Rudd</mat-option>
                    <mat-option value="Trane/American Standard">Trane/American Standard</mat-option>
                    <mat-option value="Other">Other</mat-option>
                    <mat-option value=""></mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>




            <div class="clearfix"></div>

            <div
              class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start flex-section-external-pressure">
              <label class="mb-auto importanthighlight">C Coil Model #</label>
              <a *ngIf="data.pics.c_coil_1_mn" class="upload-image-wrapper"
              href="javascript:void(0)" (click)="openPhotoViewer(data.pics.c_coil_1_mn)">
              <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
                src="{{data.pics.c_coil_1_mn || ''}}">
            </a>
            <mat-form-field>
              <input matInput formControlName="c_coil_1_mn" (focus)="setInitialValue('c_coil_1_mn')" (blur)="updateSingleField('c_coil_1_mn', true)">
            </mat-form-field>
              <input (change)="photoTaken($event, 'c_coil_1_mn')" type="file" accept="image/*,text/plain" id="pictureinput5"
                style="display: none;" />
              <button class="my-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput5')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button>
              <div [hidden]="!data.pics?.c_coil_1_mn"><button mat-button color="green"
                  [hidden]="!data.pics?.c_coil_1_mn" (click)="viewPic('c_coil_1_mn')">
                  <fa-icon [icon]="facamera"></fa-icon>
                </button></div>

            </div>


            <div
              class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start flex-section-external-pressure"
              id="e_coil_1_mn-div">
              <label class="mb-auto importanthighlight">E Coil Model #</label>
              <a *ngIf="data.pics.e_coil_1_mn" class="upload-image-wrapper"
              href="javascript:void(0)" (click)="openPhotoViewer(data.pics.e_coil_1_mn)">
              <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
                src="{{data.pics.e_coil_1_mn || ''}}">
            </a>
            <mat-form-field>
              <input matInput formControlName="e_coil_1_mn" (focus)="setInitialValue('e_coil_1_mn')" (blur)="updateSingleField('e_coil_1_mn', true)">
            </mat-form-field>
              <input (change)="photoTaken($event, 'e_coil_1_mn')" type="file" accept="image/*,text/plain" id="pictureinput4"
                style="display: none;" />
              <button class="my-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput4')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button>
              <!-- <div [hidden]="!data.pics?.e_coil_1_mn"><button mat-button color="green"
                  [hidden]="!data.pics?.e_coil_1_mn" (click)="viewPic('e_coil_1_mn')">
                  <fa-icon [icon]="facamera"></fa-icon>
                </button></div> -->

            </div>


            <div
              class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start flex-section-external-pressure">
              <label class="mb-auto importanthighlight" style="width:98%">Furnace or HP Aux. Model</label>
              <a *ngIf="data.pics.ahu_furn_1_mn" class="upload-image-wrapper"
              href="javascript:void(0)" (click)="openPhotoViewer(data.pics.ahu_furn_1_mn)">
              <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
                src="{{data.pics.ahu_furn_1_mn || ''}}">
            </a>
            <mat-form-field>
              <input matInput formControlName="ahu_furn_1_mn" (focus)="setInitialValue('ahu_furn_1_mn')" (blur)="updateSingleField('ahu_furn_1_mn', true)">
            </mat-form-field>
              <input (change)="photoTaken($event, 'ahu_furn_1_mn')" type="file" accept="image/*,text/plain" id="pictureinput6"
                style="display: none;" />
              <button class="my-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput6')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button>
              <!-- <div [hidden]="!data.pics?.ahu_furn_1_mn"><button mat-button color="green"
                  [hidden]="!data.pics?.ahu_furn_1_mn" (click)="viewPic('ahu_furn_1_mn')">
                  <fa-icon [icon]="facamera"></fa-icon>
                </button></div> -->

            </div>

            <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start" id="txv-div">

              <label class="space-title">TXV
              </label>
              <a *ngIf="data.pics.txv1" class="upload-image-wrapper"
              href="javascript:void(0)" (click)="openPhotoViewer(data.pics.txv1)">
              <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
                src="{{data.pics.txv1 || ''}}">
            </a>
              <div class="box-border">
                <mat-form-field>
                  <mat-select matNativeControl formControlName="txv" (blur)="updateSingleField('txv', true)">
                    <mat-option value="Yes">Yes</mat-option>
                    <mat-option value="No">No</mat-option>
                    <mat-option value=""></mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <input (change)="photoTaken($event, 'txv1')" type="file" accept="image/*,text/plain" id="pictureinput64"
              style="display: none;" />
              <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput64')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button>
              <div [hidden]="!data.pics?.txv1"><button mat-button color="green" [hidden]="!data.pics?.txv1"
                  (click)="viewPic('txv1')">
                  <fa-icon [icon]="facamera"></fa-icon>
                </button></div>

            </div>

          </div>
        </div>



        <div *ngIf='raterform.get("hvac2name").value.length > 1'>
          <h4>System 2: {{raterform.get('hvac2name').value}}</h4>

          <!--
          <div style="padding-right: 20px">
            <mat-label> Programmable Thermostat? </mat-label>
            <mat-checkbox formControlName="programstat2" (focus)="setInitialValue('programstat2')" (blur)="updateSingleField('programstat2')" id='programstat2'>
            </mat-checkbox>
          </div>
-->

          <div class="col-lg-6 col-12 px-3 pb-3">
            <label class="space-title">Thermostat Type
            </label>

            <a *ngIf="data.pics.tstattype2" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.tstattype2)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.tstattype2 || ''}}">
            </a>

            <mat-form-field>
              <mat-select matNativeControl formControlName="tstattype2"
                (blur)="updateSingleField('tstattype2',true)">
                <mat-option value="Non-Programmable">Non-Programmable</mat-option>
                <mat-option value="Programmable (Non-wifi)">Programmable (Non-wifi)</mat-option>
                <mat-option value="Smart Wifi">Smart Wifi</mat-option>
                <mat-option value=""></mat-option>
              </mat-select>
            </mat-form-field>

            <input (change)="photoTaken($event, 'tstattype2')" type="file" accept="image/*,text/plain" id="pictureinput83"
            style="display: none;" />
            <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput83')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button>
            <div [hidden]="!data.pics?.tstattype2"><button mat-button color="green" [hidden]="!data.pics?.tstattype2"
              (click)="viewPic('tstattype2')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button></div>


          </div>

          <div class="col-lg-6 col-12 px-3 pb-3">
            <mat-label class="formLabel">Thermostat Count</mat-label>
            <mat-form-field>
              <input matInput type="number" formControlName="tstatcount2" (focus)="setInitialValue('tstatcount2')" (blur)="updateSingleField('tstatcount2')" id="tstatcount2">
            </mat-form-field>
          </div>


          <div class="d-flex flex-wrap row">

            <div class="col-lg-6 col-12 px-3 pb-3" id="heat2fuel-div">
              <mat-label>Heat Fuel
              </mat-label>
              <mat-form-field>
                <mat-select matNativeControl formControlName="heat2fuel"
                  (blur)="updateSingleField('heat2fuel', true)">
                  <mat-option value="NG">NG</mat-option>
                  <mat-option value="LP">LP</mat-option>
                  <mat-option value="Elct">Elct</mat-option>
                  <mat-option value="Solar">Solar</mat-option>
                  <mat-option value="Dual">Dual</mat-option>
                  <mat-option value=""></mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-lg-6 col-12 px-3 pb-3" id="hvac_2_mfr-div">
              <label>Heat Manufacturer</label>
              <mat-form-field>
                <mat-select matNativeControl formControlName="hvac_2_mfr"
                  (blur)="updateSingleField('hvac_2_mfr', true)">
                  <mat-option value="Amana/Goodman">Amana/Goodman</mat-option>
                  <mat-option value="Carrier/Bryant">Carrier/Bryant</mat-option>
                  <mat-option value="Comfortmaker">Comfortmaker</mat-option>
                  <mat-option value="Lennox">Lennox</mat-option>
                  <mat-option value="Mitsubishi">Mitsubishi</mat-option>
                  <mat-option value="Rheem/Rudd">Rheem/Rudd</mat-option>
                  <mat-option value="Trane/American Standard">Trane/American Standard</mat-option>
                  <mat-option value="Other">Other</mat-option>
                  <mat-option value=""></mat-option>
                </mat-select>
              </mat-form-field>
            </div>




            <div
            class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start flex-section-external-pressure">
            <label class="mb-auto importanthighlight">C Coil Model #</label>
            <a *ngIf="data.pics.c_coil_2_mn" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.c_coil_2_mn)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.c_coil_2_mn || ''}}">
          </a>
            <input (change)="photoTaken($event, 'c_coil_2_mn')" type="file" accept="image/*,text/plain" id="pictureinput8"
              style="display: none;" />
            <button class="my-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput8')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button>
            <div [hidden]="!data.pics?.c_coil_2_mn"><button mat-button color="green"
                [hidden]="!data.pics?.c_coil_2_mn" (click)="viewPic('c_coil_2_mn')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button></div>
            <mat-form-field>
              <input matInput formControlName="c_coil_2_mn" (focus)="setInitialValue('c_coil_2_mn')" (blur)="updateSingleField('c_coil_2_mn', true)">
            </mat-form-field>
          </div>


            <div
              class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start flex-section-external-pressure">
              <label class="mb-auto importanthighlight">E Coil Model #</label>
              <a *ngIf="data.pics.e_coil_2_mn" class="upload-image-wrapper"
              href="javascript:void(0)" (click)="openPhotoViewer(data.pics.e_coil_2_mn)">
              <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
                src="{{data.pics.e_coil_2_mn || ''}}">
            </a>
              <button mat-button color="grey" id="ecol2">
                <input (change)="photoTaken($event, 'e_coil_2_mn')" type="file" accept="image/*,text/plain" id="pictureinput7"
                  style="display: none;" />
                <button class="my-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput7')">
                  <fa-icon [icon]="facamera"></fa-icon>
                </button>
                <div [hidden]="!data.pics?.e_coil_2_mn"><button mat-button color="green"
                    [hidden]="!data.pics?.e_coil_2_mn" (click)="viewPic('e_coil_2_mn')">
                    <fa-icon [icon]="facamera"></fa-icon>
                  </button></div>
              </button>
              <mat-form-field>
                <input matInput formControlName="e_coil_2_mn" (focus)="setInitialValue('e_coil_2_mn')" (blur)="updateSingleField('e_coil_2_mn', true)">
              </mat-form-field>
            </div>


            <div
              class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start flex-section-external-pressure">
              <label class="space-title importanthighlight">Furnace or HP Aux. Model</label>
              <a *ngIf="data.pics.ahu_furn_2_mn" class="upload-image-wrapper"
              href="javascript:void(0)" (click)="openPhotoViewer(data.pics.ahu_furn_2_mn)">
              <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
                src="{{data.pics.ahu_furn_2_mn || ''}}">
            </a>
              <input (change)="photoTaken($event, 'ahu_furn_2_mn')" type="file" accept="image/*,text/plain" id="pictureinput9"
                style="display: none;" />
              <button class="my-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput9')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button>
              <div [hidden]="!data.pics?.ahu_furn_2_mn"><button mat-button color="green"
                  [hidden]="!data.pics?.ahu_furn_2_mn" (click)="viewPic('ahu_furn_2_mn')">
                  <fa-icon [icon]="facamera"></fa-icon>
                </button></div>
              <mat-form-field>
                <input matInput formControlName="ahu_furn_2_mn" (focus)="setInitialValue('ahu_furn_2_mn')" (blur)="updateSingleField('ahu_furn_2_mn', true)">
              </mat-form-field>
            </div>

            <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start" id="txv2-div">

              <input (change)="photoTaken($event, 'txv2')" type="file" accept="image/*,text/plain" id="pictureinput65"
              style="display: none;" />
            <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput65')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button>
            <div [hidden]="!data.pics?.txv2"><button mat-button color="green" [hidden]="!data.pics?.txv2"
                (click)="viewPic('txv2')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button></div>

              <label class="space-title">TXV
              </label>
              <a *ngIf="data.pics.txv2" class="upload-image-wrapper"
              href="javascript:void(0)" (click)="openPhotoViewer(data.pics.txv2)">
              <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
                src="{{data.pics.txv2 || ''}}">
            </a>
              <div class="box-border">
                <mat-form-field>
                  <mat-select matNativeControl formControlName="txv2"  (blur)="updateSingleField('txv2', true)">
                    <mat-option value="Yes">Yes</mat-option>
                    <mat-option value="No">No</mat-option>
                    <mat-option value=""></mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>




          </div>
        </div>

        <div *ngIf='raterform.get("hvac3name").value.length > 1'>
          <h4>System 3: {{raterform.get('hvac3name').value}}</h4>

          <!--
          <div style="padding-right: 20px">
            <mat-label> Programmable Thermostat? </mat-label>
            <mat-checkbox formControlName="programstat3" (focus)="setInitialValue('programstat3')" (blur)="updateSingleField('programstat3')" id='programstat3'>
            </mat-checkbox>
          </div>
          -->
          <div class="col-lg-6 col-12 px-3 pb-3">
            <label class="space-title">Thermostat Type
            </label>

            <a *ngIf="data.pics.tstattype3" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.tstattype3)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.tstattype3 || ''}}">
            </a>

            <mat-form-field>
              <mat-select matNativeControl formControlName="tstattype3"
                (blur)="updateSingleField('tstattype3',true)">
                <mat-option value="Non-Programmable">Non-Programmable</mat-option>
                <mat-option value="Programmable (Non-wifi)">Programmable (Non-wifi)</mat-option>
                <mat-option value="Smart Wifi">Smart Wifi</mat-option>
                <mat-option value=""></mat-option>
              </mat-select>
            </mat-form-field>

            <input (change)="photoTaken($event, 'tstattype3')" type="file" accept="image/*,text/plain" id="pictureinput79"
            style="display: none;" />
            <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput79')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button>
            <div [hidden]="!data.pics?.tstattype3"><button mat-button color="green" [hidden]="!data.pics?.tstattype3"
              (click)="viewPic('tstattype3')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button></div>

          </div>

          <div class="col-lg-6 col-12 px-3 pb-3">
            <mat-label class="formLabel">Thermostat Count</mat-label>
            <mat-form-field>
              <input matInput type="number" formControlName="tstatcount3" (focus)="setInitialValue('tstatcount3')" (blur)="updateSingleField('tstatcount3')" id="tstatcount3">
            </mat-form-field>
          </div>


          <div class="d-flex flex-wrap row">
            <div class="col-lg-6 col-12 px-3 pb-3" id="heat3fuel-div">
              <mat-label>Heat Fuel
              </mat-label>
              <mat-form-field>
                <mat-select matNativeControl formControlName="heat3fuel"  (blur)="updateSingleField('heat3fuel')">
                  <mat-option value="NG">NG</mat-option>
                  <mat-option value="LP">LP</mat-option>
                  <mat-option value="Elct">Elct</mat-option>
                  <mat-option value="Solar">Solar</mat-option>
                  <mat-option value="Dual">Dual</mat-option>
                  <mat-option value=""></mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-lg-6 col-12 px-3 pb-3" id="hvac_3_mfr-div">
              <label>Heat Manufacturer</label>
              <mat-form-field>
                <mat-select matNativeControl formControlName="hvac_3_mfr"
                  (blur)="updateSingleField('hvac_3_mfr', true)">
                  <mat-option value="Amana/Goodman">Amana/Goodman</mat-option>
                  <mat-option value="Carrier/Bryant">Carrier/Bryant</mat-option>
                  <mat-option value="Comfortmaker">Comfortmaker</mat-option>
                  <mat-option value="Lennox">Lennox</mat-option>
                  <mat-option value="Mitsubishi">Mitsubishi</mat-option>
                  <mat-option value="Rheem/Rudd">Rheem/Rudd</mat-option>
                  <mat-option value="Trane/American Standard">Trane/American Standard</mat-option>
                  <mat-option value="Other">Other</mat-option>
                  <mat-option value=""></mat-option>
                </mat-select>
              </mat-form-field>
            </div>



            <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
              <label class="mb-auto importanthighlight">C Coil Model #</label>
              <a *ngIf="data.pics.c_coil_3_mn" class="upload-image-wrapper"
              href="javascript:void(0)" (click)="openPhotoViewer(data.pics.c_coil_3_mn)">
              <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
                src="{{data.pics.c_coil_3_mn || ''}}">
            </a>
              <input (change)="photoTaken($event, 'c_coil_3_mn')" type="file" accept="image/*,text/plain" id="pictureinput74"
                style="display: none;" />
              <button class="my-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput74')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button>
              <div [hidden]="!data.pics?.c_coil_3_mn"><button mat-button color="green"
                  [hidden]="!data.pics?.c_coil_3_mn" (click)="viewPic('c_coil_3_mn')">
                  <fa-icon [icon]="facamera"></fa-icon>
                </button></div>
              <mat-form-field>
                <input matInput formControlName="c_coil_3_mn" (focus)="setInitialValue('c_coil_3_mn')" (blur)="updateSingleField('c_coil_3_mn', true)">
              </mat-form-field>
            </div>


            <div
              class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start flex-section-external-pressure">
              <label class="space-title importanthighlight">E Coil Model #</label>
              <a *ngIf="data.pics.e_coil_3_mn" class="upload-image-wrapper"
              href="javascript:void(0)" (click)="openPhotoViewer(data.pics.e_coil_3_mn)">
              <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
                src="{{data.pics.e_coil_3_mn || ''}}">
            </a>
            <input (change)="photoTaken($event, 'e_coil_3_mn')" type="file" accept="image/*,text/plain" id="pictureinput75"
                style="display: none;" />
              <button class="my-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput75')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button>
              <div [hidden]="!data.pics?.e_coil_3_mn"><button mat-button color="green"
                  [hidden]="!data.pics?.e_coil_3_mn" (click)="viewPic('e_coil_3_mn')">
                  <fa-icon [icon]="facamera"></fa-icon>
                </button></div>
              <mat-form-field>
                <input matInput formControlName="e_coil_3_mn" (focus)="setInitialValue('e_coil_3_mn')" (blur)="updateSingleField('e_coil_3_mn', true)">
              </mat-form-field>
            </div>



            <div
              class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start flex-section-external-pressure">
              <label class="space-title importanthighlight">Furnace or HP Aux. Model</label>
              <a *ngIf="data.pics.ahu_furn_3_mn" class="upload-image-wrapper"
              href="javascript:void(0)" (click)="openPhotoViewer(data.pics.ahu_furn_3_mn)">
              <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
                src="{{data.pics.ahu_furn_3_mn || ''}}">
            </a>
              <input (change)="photoTaken($event, 'ahu_furn_3_mn')" type="file" accept="image/*,text/plain" id="pictureinput76"
                style="display: none;" />
              <button class="my-3" mat-flat-button color="primary" id="ahu_furn_3_mn"
                (click)="pictureClick('pictureinput76')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button>
              <div [hidden]="!data.pics?.ahu_furn_3_mn"><button mat-button color="green"
                  [hidden]="!data.pics?.ahu_furn_3_mn" (click)="viewPic('ahu_furn_3_mn')">
                  <fa-icon [icon]="facamera"></fa-icon>
                </button></div>
              <mat-form-field>
                <input matInput formControlName="ahu_furn_3_mn" (focus)="setInitialValue('ahu_furn_3_mn')" (blur)="updateSingleField('ahu_furn_3_mn', true)">
              </mat-form-field>
            </div>

            <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start" id="txv3-div">

              <input (change)="photoTaken($event, 'txv3')" type="file" accept="image/*,text/plain" id="pictureinput66"
              style="display: none;" />
            <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput66')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button>
            <div [hidden]="!data.pics?.txv3"><button mat-button color="green" [hidden]="!data.pics?.txv3"
                (click)="viewPic('txv3')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button></div>

              <label class="space-title">TXV</label>
              <a *ngIf="data.pics.txv3" class="upload-image-wrapper"
              href="javascript:void(0)" (click)="openPhotoViewer(data.pics.txv3)">
              <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
                src="{{data.pics.txv3 || ''}}">
            </a>
              <mat-form-field>
                <mat-select matNativeControl formControlName="txv3" (blur)="updateSingleField('txv3', true)">
                  <mat-option value="Yes">Yes</mat-option>
                  <mat-option value="No">No</mat-option>
                  <mat-option value=""></mat-option>
                </mat-select>
              </mat-form-field>
            </div>

          </div>
        </div>



        <div *ngIf='raterform.get("hvac4name").value.length > 1'>
          <h4>System 4: {{raterform.get('hvac4name').value}}</h4>

          <!--
          <div style="padding-right: 20px">
            <mat-label> Programmable Thermostat? </mat-label>
            <mat-checkbox formControlName="programstat3" (focus)="setInitialValue('programstat3')" (blur)="updateSingleField('programstat3')" id='programstat3'>
            </mat-checkbox>
          </div>
          -->
          <div class="col-lg-6 col-12 px-3 pb-3">
            <label class="space-title">Thermostat Type
            </label>

            <a *ngIf="data.pics.tstattype4" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.tstattype4)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.tstattype4 || ''}}">
            </a>

            <mat-form-field>
              <mat-select matNativeControl formControlName="tstattype4"
                (blur)="updateSingleField('tstattype4',true)">
                <mat-option value="Non-Programmable">Non-Programmable</mat-option>
                <mat-option value="Programmable (Non-wifi)">Programmable (Non-wifi)</mat-option>
                <mat-option value="Smart Wifi">Smart Wifi</mat-option>
                <mat-option value=""></mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-lg-6 col-12 px-3 pb-3">
            <mat-label class="formLabel">Thermostat Count</mat-label>
            <mat-form-field>
              <input matInput type="number" formControlName="tstatcount4" (focus)="setInitialValue('tstatcount4')" (blur)="updateSingleField('tstatcount4')" id="tstatcount4">
            </mat-form-field>
          </div>


          <div class="d-flex flex-wrap row">
            <div class="col-lg-6 col-12 px-3 pb-3" id="heat4fuel-div">
              <mat-label>Heat Fuel
              </mat-label>
              <mat-form-field>
                <mat-select matNativeControl formControlName="heat4fuel" (blur)="updateSingleField('heat4fuel')">
                  <mat-option value="NG">NG</mat-option>
                  <mat-option value="LP">LP</mat-option>
                  <mat-option value="Elct">Elct</mat-option>
                  <mat-option value="Solar">Solar</mat-option>
                  <mat-option value="Dual">Dual</mat-option>
                  <mat-option value=""></mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-lg-6 col-12 px-3 pb-3" id="hvac_4_mfr-div">
              <label>Heat Manufacturer</label>
              <mat-form-field>
                <mat-select matNativeControl formControlName="hvac_4_mfr" 
                  (blur)="updateSingleField('hvac_4_mfr', true)">
                  <mat-option value="Amana/Goodman">Amana/Goodman</mat-option>
                  <mat-option value="Carrier/Bryant">Carrier/Bryant</mat-option>
                  <mat-option value="Comfortmaker">Comfortmaker</mat-option>
                  <mat-option value="Lennox">Lennox</mat-option>
                  <mat-option value="Mitsubishi">Mitsubishi</mat-option>
                  <mat-option value="Rheem/Rudd">Rheem/Rudd</mat-option>
                  <mat-option value="Trane/American Standard">Trane/American Standard</mat-option>
                  <mat-option value="Other">Other</mat-option>
                  <mat-option value=""></mat-option>
                </mat-select>
              </mat-form-field>
            </div>



            <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
              <label class="mb-auto importanthighlight">C Coil Model #</label>
              <a *ngIf="data.pics.c_coil_4_mn" class="upload-image-wrapper"
              href="javascript:void(0)" (click)="openPhotoViewer(data.pics.c_coil_4_mn)">
              <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
                src="{{data.pics.c_coil_4_mn || ''}}">
            </a>
              <input (change)="photoTaken($event, 'c_coil_4_mn')" type="file" accept="image/*,text/plain" id="pictureinput68"
                style="display: none;" />
              <button class="my-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput68')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button>
              <div [hidden]="!data.pics?.c_coil_4_mn"><button mat-button color="green"
                  [hidden]="!data.pics?.c_coil_4_mn" (click)="viewPic('c_coil_4_mn')">
                  <fa-icon [icon]="facamera"></fa-icon>
                </button></div>
              <mat-form-field>
                <input matInput formControlName="c_coil_4_mn" (focus)="setInitialValue('c_coil_4_mn')" (blur)="updateSingleField('c_coil_4_mn', true)">
              </mat-form-field>
            </div>


            <div
              class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start flex-section-external-pressure">
              <label class="space-title importanthighlight">E Coil Model #</label>
              <a *ngIf="data.pics.e_coil_4_mn" class="upload-image-wrapper"
              href="javascript:void(0)" (click)="openPhotoViewer(data.pics.e_coil_4_mn)">
              <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
                src="{{data.pics.e_coil_4_mn || ''}}">
            </a>
            <input (change)="photoTaken($event, 'e_coil_4_mn')" type="file" accept="image/*,text/plain" id="pictureinput69"
                style="display: none;" />
              <button class="my-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput69')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button>
              <div [hidden]="!data.pics?.e_coil_4_mn"><button mat-button color="green"
                  [hidden]="!data.pics?.e_coil_4_mn" (click)="viewPic('e_coil_4_mn')">
                  <fa-icon [icon]="facamera"></fa-icon>
                </button></div>
              <mat-form-field>
                <input matInput formControlName="e_coil_4_mn" (focus)="setInitialValue('e_coil_4_mn')" (blur)="updateSingleField('e_coil_4_mn', true)">
              </mat-form-field>
            </div>



            <div
              class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start flex-section-external-pressure">
              <label class="space-title importanthighlight">Furnace or HP Aux. Model</label>
              <a *ngIf="data.pics.ahu_furn_4_mn" class="upload-image-wrapper"
              href="javascript:void(0)" (click)="openPhotoViewer(data.pics.ahu_furn_4_mn)">
              <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
                src="{{data.pics.ahu_furn_4_mn || ''}}">
            </a>
              <input (change)="photoTaken($event, 'ahu_furn_4_mn')" type="file" accept="image/*,text/plain" id="pictureinput70"
                style="display: none;" />
              <button class="my-3" mat-flat-button color="primary" id="ahu_furn_4_mn"
                (click)="pictureClick('pictureinput70')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button>
              <div [hidden]="!data.pics?.ahu_furn_4_mn"><button mat-button color="green"
                  [hidden]="!data.pics?.ahu_furn_4_mn" (click)="viewPic('ahu_furn_3_mn')">
                  <fa-icon [icon]="facamera"></fa-icon>
                </button></div>
              <mat-form-field>
                <input matInput formControlName="ahu_furn_4_mn" (focus)="setInitialValue('ahu_furn_4_mn')" (blur)="updateSingleField('ahu_furn_4_mn', true)">
              </mat-form-field>
            </div>

            <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start" id="txv4-div">

              <input (change)="photoTaken($event, 'txv4')" type="file" accept="image/*,text/plain" id="pictureinput71"
              style="display: none;" />
            <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput71')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button>
            <div [hidden]="!data.pics?.txv4"><button mat-button color="green" [hidden]="!data.pics?.txv4"
                (click)="viewPic('txv4')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button></div>

              <label class="space-title">TXV</label>
              <a *ngIf="data.pics.txv4" class="upload-image-wrapper"
              href="javascript:void(0)" (click)="openPhotoViewer(data.pics.txv4)">
              <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
                src="{{data.pics.txv4 || ''}}">
            </a>
              <mat-form-field>
                <mat-select matNativeControl formControlName="txv3" (blur)="updateSingleField('txv4', true)">
                  <mat-option value="Yes">Yes</mat-option>
                  <mat-option value="No">No</mat-option>
                  <mat-option value=""></mat-option>
                </mat-select>
              </mat-form-field>
            </div>

          </div>
        </div>

        <hr style="padding-top: 20px; padding-bottom: 20px;">

        <div class="d-flex flex-wrap row">

          <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start" id="dhw_1_location-div">
            <label class="space-title importanthighlight">DHW #1 Location</label>
            <a *ngIf="data.pics.dhw_1_location" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.dhw_1_location)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.dhw_1_location || ''}}">
          </a>
          <div class="col-12">

            <mat-form-field>
              <mat-select matNativeControl formControlName="dhw_1_location" 
                (blur)="updateSingleField('dhw_1_location',true)" id='dhw_1_location'>


                <mat-option 
                *ngIf="raterform.get('dhw_1_location').value === 'Garage/Open Crawl'"
                [value]="'Garage/Open Crawl'"
                [disabled]="true"
              >
              Garage/Open Crawl
              </mat-option>

              <mat-option 
              *ngIf="raterform.get('dhw_1_location').value === 'Garage'"
              [value]="'Garage'"
              [disabled]="true"
            >
              Garage
            </mat-option>



                <mat-option value="Conditioned Space">Conditioned Space</mat-option>
                <mat-option value="Unconditioned Attic">Unconditioned Attic</mat-option>
                <mat-option value="Unconditioned Basement">Unconditioned Basement</mat-option>
                <mat-option value="Vented Crawl">Vented Crawl</mat-option>
                <mat-option value="Conditioned Crawl">Conditioned Crawl</mat-option>
                <mat-option value="Garage or Outdoor Storage">Garage or Outdoor Storage</mat-option>
                <mat-option value="Conditioned Attic"> Conditioned Attic</mat-option>
                <mat-option value="Ambient">Ambient</mat-option>
                <mat-option value=""></mat-option>
              </mat-select>
            </mat-form-field>
          </div>
            <input (change)="photoTaken($event, 'dhw_1_location')" type="file" accept="image/*,text/plain" id="pictureinput10"
              style="display: none;" />
            <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput10')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button>
            <div [hidden]="!data.pics?.dhw_1_location"><button mat-button color="green"
                [hidden]="!data.pics?.dhw_1_location" (click)="viewPic('dhw_1_location')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button></div>
          </div>

          <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start" id="dhw1fuel-div">
            <label class="space-title importanthighlight">DHW #1 Fuel</label>
            <a *ngIf="data.pics.dhw1fuel" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.dhw1fuel)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.dhw1fuel || ''}}">
          </a>
          <div class="col-12">
            <mat-form-field>
              <mat-select matNativeControl formControlName="dhw1fuel" (blur)="updateSingleField('dhw1fuel', true)"
                id='dhw1fuel'>
                <mat-option value="NG">NG</mat-option>
                <mat-option value="LP">LP</mat-option>
                <mat-option value="Elct">Elct</mat-option>
                <mat-option value="Solar">Solar</mat-option>
                <mat-option value="Dual">Dual</mat-option>
                <mat-option value=""></mat-option>
              </mat-select>
            </mat-form-field>
          </div>
            <input (change)="photoTaken($event, 'dhw1fuel')" type="file" accept="image/*,text/plain" id="pictureinput11"
              style="display: none;" />
            <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput11')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button>
            <div [hidden]="!data.pics?.dhw1fuel"><button mat-button color="green" [hidden]="!data.pics?.dhw1fuel"
                (click)="viewPic('dhw1fuel')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button></div>
          </div>


          <div
            class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start flex-section-external-pressure">
            <mat-label class="mb-auto importanthighlight">DHW #1 Manufacturer</mat-label>
            <a *ngIf="data.pics.dhw_1_mfr" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.dhw_1_mfr)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.dhw_1_mfr || ''}}">
          </a>
          <mat-form-field>
            <input matInput formControlName="dhw_1_mfr" (focus)="setInitialValue('dhw_1_mfr')" (blur)="updateSingleField('dhw_1_mfr')" id='dhw_1_mfr'>
          </mat-form-field>
            <input (change)="photoTaken($event, 'dhw_1_mfr')" type="file" accept="image/*,text/plain" id="pictureinput12"
              style="display: none;" />
            <button class="my-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput12')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button>
            <div [hidden]="!data.pics?.dhw_1_mfr"><button mat-button color="green"
                [hidden]="!data.pics?.dhw_1_mfr" (click)="viewPic('dhw_1_mfr')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button></div>

          </div>

          <div
            class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start flex-section-external-pressure">
            <mat-label class="importanthighlight">DHW #1 Model</mat-label>
            <a *ngIf="data.pics.dhw_1_mn" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.dhw_1_mn)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.dhw_1_mn || ''}}">
            </a>
            <mat-form-field>
              <input matInput formControlName="dhw_1_mn" (focus)="setInitialValue('dhw_1_mn')" (blur)="updateSingleField('dhw_1_mn')" id='dhw_1_mn'>
            </mat-form-field>
            <input (change)="photoTaken($event, 'dhw_1_mn')" type="file" accept="image/*,text/plain" id="pictureinput13"
              style="display: none;" />
            <button class="my-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput13')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button>
            <!-- <div [hidden]="!data.pics?.dhw_1_mn"><button mat-button color="green" [hidden]="!data.pics?.dhw_1_mn"
                (click)="viewPic('dhw_1_mn')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button></div> -->

          </div>
        </div>






        <div>
          <mat-checkbox #dhw2> <p style="margin-left:20px;">2nd DHW?</p> </mat-checkbox>
        </div>

        <div class="d-flex flex-wrap row" *ngIf="dhw2.checked || raterform.get('dhw_2_location').value != '' ">

          <div class="col-lg-6 col-12 px-3 pb-3" id="dhw_2_location-div">
            <label class="space-title importanthighlight">DHW #2 Location</label>
            <a *ngIf="data.pics.dhw_2_location" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.dhw_2_location)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.dhw_2_location || ''}}">
            </a>
            <div class="box-border" style="width: 200px;">
              <mat-form-field style="width: 200px;">
                <mat-select matNativeControl formControlName="dhw_2_location" 
                  (blur)="updateSingleField('dhw_2_location', true)" id='dhw_2_location'>
                  
                  <mat-option 
                  *ngIf="raterform.get('dhw_2_location').value === 'Garage/Open Crawl'"
                  [value]="'Garage/Open Crawl'"
                  [disabled]="true"
                >
                Garage/Open Crawl
                </mat-option>
  
                <mat-option 
                *ngIf="raterform.get('dhw_2_location').value === 'Garage'"
                [value]="'Garage'"
                [disabled]="true"
              >
                Garage
              </mat-option>


                  <mat-option value="Conditioned Space">Conditioned Space</mat-option>
                  <mat-option value="Unconditioned Attic">Unconditioned Attic</mat-option>
                  <mat-option value="Unconditioned Basement">Unconditioned Basement</mat-option>
                  <mat-option value="Vented Crawl">Vented Crawl</mat-option>
                  <mat-option value="Conditioned Crawl">Conditioned Crawl</mat-option>
                  <mat-option value="Garage or Outdoor Storage">Garage or Outdoor Storage</mat-option>
                  <mat-option value="Conditioned Attic"> Conditioned Attic</mat-option>
                  <mat-option value="Ambient">Ambient</mat-option>
                  <mat-option value=""></mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <button mat-button color="grey" id="dhw_2_location">
              <input (change)="photoTaken($event, 'dhw_2_location')" type="file" accept="image/*,text/plain" id="pictureinput14"
                style="display: none;" />
              <button mat-button color="grey" (click)="pictureClick('pictureinput14')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button>
              <div [hidden]="!data.pics?.dhw_2_location"><button mat-button color="green"
                  [hidden]="!data.pics?.dhw_2_location" (click)="viewPic('dhw_2_location')">
                  <fa-icon [icon]="facamera"></fa-icon>
                </button></div>
            </button>


          </div>

          <div class="col-lg-6 col-12 px-3 pb-3" id="dhw2fuel-div">
            <label class="space-title importanthighlight">DHW #2 Fuel></label>
            <a *ngIf="data.pics.dhw2fuel" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.dhw2fuel)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.dhw2fuel || ''}}">
            </a>
              <button mat-button color="grey" id="dhw2fuel">
                <input (change)="photoTaken($event, 'dhw2fuel')" type="file" accept="image/*,text/plain" id="pictureinput15"
                  style="display: none;" />
                <button mat-button color="grey" (click)="pictureClick('pictureinput15')">
                  <fa-icon [icon]="facamera"></fa-icon>
                </button>
                <div [hidden]="!data.pics?.dhw2fuel"><button mat-button color="green"
                    [hidden]="!data.pics?.dhw2fuel" (click)="viewPic('dhw2fuel')">
                    <fa-icon [icon]="facamera"></fa-icon>
                  </button></div>
              </button>

            <div class="box-border" style="width: 120px;">
              <mat-form-field style="width: 120px;">
                <mat-select matNativeControl formControlName="dhw2fuel" (blur)="updateSingleField('dhw2fuel', true)">
                  <mat-option value="NG">NG</mat-option>
                  <mat-option value="LP">LP</mat-option>
                  <mat-option value="Elct">Elct</mat-option>
                  <mat-option value="Solar">Solar</mat-option>
                  <mat-option value="Dual">Dual</mat-option>
                  <mat-option value=""></mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
            <mat-label class="importanthighlight">DHW #2 Manufacturer</mat-label>
            <a *ngIf="data.pics.dhw_2_mfr" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.dhw_2_mfr)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.dhw_2_mfr || ''}}">
            </a>
              <button mat-button color="grey" id="dhw_2_mfr">
                <input (change)="photoTaken($event, 'dhw_2_mfr')" type="file" accept="image/*,text/plain" id="pictureinput16"
                  style="display: none;" />
                <button mat-button color="grey" (click)="pictureClick('pictureinput16')">
                  <fa-icon [icon]="facamera"></fa-icon>
                </button>
                <div [hidden]="!data.pics?.dhw_2_mfr"><button mat-button color="green"
                    [hidden]="!data.pics?.dhw_2_mfr" (click)="viewPic('dhw_2_mfr')">
                    <fa-icon [icon]="facamera"></fa-icon>
                  </button></div>
              </button>

            <mat-form-field>
              <input matInput formControlName="dhw_2_mfr" (focus)="setInitialValue('dhw_2_mfr')" (blur)="updateSingleField('dhw_2_mfr')">
            </mat-form-field>
          </div>

          <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
            <mat-label class="importanthighlight">DHW #2 Model</mat-label>
            <a *ngIf="data.pics.dhw_2_mn" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.dhw_2_mn)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.dhw_2_mn || ''}}">
            </a>
              <button mat-button color="grey" id="dhw2mn">
                <input (change)="photoTaken($event, 'dhw_2_mn')" type="file" accept="image/*,text/plain" id="pictureinput17"
                  style="display: none;" />
                <button mat-button color="grey" (click)="pictureClick('pictureinput17')">
                  <fa-icon [icon]="facamera"></fa-icon>
                </button>
                <div [hidden]="!data.pics?.dhw_2_mn"><button mat-button color="green"
                    [hidden]="!data.pics?.dhw_2_mn" (click)="viewPic('dhw_2_mn')">
                    <fa-icon [icon]="facamera"></fa-icon>
                  </button></div>
              </button>

            <mat-form-field>
              <input matInput formControlName="dhw_2_mn" (focus)="setInitialValue('dhw_2_mn')" (blur)="updateSingleField('dhw_2_mn')" id='dhw_2_mn'>
            </mat-form-field>
          </div>
        </div>


        <div class="flex-section-external-pressure col-lg-6 col-12 px-3" style="margin-top:50px;">
          <p style="margin-left:20px;">Low-Flow Water Fixtures (excludes toilets)</p>
          <mat-select matNativeControl formControlName="loflowafx" (blur)="updateSingleField('loflowafx')">
            <mat-option [value] = true>Yes</mat-option>
            <mat-option [value] = false>No</mat-option>
            <mat-option [value] = null></mat-option>
          </mat-select>
        </div>

        <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start" >

          <!-- Multi-photo gallery for loflowafx -->
          <div class="photo-gallery" *ngIf="loflowafxPhotos && loflowafxPhotos.length > 0">
            <div *ngFor="let photoUrl of loflowafxPhotos; let i = index" class="photo-thumbnail-wrapper" style="display: inline-block; margin: 5px;">
              <a href="javascript:void(0)" (click)="openPhotoViewer(photoUrl)">
                <img loading='lazy' class="photo-thumbnail" [src]="photoUrl" alt="Low flow fixture photo {{i + 1}}"
                  style="max-width: 150px; max-height: 150px; width: auto; height: auto;">
              </a>
              <button style="background-color: red; color: white; border: 0; border-radius: 9px; width: 4em; display: block; margin-top: 5px;"
                (click)="openDeleteModalLoflow(photoUrl)" title="Delete Photo">
                <mat-icon style="font-family: 'Roboto';">X</mat-icon>
              </button>
            </div>
          </div>
          <p *ngIf="!loflowafxPhotos || loflowafxPhotos.length === 0">No photos uploaded yet.</p>

          <input (change)="photoTaken($event, 'loflowafx')" type="file" accept="image/*,text/plain" id="pictureinput91"
            style="display: none;" />
          <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput91')">
            <fa-icon [icon]="facamera"></fa-icon>
          </button>
        </div>

        

        <div class="flex-section-external-pressure col-lg-6 col-12 px-3" style="margin-top:50px;">
          <p style="margin-left:20px;"> 100% pipe insulation</p>
          <mat-select matNativeControl formControlName="r3hwpipins" (blur)="updateSingleField('r3hwpipins')">
            <mat-option [value]= true>Yes</mat-option>
            <mat-option [value]= false>No</mat-option>
            <mat-option [value]= null></mat-option>
          </mat-select>

        <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
          <label>100% Pipe Insulation Pic </label>
          <a *ngIf="data.pics.r3hwpipins" class="upload-image-wrapper"
          href="javascript:void(0)" (click)="openPhotoViewer(data.pics.r3hwpipins)">
          <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
            src="{{data.pics.r3hwpipins || ''}}">
          </a>
          <input (change)="photoTaken($event, 'r3hwpipins')" type="file" accept="image/*,text/plain" id="pictureinput94"
            style="display: none;" />
          <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput94')">
            <fa-icon [icon]="facamera"></fa-icon>
          </button>

        </div>


        </div>


        <h3 style="padding-top:30px;">AHRI Numbers</h3>

        <div class="d-flex flex-wrap row">
          <div
            class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start flex-section-external-pressure">
            <mat-label>AHRI #1
            </mat-label>
            <mat-form-field>
              <input formControlName="ahri_1" (focus)="setInitialValue('ahri_1')" (blur)="updateSingleField('ahri_1')" id='ahri_1' matInput>
            </mat-form-field>
          </div>

          <div
            class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start flex-section-external-pressure">
            <mat-label>AHRI #2
            </mat-label>
            <mat-form-field>
              <input formControlName="ahri_2" (focus)="setInitialValue('ahri_2')" (blur)="updateSingleField('ahri_2')" id='ahri_2' matInput>
            </mat-form-field>
          </div>

          <div
            class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start flex-section-external-pressure">
            <mat-label>AHRI #3
            </mat-label>
            <mat-form-field>
              <input formControlName="ahri_3" (focus)="setInitialValue('ahri_3')" (blur)="updateSingleField('ahri_3')" id='ahri_3' matInput>
            </mat-form-field>
          </div>

          <div
            class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start flex-section-external-pressure">
            <mat-label>AHRI #4
            </mat-label>
            <mat-form-field>
              <input formControlName="ahri_4" (focus)="setInitialValue('ahri_4')" (blur)="updateSingleField('ahri_4')" id='ahri_4' matInput>
            </mat-form-field>
          </div>

        </div>

      </div>

      <div class="tab-content" id="item5" [hidden]="selectedItem != 5">


        <div style="justify-content: center;
        display: flex;
        align-items: center;
        text-align-last: left; ">
          <div *ngIf="showenvSpecs || showSubdivisionEnvSpecs" class="d-flex flex-wrap row row" style="margin-top: 20px;
          margin-bottom: 20px;
          width: 95%;">
            <!-- Not .collapseButton: ngOnInit wires a click toggle onto every .collapseButton
                 and this section must always render expanded. -->
            <h3 class="staticHeader"><span>Envelope Specs</span></h3>
            <div class="content content-static" style="text-align: left">
              <pre *ngIf="showenvSpecs" style="white-space:pre-wrap">{{envSpecs}}</pre>
              <div *ngIf="showSubdivisionEnvSpecs">
                <p *ngIf="showenvSpecs" style="font-weight: 700; margin: 8px 0 0 0;">Subdivision:</p>
                <pre style="white-space:pre-wrap">{{subdivisionEnvSpecs}}</pre>
              </div>
            </div>
          </div>
        </div>


        
        <div>
          <p style="text-align: left;
          font-size: 2em;
          padding-bottom: 1em;
          padding-top: 1em;
          color: #424242;">Climate Zone:  {{this.subdivisionCZ || '____'}} (If blank or incorrect, notify scheduling)</p>
        </div>


        <div class="d-flex flex-wrap row">
          <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start" id="orientation-div">
            <label class="space-title importanthighlight">Orientation (Front Door)</label>
            <a *ngIf="data.pics.orientation" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.orientation)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.orientation || ''}}">
            </a>
            <input (change)="photoTaken($event, 'orientation')" type="file" accept="image/*,text/plain" id="pictureinput18"
              style="display: none;" />
            <button class="my-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput18')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button>
            <div [hidden]="!data.pics?.orientation"><button mat-button color="green"
                [hidden]="!data.pics?.orientation" (click)="viewPic('orientation')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button></div>

            <mat-form-field>
              <mat-select matNativeControl formControlName="orientation" 
                (blur)="updateSingleField('orientation', true)" id='orientation-field'>
                <mat-option value="N">N</mat-option>
                <mat-option value="NE">NE</mat-option>
                <mat-option value="NW">NW</mat-option>
                <mat-option value="S">S</mat-option>
                <mat-option value="SE">SE</mat-option>
                <mat-option value="SW">SW</mat-option>
                <mat-option value="E">E</mat-option>
                <mat-option value="W">W</mat-option>
                <mat-option value=""></mat-option>
                </mat-select>
            </mat-form-field>
          </div>


        <div class="flex-section-external-pressure col-lg-6 col-12 px-3">
          <mat-label class="importanthighlight">Hot Water Pipe Length
          </mat-label>
          <mat-form-field>
            <input matInput formControlName="hwpipelen" (focus)="setInitialValue('hwpipelen')" (blur)="updateSingleField('hwpipelen')" id='hwpipelen'>
          </mat-form-field>
        </div>


          <!--
          <div class="col-lg-6 col-12 px-3 pb-3">
            <label class="space-title">Front Door Picture</label>
            <a *ngIf="data.pics.frontdoor" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.frontdoor)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.frontdoor || ''}}">
            </a>
            <input (change)="photoTaken($event, 'frontdoor')" type="file" accept="image/*,text/plain" id="pictureinput40"
              style="display: none;" />
            <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput40')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button>
            <div [hidden]="!data.pics?.frontdoor"><button mat-button color="green"
                [hidden]="!data.pics?.frontdoor" (click)="viewPic('frontdoor')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button></div>
          </div>

          -->

          <div
          class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start flex-section-external-pressure">
          <mat-label class="mb-auto">Solid Door U-Value </mat-label>
          <a *ngIf="data.pics.solid_door_u" class="upload-image-wrapper"
          href="javascript:void(0)" (click)="openPhotoViewer(data.pics.solid_door_u)">
          <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
            src="{{data.pics.solid_door_u || ''}}">
          </a>
          <input (change)="photoTaken($event, 'solid_door_u')" type="file" accept="image/*,text/plain" id="pictureinput43"
            style="display: none;" />
          <button class="my-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput43')">
            <fa-icon [icon]="facamera"></fa-icon>
          </button>
          <div [hidden]="!data.pics?.solid_door_u"><button mat-button color="green"
              [hidden]="!data.pics?.solid_door_u" (click)="viewPic('solid_door_u')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button></div>

          <mat-form-field>
            <input matInput formControlName="solid_door_u" (focus)="setInitialValue('solid_door_u')" (blur)="updateSingleField('solid_door_u')"
              id='solid_door_u'>
          </mat-form-field>
        </div>

        <div class="col-12 px-3 pb-3">
          <h3>Windows</h3>
        </div>

        <div class="flex-section-external-pressure col-lg-6 col-12 px-3">
          <mat-label class="importanthighlight">Window U-Value
          </mat-label>
          <mat-form-field>
            <input matInput formControlName="window_u" (focus)="setInitialValue('window_u')" (blur)="updateSingleField('window_u')" id='window_u'>
          </mat-form-field>
        </div>

        <div
          class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
          <mat-label class="mb-auto importanthighlight">Window SHGC
          </mat-label>
          <mat-form-field>
            <input matInput formControlName="window_shgc" (focus)="setInitialValue('window_shgc')" (blur)="updateSingleField('window_shgc')" id='window_shgc'>
          </mat-form-field>
        </div>

        <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
          <label>Window NFRC Label Picture</label>
          <a *ngIf="data.pics.window_shgc" class="upload-image-wrapper"
          href="javascript:void(0)" (click)="openPhotoViewer(data.pics.window_shgc)">
          <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
            src="{{data.pics.window_shgc || ''}}">
          </a>
          <input (change)="photoTaken($event, 'window_shgc')" type="file" accept="image/*,text/plain" id="pictureinput41"
            style="display: none;" />
          <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput41')">
            <fa-icon [icon]="facamera"></fa-icon>
          </button>
          <!-- <div [hidden]="!data.pics?.window_shgc"><button mat-button color="green"
              [hidden]="!data.pics?.window_shgc" (click)="viewPic('window_shgc')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button></div> -->

        </div>


        <div class="col-lg-6 col-12 px-3 pb-3">
          <mat-label>Window Notes</mat-label>
          <textarea rows=6 formControlName="specshgcu" (focus)="setInitialValue('specshgcu')" (blur)="updateSingleField('specshgcu')">
          </textarea>
        </div>

        <div class="col-12 px-3 pb-3">
          <h3>Doors</h3>
        </div>

        <div
          class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start flex-section-external-pressure">
          <mat-label class="importanthighlight">Glass Door U Value
          </mat-label>
          <mat-form-field>
            <input matInput formControlName="glass_door_u" (focus)="setInitialValue('glass_door_u')" (blur)="updateSingleField('glass_door_u')"
              id='glass_door_u'>
          </mat-form-field>
        </div>

        <div
          class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start flex-section-external-pressure">
          <mat-label class="importanthighlight">Glass Door SHGC Value
          </mat-label>
          <mat-form-field>
            <input matInput formControlName="glass_door_shgc" (focus)="setInitialValue('glass_door_shgc')" (blur)="updateSingleField('glass_door_shgc')"
              id='glass_door_shgc'>
          </mat-form-field>
        </div>

        <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
          <label>Glass Door NFRC Label Picture</label>
          <a *ngIf="data.pics.glass_door_shgc" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.glass_door_shgc)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.glass_door_shgc || ''}}">
          </a>
          <input (change)="photoTaken($event, 'glass_door_shgc')" type="file" accept="image/*,text/plain" id="pictureinput42"
            style="display: none;" />
          <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput42')">
            <fa-icon [icon]="facamera"></fa-icon>
          </button>
          <!-- <div [hidden]="!data.pics?.glass_door_shgc"><button mat-button color="green"
              [hidden]="!data.pics?.glass_door_shgc" (click)="viewPic('glass_door_shgc')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button></div> -->

        </div>

        <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start" style="align-items:center !important;" id="skylights-div">
          <mat-checkbox formControlName="skylights" (change)="updateSingleField('skylights', true)"><p style="padding-left: 20px;">Skylights</p></mat-checkbox>
          <a *ngIf="data.pics.skylights" class="upload-image-wrapper"
          href="javascript:void(0)" (click)="openPhotoViewer(data.pics.skylights)">
          <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
            src="{{data.pics.skylights || ''}}">
          </a>
          <input (change)="photoTaken($event, 'skylights')" type="file" accept="image/*,text/plain" id="pictureinput20"
            style="display: none;" />
          <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput20')">
            <fa-icon [icon]="facamera"></fa-icon>
          </button>
          <div [hidden]="!data.pics?.skylights"><button mat-button color="green"
              [hidden]="!data.pics?.skylights" (click)="viewPic('skylights')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button></div>

        </div>

        <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start" style="align-items:center;">
          <mat-checkbox formControlName="foamwalls" (change)="updateSingleField('foamwalls')" id='foamwalls'>
            <p style="margin-left: 20px;"> Foam Walls </p>
          </mat-checkbox>
          <a *ngIf="data.pics.foamwalls" class="upload-image-wrapper"
          href="javascript:void(0)" (click)="openPhotoViewer(data.pics.foamwalls)">
          <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
            src="{{data.pics.foamwalls || ''}}">
          </a>
          <input (change)="photoTaken($event, 'foamwalls')" type="file" accept="image/*,text/plain" id="pictureinput34"
            style="display: none;" />
          <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput34')">
            <fa-icon [icon]="facamera"></fa-icon>
          </button>
          <div [hidden]="!data.pics?.foamwalls"><button mat-button color="green"
              [hidden]="!data.pics?.foamwalls" (click)="viewPic('foamwalls')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button></div>


        </div>


        <div
        class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
        <mat-label class="mb-auto">Foam Wall Average Insulation Depth
        </mat-label>
        <mat-form-field>
          <input matInput formControlName="fwavgdepth" (focus)="setInitialValue('fwavgdepth')" (blur)="updateSingleField('fwavgdepth')" id='fwavgdepth'>
        </mat-form-field>
      </div>


        <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">

          <div style="padding-bottom:24px;">
            <mat-checkbox formControlName="agwna" (change)="updateSingleField('agwna', true)"> <p style="padding-left:5px; font-size:24px;">AGW N/A</p>
            </mat-checkbox>
          </div>

          <div *ngIf = "raterform.get('agwna').value == false">
          <label class="space-title">AGW</label>
          <a *ngIf="data.pics.agw" class="upload-image-wrapper"
          href="javascript:void(0)" (click)="openPhotoViewer(data.pics.agw)">
          <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
            src="{{data.pics.agw || ''}}">
          </a>
          <input (change)="photoTaken($event, 'agw')" type="file" accept="image/*,text/plain" id="pictureinput29"
            style="display: none;" />
          <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput29')">
            <fa-icon [icon]="facamera"></fa-icon>
          </button>
          <!-- <div [hidden]="!data.pics?.agw"><button mat-button color="green" [hidden]="!data.pics?.agw"
              (click)="viewPic('agw')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button></div> -->

          <mat-form-field>
            <mat-select matNativeControl formControlName="agw" (blur)="updateSingleField('agw', true)" id='agw'>
              <mat-option value="N/A">N/A</mat-option>
              <mat-option value="R13 GI">R13 GI</mat-option>
              <mat-option value="R13 GII">R13 GII</mat-option>
              <mat-option value="R13 GIII">R13 GIII</mat-option>
              <mat-option value="R15 GI">R15 GI</mat-option>
              <mat-option value="R15 GII">R15 GII</mat-option>
              <mat-option value="R15 GIII">R15 GIII</mat-option>
              <mat-option value="R19 GI">R19 GI</mat-option>
              <mat-option value="R19 GII">R19 GII</mat-option>
              <mat-option value="R19 GIII">R19 GIII</mat-option>
              <mat-option value="R21 GI">R21 GI</mat-option>
              <mat-option value="R21 GII">R21 GII</mat-option>
              <mat-option value="R21 GIII">R21 GIII</mat-option>
              <mat-option value="Other">Other</mat-option>
              <mat-option value=""></mat-option>
            </mat-select>
          </mat-form-field>

          </div>

        </div>

        <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
          <div class="col-lg-6 col-12 px-3 pb-3">
            <label class="space-title">AGW Spacing
            </label>
            <mat-form-field>
              <mat-select matNativeControl formControlName="agwspacing"
                (blur)="updateSingleField('agwspacing',true)">
                <mat-option value="12 OC">12 OC</mat-option>
                <mat-option value="16 OC">16 OC</mat-option>
                <mat-option value="19.2 OC">19.2 OC</mat-option>
                <mat-option value="24 OC">24 OC</mat-option>
                <mat-option value=""></mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>



        <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">

          <label class="space-title">AGW Insulated Sheathing</label>
          <a *ngIf="data.pics.agwins" class="upload-image-wrapper"
          href="javascript:void(0)" (click)="openPhotoViewer(data.pics.agwins)">
          <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
            src="{{data.pics.agwins || ''}}">
          </a>
          <input (change)="photoTaken($event, 'agwins')" type="file" accept="image/*,text/plain" id="pictureinput88"
            style="display: none;" />
          <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput88')">
            <fa-icon [icon]="facamera"></fa-icon>
          </button>
          <!-- <div [hidden]="!data.pics?.agw"><button mat-button color="green" [hidden]="!data.pics?.agw"
              (click)="viewPic('agw')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button></div> -->



          <mat-form-field>
            <mat-select matNativeControl formControlName="agwins"  (blur)="updateSingleField('agwins', true)" id='agwins'>
              <mat-option value="N/A">None</mat-option>
              <mat-option value="R3">R3</mat-option>
              <mat-option value="R5">R5</mat-option>
              <mat-option value="R6">R6</mat-option>
              <mat-option value="R9">R9</mat-option>
              <mat-option value="R10">R10</mat-option>
              <mat-option value="R12">R12</mat-option>
              <mat-option value=""></mat-option>
            </mat-select>
          </mat-form-field>
        </div>


        <mat-checkbox formControlName="adiabatic_walls_chk" (change)="updateSingleField('adiabatic_walls_chk', true)" style="padding-bottom: 24px;"> <p style="padding-left:5px; font-size:24px;">Adiabatic/Common Walls</p>
        </mat-checkbox>

        <div *ngIf="raterform.get('adiabatic_walls_chk').value == true">
          <div class="col-lg-6 col-12 px-3 pb-3">
            <label class="space-title">Adiabatic Walls</label>
            <a *ngIf="data.pics.adiabatic_walls_rv" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.adiabatic_walls_rv)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.adiabatic_walls_rv || ''}}">
            </a>
            <input (change)="photoTaken($event, 'adiabatic_walls_rv')" type="file" accept="image/*,text/plain" id="pictureinput_adwall"
              style="display: none;" />
            <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput_adwall')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button>

            <mat-form-field>
              <mat-select matNativeControl formControlName="adiabatic_walls_rv" (blur)="updateSingleField('adiabatic_walls_rv', true)">
                <mat-option value="N/A">N/A</mat-option>
                <mat-option value="R11 GI">R11 GI</mat-option>
                <mat-option value="R11 GII">R11 GII</mat-option>
                <mat-option value="R11 GIII">R11 GIII</mat-option>
                <mat-option value="R13 GI">R13 GI</mat-option>
                <mat-option value="R13 GII">R13 GII</mat-option>
                <mat-option value="R13 GIII">R13 GIII</mat-option>
                <mat-option value="R15 GI">R15 GI</mat-option>
                <mat-option value="R15 GII">R15 GII</mat-option>
                <mat-option value="R15 GIII">R15 GIII</mat-option>
                <mat-option value="R19 GI">R19 GI</mat-option>
                <mat-option value="R19 GII">R19 GII</mat-option>
                <mat-option value="R19 GIII">R19 GIII</mat-option>
                <mat-option value="R21 GI">R21 GI</mat-option>
                <mat-option value="R21 GII">R21 GII</mat-option>
                <mat-option value="R21 GIII">R21 GIII</mat-option>
                <mat-option value="Other">Other</mat-option>
                <mat-option value=""></mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-lg-6 col-12 px-3 pb-3">
            <label class="space-title">Adiabatic Wall Spacing</label>
            <mat-form-field>
              <mat-select matNativeControl formControlName="adiabatic_walls_sp" (blur)="updateSingleField('adiabatic_walls_sp', true)">
                <mat-option value="12 OC">12 OC</mat-option>
                <mat-option value="16 OC">16 OC</mat-option>
                <mat-option value="19.2 OC">19.2 OC</mat-option>
                <mat-option value="24 OC">24 OC</mat-option>
                <mat-option value=""></mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <mat-checkbox formControlName="bandna" (change)="updateSingleField('bandna', true)" style="padding-bottom: 24px;"> <p style="padding-left:5px; font-size:24px;">BAND N/A</p>
        </mat-checkbox>


        <div *ngIf = "raterform.get('bandna').value == false">
          <div class="col-lg-6 col-12 px-3 pb-3">
            <label class="space-title importanthighlight">Band R-Value</label>
            <a *ngIf="data.pics.band" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.band)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.band || ''}}">
            </a>
            <input (change)="photoTaken($event, 'band')" type="file" accept="image/*,text/plain" id="pictureinput73"
              style="display: none;" />
            <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput73')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button>
            <div [hidden]="!data.pics?.band"><button mat-button color="green"
                [hidden]="!data.pics?.band" (click)="viewPic('band')">
                <fa-icon [icon]="facamera"></fa-icon>
              </button></div>

            <mat-form-field>
              <mat-select matNativeControl formControlName="band"  (blur)="updateSingleField('band', true)"
                id='band'>
                <mat-option value="N/A">N/A</mat-option>
                <mat-option value="R13 GI">R13 GI</mat-option>
                <mat-option value="R13 GII">R13 GII</mat-option>
                <mat-option value="R13 GIII">R13 GIII</mat-option>
                <mat-option value="R15 GI">R15 GI</mat-option>
                <mat-option value="R15 GII">R15 GII</mat-option>
                <mat-option value="R15 GIII">R15 GIII</mat-option>
                <mat-option value="R19 GI">R19 GI</mat-option>
                <mat-option value="R19 GII">R19 GII</mat-option>
                <mat-option value="R19 GIII">R19 GIII</mat-option>
                <mat-option value="R21 GI">R21 GI</mat-option>
                <mat-option value="R21 GII">R21 GII</mat-option>
                <mat-option value="R21 GIII">R21 GIII</mat-option>
                <mat-option value="R13 13 + 13 dble walls">R13 13 + 13 dble walls</mat-option>
                <mat-option value="R15 13 + 13 dble walls">R15 13 + 13 dble walls</mat-option>
                <mat-option value="R19 13 + 13 dble walls">R19 13 + 13 dble walls</mat-option>
                <mat-option value="R13 15 + 15 dble walls">R13 15 + 15 dble walls</mat-option>
                <mat-option value="R15 15 + 15 dble walls">R15 15 + 15 dble walls</mat-option>
                <mat-option value="R19 15 + 15 dble walls">R19 15 + 15 dble walls</mat-option>
                <mat-option value="R13 13 + 19 dble walls">R13 13 + 19 dble walls</mat-option>
                <mat-option value="R15 13 + 19 dble walls">R15 13 + 19 dble walls</mat-option>
                <mat-option value="R19 13 + 19 dble walls">R19 13 + 19 dble walls</mat-option>
                <mat-option value="R13 15 + 19 dble walls">R13 15 + 19 dble walls</mat-option>
                <mat-option value="R15 15 + 19 dble walls">R15 15 + 19 dble walls</mat-option>
                <mat-option value="R19 15 + 19 dble walls">R19 15 + 19 dble walls</mat-option>
                <mat-option value="Other">Other</mat-option>
              </mat-select>
            </mat-form-field>
          </div>


          <div class="col-lg-6 col-12 px-3 pb-3">
            <label class="space-title">Band Spacing
            </label>
            <mat-form-field>
              <mat-select matNativeControl formControlName="bandspacing"
                (blur)="updateSingleField('bandspacing',true)">
                <mat-option value="12 OC">12 OC</mat-option>
                <mat-option value="16 OC">16 OC</mat-option>
                <mat-option value="19.2 OC">19.2 OC</mat-option>
                <mat-option value="24 OC">24 OC</mat-option>
                <mat-option value=""></mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-lg-6 col-12 px-3 pb-3">
            <label class="space-title">Joist Height
            </label>
            <mat-form-field>
              <mat-select matNativeControl formControlName="bandht" 
                (blur)="updateSingleField('bandht',true)">
                <mat-option value = "x10">x10</mat-option>
                <mat-option value = "x12">x12</mat-option>
                <mat-option value = "12in TJI">12"TJI</mat-option>
                <mat-option value = "14in TJI">14"TJI</mat-option>
                <mat-option value = "16in TJI">16"TJI</mat-option>
                <mat-option value = "12 FT">12" Floor Truss</mat-option>
                <mat-option value = "14 FT">14" Floor Truss</mat-option>
                <mat-option value = "16 FT">16" Floor Truss</mat-option>
                <mat-option value = "18 FT">18" Floor Truss</mat-option>
                <mat-option value = "20 FT">20" Floor Truss</mat-option>
                <mat-option value = "22 FT">22" Floor Truss</mat-option>
                <mat-option value = "24 FT">24" Floor Truss</mat-option>
                <mat-option value=""></mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>



        <mat-checkbox formControlName="adiabatic_bands_chk" (change)="updateSingleField('adiabatic_bands_chk', true)" style="padding-bottom: 24px;"> <p style="padding-left:5px; font-size:24px;">Adiabatic Bands</p>
        </mat-checkbox>

        <div *ngIf="raterform.get('adiabatic_bands_chk').value == true">
          <div class="col-lg-6 col-12 px-3 pb-3">
            <label class="space-title">Adiabatic Band R-Value</label>
            <a *ngIf="data.pics.adiabatic_bands_rv" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.adiabatic_bands_rv)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.adiabatic_bands_rv || ''}}">
            </a>
            <input (change)="photoTaken($event, 'adiabatic_bands_rv')" type="file" accept="image/*,text/plain" id="pictureinput_adband"
              style="display: none;" />
            <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput_adband')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button>

            <mat-form-field>
              <mat-select matNativeControl formControlName="adiabatic_bands_rv" (blur)="updateSingleField('adiabatic_bands_rv', true)">
                <mat-option value="N/A">N/A</mat-option>
                <mat-option value="R11 GI">R11 GI</mat-option>
                <mat-option value="R11 GII">R11 GII</mat-option>
                <mat-option value="R11 GIII">R11 GIII</mat-option>
                <mat-option value="R13 GI">R13 GI</mat-option>
                <mat-option value="R13 GII">R13 GII</mat-option>
                <mat-option value="R13 GIII">R13 GIII</mat-option>
                <mat-option value="R15 GI">R15 GI</mat-option>
                <mat-option value="R15 GII">R15 GII</mat-option>
                <mat-option value="R15 GIII">R15 GIII</mat-option>
                <mat-option value="R19 GI">R19 GI</mat-option>
                <mat-option value="R19 GII">R19 GII</mat-option>
                <mat-option value="R19 GIII">R19 GIII</mat-option>
                <mat-option value="R21 GI">R21 GI</mat-option>
                <mat-option value="R21 GII">R21 GII</mat-option>
                <mat-option value="R21 GIII">R21 GIII</mat-option>
                <mat-option value="Other">Other</mat-option>
                <mat-option value=""></mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-lg-6 col-12 px-3 pb-3">
            <label class="space-title">Adiabatic Band Spacing</label>
            <mat-form-field>
              <mat-select matNativeControl formControlName="adiabatic_bands_sp" (blur)="updateSingleField('adiabatic_bands_sp', true)">
                <mat-option value="12 OC">12 OC</mat-option>
                <mat-option value="16 OC">16 OC</mat-option>
                <mat-option value="19.2 OC">19.2 OC</mat-option>
                <mat-option value="24 OC">24 OC</mat-option>
                <mat-option value=""></mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-lg-6 col-12 px-3 pb-3">
            <label class="space-title">Adiabatic Band Joist Height</label>
            <mat-form-field>
              <mat-select matNativeControl formControlName="adiabatic_bands_jh" (blur)="updateSingleField('adiabatic_bands_jh', true)">
                <mat-option value = "x10">x10</mat-option>
                <mat-option value = "x12">x12</mat-option>
                <mat-option value = "12in TJI">12"TJI</mat-option>
                <mat-option value = "14in TJI">14"TJI</mat-option>
                <mat-option value = "16in TJI">16"TJI</mat-option>
                <mat-option value = "12 FT">12" Floor Truss</mat-option>
                <mat-option value = "14 FT">14" Floor Truss</mat-option>
                <mat-option value = "16 FT">16" Floor Truss</mat-option>
                <mat-option value = "18 FT">18" Floor Truss</mat-option>
                <mat-option value = "20 FT">20" Floor Truss</mat-option>
                <mat-option value = "22 FT">22" Floor Truss</mat-option>
                <mat-option value = "24 FT">24" Floor Truss</mat-option>
                <mat-option value=""></mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>


        <!-- ADIABATIC FLOORS SECTION (moved here) -->
        <mat-checkbox formControlName="adiabatic_flr_chk" (change)="updateSingleField('adiabatic_flr_chk', true)" style="padding-bottom: 24px;"> <p style="padding-left:5px; font-size:24px;">Adiabatic Floors MF</p>
        </mat-checkbox>

        <div *ngIf="raterform.get('adiabatic_flr_chk').value == true">
          <div class="col-lg-6 col-12 px-3 pb-3">
            <label class="space-title">Adiabatic Floor R-Value</label>
            <a *ngIf="data.pics.adiabatic_flr_rv" class="upload-image-wrapper"
            href="javascript:void(0)" (click)="openPhotoViewer(data.pics.adiabatic_flr_rv)">
            <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
              src="{{data.pics.adiabatic_flr_rv || ''}}">
            </a>
            <input (change)="photoTaken($event, 'adiabatic_flr_rv')" type="file" accept="image/*,text/plain" id="pictureinput_adflr"
              style="display: none;" />
            <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput_adflr')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button>

            <mat-form-field>
              <mat-select matNativeControl formControlName="adiabatic_flr_rv" (blur)="updateSingleField('adiabatic_flr_rv', true)">
                <mat-option value="N/A">N/A</mat-option>
                <mat-option value="R11 GI">R11 GI</mat-option>
                <mat-option value="R11 GII">R11 GII</mat-option>
                <mat-option value="R11 GIII">R11 GIII</mat-option>
                <mat-option value="R13 GI">R13 GI</mat-option>
                <mat-option value="R13 GII">R13 GII</mat-option>
                <mat-option value="R13 GIII">R13 GIII</mat-option>
                <mat-option value="R15 GI">R15 GI</mat-option>
                <mat-option value="R15 GII">R15 GII</mat-option>
                <mat-option value="R15 GIII">R15 GIII</mat-option>
                <mat-option value="R19 I">R19 I</mat-option>
                <mat-option value="R19 II">R19 II</mat-option>
                <mat-option value="R19 III">R19 III</mat-option>
                <mat-option value="R30 I">R30 I</mat-option>
                <mat-option value="R30 II">R30 II</mat-option>
                <mat-option value="R30 III">R30 III</mat-option>
                <mat-option value="Other">Other</mat-option>
                <mat-option value=""></mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-lg-6 col-12 px-3 pb-3">
            <label class="space-title">Adiabatic Floor Framing Spacing</label>
            <mat-form-field>
              <mat-select matNativeControl formControlName="adiabatic_flr_sp" (blur)="updateSingleField('adiabatic_flr_sp', true)">
                <mat-option value="12 OC">12 OC</mat-option>
                <mat-option value="16 OC">16 OC</mat-option>
                <mat-option value="19.2 OC">19.2 OC</mat-option>
                <mat-option value="24 OC">24 OC</mat-option>
                <mat-option value=""></mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-lg-6 col-12 px-3 pb-3">
            <label class="space-title">Adiabatic Floor Joist Height</label>
            <mat-form-field>
              <mat-select matNativeControl formControlName="adiabatic_flr_jh" (blur)="updateSingleField('adiabatic_flr_jh', true)">
                <mat-option value = "x10">x10</mat-option>
                <mat-option value = "x12">x12</mat-option>
                <mat-option value = "12in TJI">12"TJI</mat-option>
                <mat-option value = "14in TJI">14"TJI</mat-option>
                <mat-option value = "16in TJI">16"TJI</mat-option>
                <mat-option value = "12 FT">12" Floor Truss</mat-option>
                <mat-option value = "14 FT">14" Floor Truss</mat-option>
                <mat-option value = "16 FT">16" Floor Truss</mat-option>
                <mat-option value = "18 FT">18" Floor Truss</mat-option>
                <mat-option value = "20 FT">20" Floor Truss</mat-option>
                <mat-option value = "22 FT">22" Floor Truss</mat-option>
                <mat-option value = "24 FT">24" Floor Truss</mat-option>
                <mat-option value=""></mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>


        <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">

          <label class="space-title importanthighlight">Cantilever Floor R-value</label>
          <a *ngIf="data.pics.cantilever_floor" class="upload-image-wrapper"
          href="javascript:void(0)" (click)="openPhotoViewer(data.pics.cantilever_floor)">
          <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
            src="{{data.pics.cantilever_floor || ''}}">
          </a>
          <input (change)="photoTaken($event, 'cantilever_floor')" type="file" accept="image/*,text/plain" id="pictureinput33"
            style="display: none;" />
          <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput33')">
            <fa-icon [icon]="facamera"></fa-icon>
          </button>
          <div [hidden]="!data.pics?.cantilever_floor"><button mat-button color="green"
              [hidden]="!data.pics?.cantilever_floor" (click)="viewPic('cantilever_floor')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button></div>

          <mat-form-field>
            <mat-select matNativeControl formControlName="cantilever_floor" 
              (blur)="updateSingleField('cantilever_floor', true)" id='cantilever_floor'>
              <mat-option value="N/A">N/A</mat-option>
              <mat-option value="R19 GI">R19 GI</mat-option>
              <mat-option value="R19 GII">R19 GII</mat-option>
              <mat-option value="R19 GIII">R19 GIII</mat-option>
              <mat-option value="R21 GI">R21 GI</mat-option>
              <mat-option value="R21 GII">R21 GII</mat-option>
              <mat-option value="R21 GIII">R21 GIII</mat-option>
              <mat-option value="R30 GI">R30 GI</mat-option>
              <mat-option value="R30 GII">R30 GII</mat-option>
              <mat-option value="R30 GIII">R30 GIII</mat-option>
              <mat-option value="R38 GI">R38 GI</mat-option>
              <mat-option value="R38 GII">R38 GII</mat-option>
              <mat-option value="R38 GIII">R38 GIII</mat-option>

              <mat-option value="R49 GI">R49 GI</mat-option>
              <mat-option value="R49 GII">R49 GII</mat-option>
              <mat-option value="R49 GIII">R49 GIII</mat-option>
              <mat-option value="Other">Other</mat-option>
              <mat-option value="Uninsulated">Uninsulated</mat-option>
              <mat-option value=""></mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-lg-6 col-12 px-3 pb-3">
          <label class="space-title">Cantilever Floor Framing Spacing
          </label>
          <mat-form-field>
            <mat-select matNativeControl formControlName="cantfspacing"
              (blur)="updateSingleField('cantfspacing',true)">
            <mat-option value="12 OC">12 OC</mat-option>
              <mat-option value="16 OC">16 OC</mat-option>
              <mat-option value="19.2 OC">19.2 OC</mat-option>
              <mat-option value="24 OC">24 OC</mat-option>
              <mat-option value=""></mat-option>
            </mat-select>
          </mat-form-field>

        </div>

        <div class="col-lg-6 col-12 px-3 pb-3">
          <label class="space-title">Cantilever Joist Height
          </label>
          <mat-form-field>
            <mat-select matNativeControl formControlName="cantjoist"
              (blur)="updateSingleField('cantjoist',true)">
              <mat-option value = "x10">x10</mat-option>
              <mat-option value = "x12">x12</mat-option>
              <mat-option value = "12in TJI">12"TJI</mat-option>
              <mat-option value = "14in TJI">14"TJI</mat-option>
              <mat-option value = "16in TJI">16"TJI</mat-option>
              <mat-option value = "12 FT">12" Floor Truss</mat-option>
              <mat-option value = "14 FT">14" Floor Truss</mat-option>
              <mat-option value = "16 FT">16" Floor Truss</mat-option>
              <mat-option value = "18 FT">18" Floor Truss</mat-option>
              <mat-option value = "20 FT">20" Floor Truss</mat-option>
              <mat-option value = "22 FT">22" Floor Truss</mat-option>
              <mat-option value = "24 FT">24" Floor Truss</mat-option>
              <mat-option value=""></mat-option>
            </mat-select>
          </mat-form-field>
        </div>



        <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
          <label class="space-title importanthighlight">Floor Above Garage R-Value</label>
          <a *ngIf="data.pics.floor_above_garage" class="upload-image-wrapper"
          href="javascript:void(0)" (click)="openPhotoViewer(data.pics.floor_above_garage)">
          <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
            src="{{data.pics.floor_above_garage || ''}}">
          </a>
          <input (change)="photoTaken($event, 'floor_above_garage')" type="file" accept="image/*,text/plain" id="pictureinput36"
            style="display: none;" />
          <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput36')">
            <fa-icon [icon]="facamera"></fa-icon>
          </button>
          <div [hidden]="!data.pics?.floor_above_garage"><button mat-button color="green"
              [hidden]="!data.pics?.floor_above_garage" (click)="viewPic('floor_above_garage')">
              <fa-icon [icon]="facamera"></fa-icon>
            </button></div>

          <mat-form-field>
            <mat-select matNativeControl formControlName="floor_above_garage"
              (blur)="updateSingleField('floor_above_garage', true)" id='floor_above_garage'>
              <mat-option value="N/A">N/A</mat-option>
              <mat-option value="R19 GI">R19 GI</mat-option>
              <mat-option value="R19 GII">R19 GII</mat-option>
              <mat-option value="R19 GIII">R19 GIII</mat-option>
              <mat-option value="R21 GI">R21 GI</mat-option>
              <mat-option value="R21 GII">R21 GII</mat-option>
              <mat-option value="R21 GIII">R21 GIII</mat-option>
              <mat-option value="R30 GI">R30 GI</mat-option>
              <mat-option value="R30 GII">R30 GII</mat-option>
              <mat-option value="R30 GIII">R30 GIII</mat-option>
              <mat-option value="R38 GI">R38 GI</mat-option>
              <mat-option value="R38 GII">R38 GII</mat-option>
              <mat-option value="R38 GIII">R38 GIII</mat-option>
              <mat-option value="R49 GI">R49 GI</mat-option>
              <mat-option value="R49 GII">R49 GII</mat-option>
              <mat-option value="R49 GIII">R49 GIII</mat-option>
              <mat-option value="Other">Other</mat-option>
              <mat-option value=""></mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-lg-6 col-12 px-3 pb-3">

          <label class="space-title">Garage Framing Spacing
          </label>
          <mat-form-field>
            <mat-select matNativeControl formControlName="garspacing" (blur)="updateSingleField('garspacing',true)">
              <mat-option value="12 OC">12 OC</mat-option>
              <mat-option value="16 OC">16 OC</mat-option>
              <mat-option value="19.2 OC">19.2 OC</mat-option>
              <mat-option value="24 OC">24 OC</mat-option>
              <mat-option value=""></mat-option>
            </mat-select>
          </mat-form-field>
        </div>


        <div class="col-lg-6 col-12 px-3 pb-3">
          <label class="space-title">Garage Joist Height
          </label>
          <mat-form-field>
            <mat-select matNativeControl formControlName="garjoist"
              (blur)="updateSingleField('garjoist',true)">
              <mat-option value = "x10">x10</mat-option>
              <mat-option value = "x12">x12</mat-option>
              <mat-option value = "12in TJI">12"TJI</mat-option>
              <mat-option value = "14in TJI">14"TJI</mat-option>
              <mat-option value = "16in TJI">16"TJI</mat-option>
              <mat-option value = "12 FT">12" Floor Truss</mat-option>
              <mat-option value = "14 FT">14" Floor Truss</mat-option>
              <mat-option value = "16 FT">16" Floor Truss</mat-option>
              <mat-option value = "18 FT">18" Floor Truss</mat-option>
              <mat-option value = "20 FT">20" Floor Truss</mat-option>
              <mat-option value = "22 FT">22" Floor Truss</mat-option>
              <mat-option value = "24 FT">24" Floor Truss</mat-option>
              <mat-option value=""></mat-option>
            </mat-select>
          </mat-form-field>
        </div>



        <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start" style="align-items:center;"
        style="padding-right: 20px">
        <mat-checkbox formControlName="flrovrincl" (change)="updateSingleField('flrovrincl')" id='flrovrincl'>
          <p style="margin-left:20px;">Floors over garages included in envelope for foam houses</p>
        </mat-checkbox>
      </div>

      <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start" style="align-items:center;" id='radiantbarrier-div'>
        <!-- <label class="space-title">Radiant Barrier</label> -->
        <mat-checkbox formControlName="radiantbarrier" (change)="updateSingleField('radiantbarrier', true)"> <p style="padding-left:5px;">Radiant Barrier</p>
        </mat-checkbox>
        <a *ngIf="data.pics.radiantbarrier" class="upload-image-wrapper"
        href="javascript:void(0)" (click)="openPhotoViewer(data.pics.radiantbarrier)">
        <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
          src="{{data.pics.radiantbarrier || ''}}">
        </a>
        <input (change)="photoTaken($event, 'radiantbarrier')" type="file" accept="image/*,text/plain" id="pictureinput19"
          style="display: none;" />
        <button class="my-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput19')">
          <fa-icon [icon]="facamera"></fa-icon>
        </button>
        <div [hidden]="!data.pics?.radiantbarrier"><button mat-button color="green"
            [hidden]="!data.pics?.radiantbarrier" (click)="viewPic('radiantbarrier')">
            <fa-icon [icon]="facamera"></fa-icon>
          </button></div>


      </div>


      <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start" style="align-items:center;" id="raisedheel-div">
        <mat-checkbox formControlName="raisedheel" (change)="updateSingleField('raisedheel', true)"><p style="padding-left:5px;">Raised Heel</p>
        </mat-checkbox>
        <a *ngIf="data.pics.raisedheel" class="upload-image-wrapper"
        href="javascript:void(0)" (click)="openPhotoViewer(data.pics.raisedheel)">
        <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
          src="{{data.pics.raisedheel || ''}}">
        </a>
        <input (change)="photoTaken($event, 'raisedheel')" type="file" accept="image/*,text/plain" id="pictureinput21"
          style="display: none;" />
        <button class="my-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput21')">
          <fa-icon [icon]="facamera"></fa-icon>
        </button>
        <div [hidden]="!data.pics?.raisedheel"><button mat-button color="green"
            [hidden]="!data.pics?.raisedheel" (click)="viewPic('raisedheel')">
            <fa-icon [icon]="facamera"></fa-icon>
          </button></div>



      </div>

      <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start" id="blowcard-div">
        <label class="space-title">Blower card Photo</label>
        <a *ngIf="data.pics.blowcard" class="upload-image-wrapper"
        href="javascript:void(0)" (click)="openPhotoViewer(data.pics.blowcard)">
        <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
          src="{{data.pics.blowcard || ''}}">
        </a>
        <input (change)="photoTaken($event, 'blowcard')" type="file" accept="image/*,text/plain" id="pictureinput23"
          style="display: none;" />
        <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput23')">
          <fa-icon [icon]="facamera"></fa-icon>
        </button>
        <div [hidden]="!data.pics?.blowcard"><button mat-button color="green" [hidden]="!data.pics?.blowcard"
            (click)="viewPic('blowcard')">
            <fa-icon [icon]="facamera"></fa-icon>
          </button></div>

      </div>

      <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start" style="align-items:center;">
        <mat-checkbox style="padding-bottom:20px;" formControlName="foamceilings" (change)="updateSingleField('foamceilings')"> <p style="margin-left:20px;">Foam Ceilings</p>
        </mat-checkbox>
        <a *ngIf="data.pics.foamceilings" class="upload-image-wrapper"
        href="javascript:void(0)" (click)="openPhotoViewer(data.pics.foamceilings)">
        <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
          src="{{data.pics.foamceilings || ''}}">
        </a>
        <input (change)="photoTaken($event, 'foamceilings')" type="file" accept="image/*,text/plain" id="pictureinput22"
          style="display: none;" />
        <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput22')">
          <fa-icon [icon]="facamera"></fa-icon>
        </button>
        <div [hidden]="!data.pics?.foamceilings"><button mat-button color="green"
            [hidden]="!data.pics?.foamceilings" (click)="viewPic('foamceilings')">
            <fa-icon [icon]="facamera"></fa-icon>
          </button></div>
      </div>


      <div
      class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
      <mat-label class="mb-auto">Foam Ceiling Average Insulation Depth
      </mat-label>
      <mat-form-field>
        <input matInput formControlName="fcavgdepth" (focus)="setInitialValue('fcavgdepth')" (blur)="updateSingleField('fcavgdepth')" id='fcavgdepth'>
      </mat-form-field>
    </div>



      <mat-checkbox formControlName="adiabatic_ceil_chk" (change)="updateSingleField('adiabatic_ceil_chk', true)" style="padding-bottom: 24px;"> <p style="padding-left:5px; font-size:24px;">Adiabatic Ceilings MF</p>
      </mat-checkbox>

      <div *ngIf="raterform.get('adiabatic_ceil_chk').value == true">
        <div class="col-lg-6 col-12 px-3 pb-3">
          <label class="space-title">Adiabatic Ceilings R-Value</label>
          <a *ngIf="data.pics.adiabatic_ceil_rv" class="upload-image-wrapper"
          href="javascript:void(0)" (click)="openPhotoViewer(data.pics.adiabatic_ceil_rv)">
          <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
            src="{{data.pics.adiabatic_ceil_rv || ''}}">
          </a>
          <input (change)="photoTaken($event, 'adiabatic_ceil_rv')" type="file" accept="image/*,text/plain" id="pictureinput_adceil"
            style="display: none;" />
          <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput_adceil')">
            <fa-icon [icon]="facamera"></fa-icon>
          </button>

          <mat-form-field>
            <mat-select matNativeControl formControlName="adiabatic_ceil_rv" (blur)="updateSingleField('adiabatic_ceil_rv', true)">
              <mat-option value="N/A">N/A</mat-option>
              <mat-option value="R11 GI">R11 GI</mat-option>
              <mat-option value="R11 GII">R11 GII</mat-option>
              <mat-option value="R11 GIII">R11 GIII</mat-option>
              <mat-option value="R13 GI">R13 GI</mat-option>
              <mat-option value="R13 GII">R13 GII</mat-option>
              <mat-option value="R13 GIII">R13 GIII</mat-option>
              <mat-option value="R15 GI">R15 GI</mat-option>
              <mat-option value="R15 GII">R15 GII</mat-option>
              <mat-option value="R15 GIII">R15 GIII</mat-option>
              <mat-option value="R19 GI">R19 GI</mat-option>
              <mat-option value="R19 GII">R19 GII</mat-option>
              <mat-option value="R19 GIII">R19 GIII</mat-option>
              <mat-option value="R20 Foam">R20 Foam</mat-option>
              <mat-option value="R21 GI">R21 GI</mat-option>
              <mat-option value="R21 GII">R21 GII</mat-option>
              <mat-option value="R21 GIII">R21 GIII</mat-option>
              <mat-option value="R30 GI">R30 GI</mat-option>
              <mat-option value="R30 GII">R30 GII</mat-option>
              <mat-option value="R30 GIII">R30 GIII</mat-option>
              <mat-option value="R38 GI">R38 GI</mat-option>
              <mat-option value="R38 GII">R38 GII</mat-option>
              <mat-option value="R38 GIII">R38 GIII</mat-option>
              <mat-option value="R49 GI">R49 GI</mat-option>
              <mat-option value="R49 GII">R49 GII</mat-option>
              <mat-option value="R49 GIII">R49 GIII</mat-option>
              <mat-option value="Other">Other</mat-option>
              <mat-option value=""></mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-lg-6 col-12 px-3 pb-3">
          <label class="space-title">Adiabatic Ceiling Spacing</label>
          <mat-form-field>
            <mat-select matNativeControl formControlName="adiabatic_ceil_sp" (blur)="updateSingleField('adiabatic_ceil_sp', true)">
              <mat-option value="16 OC">16 OC</mat-option>
              <mat-option value="19.2 OC">19.2 OC</mat-option>
              <mat-option value="24 OC">24 OC</mat-option>
              <mat-option value=""></mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-lg-6 col-12 px-3 pb-3">
          <label class="space-title">Adiabatic Ceiling Framing Size</label>
          <mat-form-field>
            <mat-select matNativeControl formControlName="adiabatic_ceil_fs" (blur)="updateSingleField('adiabatic_ceil_fs', true)">
              <mat-option value="12in TJI">12" TJI</mat-option>
              <mat-option value="14in TJI">14" TJI</mat-option>
              <mat-option value="16in TJI">16" TJI</mat-option>
              <mat-option value="12 FT">12" FT</mat-option>
              <mat-option value="14 FT">14" FT</mat-option>
              <mat-option value="16 FT">16" FT</mat-option>
              <mat-option value="18 FT">18" FT</mat-option>
              <mat-option value="20 FT">20" FT</mat-option>
              <mat-option value="24 FT">24" FT</mat-option>
              <mat-option value="Other">Other</mat-option>
              <mat-option value=""></mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
        <label class="mb-auto importanthighlight">Flat Ceilings R-Value</label>
        <a *ngIf="data.pics.flat_ceilings" class="upload-image-wrapper"
        href="javascript:void(0)" (click)="openPhotoViewer(data.pics.flat_ceilings)">
        <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
          src="{{data.pics.flat_ceilings || ''}}">
        </a>
        <input (change)="photoTaken($event, 'flat_ceilings')" type="file" accept="image/*,text/plain" id="pictureinput25"
          style="display: none;" />
        <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput25')">
          <fa-icon [icon]="facamera"></fa-icon>
        </button>
        <!-- <div [hidden]="!data.pics?.flat_ceilings"><button mat-button color="green"
            [hidden]="!data.pics?.flat_ceilings" (click)="viewPic('flat_ceilings')">
            <fa-icon [icon]="facamera"></fa-icon>
          </button></div> -->

        <mat-form-field>
          <mat-select matNativeControl formControlName="flat_ceilings"
            (blur)="updateSingleField('flat_ceilings', true)" id='flat_ceilings'>
            <mat-option value="N/A">N/A</mat-option>
            <mat-option value="R20 Foam">R20 Foam</mat-option>
            <mat-option value="R21 GI">R21 GI</mat-option>
            <mat-option value="R21 GII">R21 GII</mat-option>
            <mat-option value="R21 GIII">R21 GIII</mat-option>
            <mat-option value="R30 GI">R30 GI</mat-option>
            <mat-option value="R30 GII">R30 GII</mat-option>
            <mat-option value="R30 GIII">R30 GIII</mat-option>
            <mat-option value="R38 GI">R38 GI</mat-option>
            <mat-option value="R38 GII">R38 GII</mat-option>
            <mat-option value="R38 GIII">R38 GIII</mat-option>
            <mat-option value="R49 GI">R49 GI</mat-option>
            <mat-option value="R49 GII">R49 GII</mat-option>
            <mat-option value="R49 GIII">R49 GIII</mat-option>
            <mat-option value="Other">Other</mat-option>
            <mat-option value=""></mat-option>
          </mat-select>
        </mat-form-field>
      </div>



      <!--
      <div
        class="flex-section-external-pressure col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
        <mat-label class="mb-auto">Foam Ceiling Average Insulation Depth
        </mat-label>
        <mat-form-field>
          <input matInput formControlName="fcavginsdep" (focus)="setInitialValue('fcavginsdep')" (blur)="updateSingleField('fcavginsdep')" id='fcavginsdep'>
        </mat-form-field>
      </div>
-->


      <div class="col-lg-6 col-12 px-3 pb-3">
        <label class="space-title importanthighlight">Ceiling or Rafter Framing Size (to be covered by insulation)
        </label>
        <mat-form-field>
          <mat-select matNativeControl formControlName="size"  (blur)="updateSingleField('size', true)">
            <mat-option value="2x4">2X4</mat-option>
            <mat-option value="2x6">2X6 </mat-option>
            <mat-option value="2x8">2X8 </mat-option>
            <mat-option value="2x10">2x10 </mat-option>
            <mat-option value="2x12">2x12</mat-option>
            <mat-option value="12 TJI">12 TJI</mat-option>
            <mat-option value="14 TJI">14 TJI</mat-option>
            <mat-option value="16 TJI">16 TJI</mat-option>
            <mat-option value=""></mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-lg-6 col-12 px-3 pb-3">

        <div class="box-border" style="width:98%" id="spacing-div">
          <label class="space-title importanthighlight">Ceiling or Rafter Spacing
          </label>
          <mat-form-field>
            <mat-select matNativeControl formControlName="spacing" (blur)="updateSingleField('spacing',true)">
              <mat-option value="16 OC">16 OC</mat-option>
              <mat-option value="19.2 OC">19.2 OC</mat-option>
              <mat-option value="24 OC">24 OC</mat-option>
              <mat-option value=""></mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">

        <label class="space-title importanthighlight">Vaulted Ceilings R-Value</label>
        <a *ngIf="data.pics.vaulted_ceilings" class="upload-image-wrapper"
        href="javascript:void(0)" (click)="openPhotoViewer(data.pics.vaulted_ceilings)">
        <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
          src="{{data.pics.vaulted_ceilings || ''}}">
        </a>
        <input (change)="photoTaken($event, 'vaulted_ceilings')" type="file" accept="image/*,text/plain" id="pictureinput26"
          style="display: none;" />
        <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput26')">
          <fa-icon [icon]="facamera"></fa-icon>
        </button>
        <div [hidden]="!data.pics?.vaulted_ceilings"><button mat-button color="green"
            [hidden]="!data.pics?.vaulted_ceilings" (click)="viewPic('vaulted_ceilings')">
            <fa-icon [icon]="facamera"></fa-icon>
          </button></div>

        <mat-form-field>
          <mat-select matNativeControl formControlName="vaulted_ceilings" 
            (blur)="updateSingleField('vaulted_ceilings', true)" id='vaulted_ceilings'>
            <mat-option value="NA">N/A</mat-option>
            <mat-option value="R20 Foam">R20 Foam</mat-option>
            <mat-option value ="R22 Foam"> R22 Foam</mat-option>
            <mat-option value ="R25.9 Foam"> R25.9 Foam</mat-option>
            <mat-option value="R30 Foam">R30 Foam</mat-option>
            <mat-option value="R30 I">R30 I</mat-option>
            <mat-option value="R30 II">R30 II</mat-option>
            <mat-option value="R30 III">R30 III</mat-option>
            <mat-option value="R38 I">R38 I</mat-option>
            <mat-option value="R38 II">R38 II</mat-option>
            <mat-option value="R38 III">R38 III</mat-option>
            <mat-option value="R49 GI">R49 GI</mat-option>
            <mat-option value="R49 GII">R49 GII</mat-option>
            <mat-option value="R49 GIII">R49 GIII</mat-option>
            <mat-option value="Other">"Other"></mat-option>
            <mat-option value=""></mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
        <label class="mb-auto importanthighlight">Sloped Ceilings R-Value (adjacent to attic space/unconditioned space)</label>
        <a *ngIf="data.pics.sloped_ceilings" class="upload-image-wrapper"
        href="javascript:void(0)" (click)="openPhotoViewer(data.pics.sloped_ceilings)">
        <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
          src="{{data.pics.sloped_ceilings || ''}}">
        </a>
        <input (change)="photoTaken($event, 'sloped_ceilings')" type="file" accept="image/*,text/plain" id="pictureinput24"
          style="display: none;" />
        <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput24')">
          <fa-icon [icon]="facamera"></fa-icon>
        </button>
        <div [hidden]="!data.pics?.sloped_ceilings"><button mat-button color="green"
            [hidden]="!data.pics?.sloped_ceilings" (click)="viewPic('sloped_ceilings')">
            <fa-icon [icon]="facamera"></fa-icon>
          </button></div>

        <mat-form-field>
          <mat-select matNativeControl formControlName="sloped_ceilings"
            (blur)="updateSingleField('sloped_ceilings', true)" id='sloped_ceilings'>
            <mat-option value="NA">N/A</mat-option>
            <mat-option value="R20 Foam">R20 Foam</mat-option>
            <mat-option value="R30 Foam">R30 Foam</mat-option>
            <mat-option value="R30 I">R30 I</mat-option>
            <mat-option value="R30 II">R30 II</mat-option>
            <mat-option value="R30 III">R30 III</mat-option>
            <mat-option value="R38 I">R38 I</mat-option>
            <mat-option value="R38 II">R38 II</mat-option>
            <mat-option value="R38 III">R38 III</mat-option>
            <mat-option value="R49 GI">R49 GI</mat-option>
            <mat-option value="R49 GII">R49 GII</mat-option>
            <mat-option value="R49 GIII">R49 GIII</mat-option>
            <mat-option value="Other">"Other"></mat-option>
            <mat-option value=""></mat-option>
          </mat-select>
        </mat-form-field>

      </div>

      <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">

        <label class="space-title">Dropped Ceilings/ Soffits, and All Other Ceilings</label>

        <!-- Multi-photo gallery for all_otr_ceilings -->
        <div class="photo-gallery" *ngIf="allOtrCeilingsPhotos && allOtrCeilingsPhotos.length > 0">
          <div *ngFor="let photoUrl of allOtrCeilingsPhotos; let i = index" class="photo-thumbnail-wrapper" style="display: inline-block; margin: 5px;">
            <a href="javascript:void(0)" (click)="openPhotoViewer(photoUrl)">
              <img loading='lazy' class="photo-thumbnail" [src]="photoUrl" alt="Other ceiling photo {{i + 1}}"
                style="max-width: 150px; max-height: 150px; width: auto; height: auto;">
            </a>
            <button style="background-color: red; color: white; border: 0; border-radius: 9px; width: 4em; display: block; margin-top: 5px;"
              (click)="openDeleteModalAllOtrCeilings(photoUrl)" title="Delete Photo">
              <mat-icon style="font-family: 'Roboto';">X</mat-icon>
            </button>
          </div>
        </div>
        <p *ngIf="!allOtrCeilingsPhotos || allOtrCeilingsPhotos.length === 0">No photos uploaded yet.</p>

        <input (change)="photoTaken($event, 'all_otr_ceilings')" type="file" accept="image/*,text/plain" id="pictureinput28"
          style="display: none;" />
        <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput28')">
          <fa-icon [icon]="facamera"></fa-icon>
        </button>


        <mat-form-field>
          <mat-select matNativeControl formControlName="all_otr_ceilings"
            (blur)="updateSingleField('all_otr_ceilings', true)" id='all_otr_ceilings'>
            <mat-option value="Rater Verified">Rater Verified</mat-option>
            <mat-option value="Must Correct">Must Correct</mat-option>
            <mat-option value="N/A">N/A</mat-option>
            <mat-option value=""></mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
        <label class="mb-auto">Ceiling Insulation Accessibility</label>
        <a *ngIf="data.pics.ceilins" class="upload-image-wrapper"
        href="javascript:void(0)" (click)="openPhotoViewer(data.pics.ceilins)">
        <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
          src="{{data.pics.ceilins || ''}}">
        </a>
        <input (change)="photoTaken($event, 'ceilins')" type="file" accept="image/*,text/plain" id="pictureinput27"
          style="display: none;" />
        <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput27')">
          <fa-icon [icon]="facamera"></fa-icon>
        </button>
        <div [hidden]="!data.pics?.ceilins"><button mat-button color="green" [hidden]="!data.pics?.ceilins"
            (click)="viewPic('ceilins')">
            <fa-icon [icon]="facamera"></fa-icon>
          </button></div>


        <mat-form-field>
          <mat-select matNativeControl formControlName="ceilins" (blur)="updateSingleField('ceilins', true)"
            id='ceilins'>
            <mat-option class="inCeil" style="font-size: 12px !important;" value="There are no inaccessible ceilings">No inaccessible
              ceilings</mat-option>
            <mat-option class="inCeil" style="font-size: 12px !important;" value="There are inaccessible ceilings and they are batted">Batted
              inacessible ceilings</mat-option>
            <mat-option class="inCeil" style="font-size: 12px !important;" value="There are inaccessible ceilings that must be checked at final">
              Inaccessible ceilings that must be checked at final</mat-option>
            <mat-option class="inCeil" style="font-size: 12px !important;" value="Other">Other</mat-option>
            <mat-option value=""></mat-option>
          </mat-select>
        </mat-form-field>


      </div>
      <div class="col-lg-6 col-12 px-3 pb-3">
        <mat-label>Ceiling Insulation Notes <span style="color: #9e9e9e; font-weight: 400; font-size: 0.85em;">(Approx Sqft, Grade, R value, Framing/Spacing of each other ceiling)</span></mat-label>
        <textarea rows=6 formControlName="ceilins_notes" (focus)="setInitialValue('ceilins_notes')" (blur)="updateSingleField('ceilins_notes')"
          id='ceilins_notes'>
        </textarea>
      </div>

      <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">

        <label class="space-title">Kneewall R Value</label>
        <a *ngIf="data.pics.knee_walls" class="upload-image-wrapper"
        href="javascript:void(0)" (click)="openPhotoViewer(data.pics.knee_walls)">
        <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
          src="{{data.pics.knee_walls || ''}}">
        </a>
        <input (change)="photoTaken($event, 'knee_walls')" type="file" accept="image/*,text/plain" id="pictureinput30"
          style="display: none;" />
        <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput30')">
          <fa-icon [icon]="facamera"></fa-icon>
        </button>
        <div [hidden]="!data.pics?.knee_walls"><button mat-button color="green"
            [hidden]="!data.pics?.knee_walls" (click)="viewPic('knee_walls')">
            <fa-icon [icon]="facamera"></fa-icon>
          </button></div>

        <mat-form-field>
          <mat-select matNativeControl formControlName="knee_walls" (blur)="updateSingleField('knee_walls', true)"
            id='knee_walls'>
            <mat-option value="NA">N/A</mat-option>
            <mat-option value="R13 I">R13 I</mat-option>
            <mat-option value="R13 II">R13 II</mat-option>
            <mat-option value="R13 III">R13 III</mat-option>
            <mat-option value="R15 I">R15 I</mat-option>
            <mat-option value="R15 II">R15 II</mat-option>
            <mat-option value="R15 III">R15 III</mat-option>
            <mat-option value="R19 I">R19 I</mat-option>
            <mat-option value="R19 II">R19 II</mat-option>
            <mat-option value="R19 III">R19 III</mat-option>
            <mat-option value="R21 I">R21 I</mat-option>
            <mat-option value="R21 II">R21 II</mat-option>
            <mat-option value="R21 III">R21 III</mat-option>
            <mat-option value="R13 13 + 13 dble walls">R13 13 + 13 dble walls</mat-option>
            <mat-option value="R15 13 + 13 dble walls">R15 13 + 13 dble walls</mat-option>
            <mat-option value="R19 13 + 13 dble walls">R19 13 + 13 dble walls</mat-option>
            <mat-option value="R13 15 + 15 dble walls">R13 15 + 15 dble walls</mat-option>
            <mat-option value="R15 15 + 15 dble walls">R15 15 + 15 dble walls</mat-option>
            <mat-option value="R19 15 + 15 dble walls">R19 15 + 15 dble walls</mat-option>
            <mat-option value="R13 13 + 19 dble walls">R13 13 + 19 dble walls</mat-option>
            <mat-option value="R15 13 + 19 dble walls">R15 13 + 19 dble walls</mat-option>
            <mat-option value="R19 13 + 19 dble walls">R19 13 + 19 dble walls</mat-option>
            <mat-option value="R13 15 + 19 dble walls">R13 15 + 19 dble walls</mat-option>
            <mat-option value="R15 15 + 19 dble walls">R15 15 + 19 dble walls</mat-option>
            <mat-option value="R19 15 + 19 dble walls">R19 15 + 19 dble walls</mat-option>
            <mat-option value="Other">"Other"></mat-option>
            <mat-option value=""></mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
        <label class="space-title">Kneewall Sheathing</label>
        <a *ngIf="data.pics.kneesheath" class="upload-image-wrapper"
        href="javascript:void(0)" (click)="openPhotoViewer(data.pics.kneesheath)">
        <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
          src="{{data.pics.kneesheath || ''}}">
        </a>
        <input (change)="photoTaken($event, 'kneesheath')" type="file" accept="image/*,text/plain" id="pictureinput31"
          style="display: none;" />
        <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput31')">
          <fa-icon [icon]="facamera"></fa-icon>
        </button>
        <div [hidden]="!data.pics?.kneesheath"><button mat-button color="green"
            [hidden]="!data.pics?.kneesheath" (click)="viewPic('kneesheath')">
            <fa-icon [icon]="facamera"></fa-icon>
          </button></div>

        <mat-form-field>
          <mat-select matNativeControl formControlName="kneesheath"
            (blur)="updateSingleField('kneesheath', true)">
            <mat-option value="TPly">TPly</mat-option>
            <mat-option value="House Wrap">House Wrap</mat-option>
            <mat-option value="OSB">OSB</mat-option>
            <mat-option value='R3 (0.5") rigid'>R3 (0.5") rigid</mat-option>
            <mat-option value='R5 (1") rigid'>R5 (1") rigid</mat-option>
            <mat-option value="None">None</mat-option>
            <mat-option value=""></mat-option>
          </mat-select>
        </mat-form-field>
      </div>



      <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
        <label class="space-title">Kneewall Framing Size</label>
        <a *ngIf="data.pics.kneewallfs" class="upload-image-wrapper"
        href="javascript:void(0)" (click)="openPhotoViewer(data.pics.kneewallfs)">
        <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
          src="{{data.pics.kneewallfs || ''}}">
        </a>
        <input (change)="photoTaken($event, 'kneewallfs')" type="file" accept="image/*,text/plain" id="pictureinput81"
          style="display: none;" />
        <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput81')">
          <fa-icon [icon]="facamera"></fa-icon>
        </button>
        <div [hidden]="!data.pics?.kneewallfs"><button mat-button color="green"
            [hidden]="!data.pics?.kneewallfs" (click)="viewPic('kneewallfs')">
            <fa-icon [icon]="facamera"></fa-icon>
          </button></div>

        <mat-form-field>
          <mat-select matNativeControl formControlName="kneewallfs"
            (blur)="updateSingleField('kneewallfs', true)">
            <mat-option value="2x4">2x4</mat-option>
            <mat-option value="Dbl 2x4">Dbl 2x4</mat-option>
            <mat-option value="2x6">2x6</mat-option>
            <mat-option value="Dbl 2x6">Dbl 2x6</mat-option>
            <mat-option value="Dbl 2x4/2x6">Dbl 2x4/2x6</mat-option>
            <mat-option value="2x8">2x8</mat-option>
            <mat-option value=""></mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
        <label class="space-title">"Kneewall Spacing</label>
        <a *ngIf="data.pics.kneewallsp" class="upload-image-wrapper"
        href="javascript:void(0)" (click)="openPhotoViewer(data.pics.kneewallsp)">
        <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
          src="{{data.pics.kneewallsp || ''}}">
        </a>
        <input (change)="photoTaken($event, 'kneewallsp')" type="file" accept="image/*,text/plain" id="pictureinput82"
          style="display: none;" />
        <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput82')">
          <fa-icon [icon]="facamera"></fa-icon>
        </button>
        <div [hidden]="!data.pics?.kneewallsp"><button mat-button color="green"
            [hidden]="!data.pics?.kneewallsp" (click)="viewPic('kneewallsp')">
            <fa-icon [icon]="facamera"></fa-icon>
          </button></div>

        <mat-form-field>
          <mat-select matNativeControl formControlName="kneewallsp"
            (blur)="updateSingleField('kneewallsp', true)">
            <mat-option value="16oc"> 16oc </mat-option>
            <mat-option value="19.2oc"> 19.2oc </mat-option>
            <mat-option value="24oc"> 24oc </mat-option>
            <mat-option value=""></mat-option>
          </mat-select>
        </mat-form-field>
      </div>



      <div class="d-flex flex-wrap row">


        <div class="col-lg-6 col-12 px-3 pb-3">
          <label class="space-title">Attic Doors Insulation</label>
          <mat-radio-group class="mat-radio-grid" formControlName="atticdoorins" (change)="updateSingleField('atticdoorins')"
            id='atticdoorins' class="mat-radio-grid">
            <mat-radio-button value='R5- 1-1/8" Code Required'>R5- 1-1/8" Code Req'd
            </mat-radio-button>
            <mat-radio-button value="Uninsulated Panel">Uninsulated Panel</mat-radio-button>
            <button (click)= "clearOut('atticdoorins')" class='radioClearButton' *ngIf="raterform.get('atticdoorins').value.length > 1"> Clear</button>

          </mat-radio-group>
        </div>

        <div class="col-lg-6 col-12 px-3 pb-3">
          <label class="space-title">Additional Door Insulation</label>
          <mat-radio-group class="mat-radio-grid" formControlName="adddoorins" (change)="updateSingleField('adddoorins')"
            id='adddoorins' class="mat-radio-grid">
            <mat-radio-button value='R5- 1" foam'>R5- 1" foam</mat-radio-button>
            <mat-radio-button value='R10- 2" foam'>R10- 2" foam</mat-radio-button>
            <mat-radio-button value='R13-wrapped batt'>R13-wrapped batt</mat-radio-button>
            <mat-radio-button value='R15-wrapped batt'>R15-wrapped batt</mat-radio-button>
            <button (click)= "clearOut('adddoorins')" class='radioClearButton' *ngIf="raterform.get('adddoorins').value.length > 1"> Clear</button>

          </mat-radio-group>
        </div>

      </div>

      <div class="col-lg-6 col-12 px-3 pb-3">


        <label class="space-title">Foundation Type</label>
        <a *ngIf="data.pics.foundation_type" class="upload-image-wrapper"
        href="javascript:void(0)" (click)="openPhotoViewer(data.pics.foundation_type)">
        <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
          src="{{data.pics.foundation_type || ''}}">
        </a>
        <input (change)="photoTaken($event, 'foundation_type')" type="file" accept="image/*,text/plain" id="pictureinput37"
          style="display: none;" />
        <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput37')">
          <fa-icon [icon]="facamera"></fa-icon>
        </button>
        <div [hidden]="!data.pics?.foundation_type"><button mat-button color="green"
            [hidden]="!data.pics?.foundation_type" (click)="viewPic('foundation_type')">
            <fa-icon [icon]="facamera"></fa-icon>
          </button></div>

        <mat-form-field>
          <mat-select matNativeControl formControlName="foundation_type"
            (blur)="updateSingleField('foundation_type', true)" id='foundation_type'>
            <mat-option value="NA">N/A</mat-option>
            <mat-option value="Another Unit">Another Unit</mat-option>
            <mat-option value="Cond BSMT W/Slab Ins"> Cond BSMT W/Slab Ins</mat-option>
            <mat-option value="Cond BSMT W/Unins Slab"> Cond BSMT W/Unins Slab</mat-option>
            <mat-option value="Cond Crawl">Cond Crawl</mat-option>
            <mat-option value="Conditioned Crawl-CMU and Framed Walls">Conditioned Crawl-CMU and Framed Walls
            </mat-option>
            <mat-option value="Ins Slab">Ins Slab</mat-option>
            <mat-option value="Multiple">Multiple</mat-option>
            <mat-option value="Other">Other</mat-option>
            <mat-option value="Superior Walls">Superior Walls</mat-option>
            <mat-option value="Uncon Bsmt">Uncon Bsmt</mat-option>
            <mat-option value="Unins Slab">Unins Slab</mat-option>
            <mat-option value="Vented Crawl">Vented Crawl</mat-option>
            <mat-option value=""></mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
        <label class="space-title importanthighlight">Slab or Foundation Walls R-Value</label>
        <a *ngIf="data.pics.fdn_r" class="upload-image-wrapper"
        href="javascript:void(0)" (click)="openPhotoViewer(data.pics.fdn_r)">
        <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
          src="{{data.pics.fdn_r || ''}}">
        </a>
        <input (change)="photoTaken($event, 'fdn_r')" type="file" accept="image/*,text/plain" id="pictureinput38"
          style="display: none;" />
        <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput38')">
          <fa-icon [icon]="facamera"></fa-icon>
        </button>
        <div [hidden]="!data.pics?.fdn_r"><button mat-button color="green" [hidden]="!data.pics?.fdn_r"
            (click)="viewPic('fdn_r')">
            <fa-icon [icon]="facamera"></fa-icon>
          </button></div>

        <mat-form-field>
          <mat-select matNativeControl formControlName="fdn_r"  (blur)="updateSingleField('fdn_r', true)" id='fdn_r'>
            <mat-option value = "N.A.">N.A.</mat-option>
            <mat-option value = "TBD">TBD</mat-option>
            <mat-option value = "R0">R0 (i.e. Uninsulated slab foundation)</mat-option>
            <mat-option value = "R5 Cont">R5 Cont</mat-option>
            <mat-option value = "R10 Cont">R10 Cont</mat-option>
            <mat-option value = "R11 Cont">R11 Cont</mat-option>
            <mat-option value = "R13 Cont">R13 Cont</mat-option>
            <mat-option value = "R5 Continuous + R15 G1 Cavity">R5 Continuous + R15 G1 Cavity</mat-option>
            <mat-option value = "R5 Continuous + R15 G2 Cavity">R5 Continuous + R15 G2 Cavity</mat-option>
            <mat-option value = "R5 Continuous + R19 G1 Cavity">R5 Continuous + R19 G1 Cavity</mat-option>
            <mat-option value = "R5 Continuous + R19 G2 Cavity">R5 Continuous + R19 G2 Cavity</mat-option>
            <mat-option value = "R10 Continuous + R15 G1 Cavity">R10 Continuous + R15 G1 Cavity</mat-option>
            <mat-option value = "R10 Continuous + R15 G2 Cavity">R10 Continuous + R15 G2 Cavity</mat-option>
            <mat-option value = "R10 Continuous + R19 G1 Cavity">R10 Continuous + R19 G1 Cavity</mat-option>
            <mat-option value = "R10 Continuous + R19 G2 Cavity">R10 Continuous + R19 G2 Cavity</mat-option>
            <mat-option value = "R11 Continuous + R15 G1 Cavity">R11 Continuous + R15 G1 Cavity</mat-option>
            <mat-option value = "R11 Continuous + R15 G2 Cavity">R11 Continuous + R15 G2 Cavity</mat-option>
            <mat-option value = "R11 Continuous + R19 G1 Cavity">R11 Continuous + R19 G1 Cavity</mat-option>
            <mat-option value = "R11 Continuous + R19 G2 Cavity">R11 Continuous + R19 G2 Cavity</mat-option>
            <mat-option value = "R13 Continuous + R15 G1 Cavity">R13 Continuous + R15 G1 Cavity</mat-option>
            <mat-option value = "R13 Continuous + R15 G2 Cavity">R13 Continuous + R15 G2 Cavity</mat-option>
            <mat-option value = "R13 Continuous + R19 G1 Cavity">R13 Continuous + R19 G1 Cavity</mat-option>
            <mat-option value = "R13 Continuous + R19 G2 Cavity">R13 Continuous + R19 G2 Cavity</mat-option>
            <mat-option value = "R10 Horizontal">R10 Horizontal </mat-option>
            <mat-option value = "R11 16OC">R11 16OC </mat-option>
            <mat-option value = "R13 16OC">R13 16OC </mat-option>
            <mat-option value = "R15 16OC">R15 16OC </mat-option>
            <mat-option value = "R30 Foam">R30 Foam</mat-option>
            <option value = "Superior Walls">Superior Walls </option>
            <mat-option value = "R13 Framed">R13 Framed</mat-option>
            <mat-option value = "R13 Double Framed">R13 Double Framed</mat-option>
            <mat-option value = "R15 Framed">R15 Framed</mat-option>
            <mat-option value = "R15 Double Framed">R15 Double Framed</mat-option>
            <mat-option value = "R19/R13 Double Framed">R19/R13 Double Framed</mat-option>
            <mat-option value = "R19/R15 Double Framed">R19/R15 Double Framed</mat-option>
            <mat-option value = "Closed Cell">Closed Cell (specify depth in notes)</mat-option>
            <mat-option value = "Superior Xi-15">Superior Xi-15</mat-option>
            <mat-option value = "Superior Xi">Superior Xi</mat-option>
            <mat-option value = "Other">Other (explain)</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-lg-6 col-12 px-3 pb-3">
        <label class="space-title">Garage Slab Insulated?
        </label>
        <mat-form-field>
          <mat-select matNativeControl formControlName="garslabins"
            (blur)="updateSingleField('garslabins',true)">
            <mat-option value="Yes">Yes</mat-option>
            <mat-option value="No">No</mat-option>
            <mat-option value=""></mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-lg-6 col-12 px-3 pb-3">
        <label class="space-title">Porch/Patio Slab Insulated?
        </label>
        <mat-form-field>
          <mat-select matNativeControl formControlName="prchpatins"
            (blur)="updateSingleField('prchpatins',true)">
            <mat-option value="Yes">Yes</mat-option>
            <mat-option value="No">No</mat-option>
            <mat-option value=""></mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-lg-6 col-12 px-3 pb-3">
        <label class="space-title">Foundation Wall Framing Spacing
        </label>
        <mat-form-field>
          <mat-select matNativeControl formControlName="fndwallspa"
            (blur)="updateSingleField('fndwallspa',true)">
            <mat-option value="16 OC">16 OC</mat-option>
            <mat-option value="19.2 OC">19.2 OC</mat-option>
            <mat-option value="24 OC">24 OC</mat-option>
            <mat-option value=""></mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-lg-6 col-12 px-3 pb-3">
        <label class="space-title">Partition Wall Sheathing
        </label>
        <mat-form-field>
          <mat-select matNativeControl formControlName="parwallshe"
            (blur)="updateSingleField('parwallshe',true)">
            <mat-option value = "Drywall"> Drywall </mat-option>
            <mat-option value = "Wrap"> Wrap </mat-option>
            <mat-option value = "OSB"> OSB </mat-option>
            <mat-option value = "Tply"> Tply </mat-option>
            <mat-option value = "Other"> Other(explain) </mat-option>
            <mat-option value=""></mat-option>
          </mat-select>
        </mat-form-field>
      </div>


      <div class="col-lg-6 col-12 px-3 pb-3">
        <label class="space-title">Conditioned Crawl Drying Method
        </label>
        <mat-form-field>
          <mat-select matNativeControl formControlName="cndcrwldry"
            (blur)="updateSingleField('cndcrwldry',true)">
            <mat-option value = "Supply"> Supply </mat-option>
            <mat-option value = "Supply/Return"> Supply/Return </mat-option>
            <mat-option value = "Dehumidifier"> Dehumidifier </mat-option>
            <mat-option value = "Hatch to House"> Hatch to House </mat-option>
            <mat-option value=""></mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-lg-6 col-12 px-3 pb-3">
        <mat-label>Foundation Notes</mat-label>
        <textarea rows=6 formControlName="fdn_notes" (focus)="setInitialValue('fdn_notes')" (blur)="updateSingleField('fdn_notes')"></textarea>
      </div>

      <div class="col-lg-6 col-12 px-3 pb-3">
        <label class="space-title importanthighlight">1st Floor R-Value</label>
        <a *ngIf="data.pics._1st_floor" class="upload-image-wrapper"
        href="javascript:void(0)" (click)="openPhotoViewer(data.pics._1st_floor)">
        <img loading='lazy' style="max-width: 100%; max-height: 100%; width: auto; height: auto;" mat-card-image
          src="{{data.pics._1st_floor || ''}}">
        </a>
        <input (change)="photoTaken($event, '_1st_floor')" type="file" accept="image/*,text/plain" id="pictureinput39"
          style="display: none;" />
        <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput39')">
          <fa-icon [icon]="facamera"></fa-icon>
        </button>
        <div [hidden]="!data.pics?._1st_floor"><button mat-button color="green"
            [hidden]="!data.pics?._1st_floor" (click)="viewPic('_1st_floor')">
            <fa-icon [icon]="facamera"></fa-icon>
          </button></div>

        <mat-form-field>
          <mat-select matNativeControl formControlName="_1st_floor" (blur)="updateSingleField('_1st_floor', true)"
            id='_1st_floor'>
            <mat-option value="N/A">N/A</mat-option>
            <mat-option value="R19 I"> R19 I</mat-option>
            <mat-option value="R19 II">R19 II</mat-option>
            <mat-option value="R19 III">R19 III</mat-option>
            <mat-option value="R30 I">R30 I</mat-option>
            <mat-option value="R30 II">R30 II</mat-option>
            <mat-option value="R30 III">R30 III</mat-option>
            <mat-option value="Other">Other</mat-option>
            <mat-option value=""></mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-lg-6 col-12 px-3 pb-3">

        <label class="space-title">1st Floor Framing Spacing
        </label>
        <mat-form-field>
          <mat-select matNativeControl formControlName="ffspacing" (blur)="updateSingleField('ffspacing',true)">
            <mat-option value="12 OC">12 OC</mat-option>
            <mat-option value="16 OC">16 OC</mat-option>
            <mat-option value="19.2 OC">19.2 OC</mat-option>
            <mat-option value="24 OC">24 OC</mat-option>
            <mat-option value=""></mat-option>
          </mat-select>
        </mat-form-field>

      </div>

      <div class="col-lg-6 col-12 px-3 pb-3">
        <label class="space-title">1st Floor Joist Height
        </label>
        <mat-form-field>
          <mat-select matNativeControl formControlName="frstflrjoi"
            (blur)="updateSingleField('frstflrjoi',true)">
            <mat-option value = "x10">x10</mat-option>
            <mat-option value = "x12">x12</mat-option>
            <mat-option value = "12in TJI">12"TJI</mat-option>
            <mat-option value = "14in TJI">14"TJI</mat-option>
            <mat-option value = "16in TJI">16"TJI</mat-option>
            <mat-option value = "12 FT">12" Floor Truss</mat-option>
            <mat-option value = "14 FT">14" Floor Truss</mat-option>
            <mat-option value = "16 FT">16" Floor Truss</mat-option>
            <mat-option value = "18 FT">18" Floor Truss</mat-option>
            <mat-option value = "20 FT">20" Floor Truss</mat-option>
            <mat-option value = "22 FT">22" Floor Truss</mat-option>
            <mat-option value = "24 FT">24" Floor Truss</mat-option>
            <mat-option value=""></mat-option>
          </mat-select>
        </mat-form-field>
      </div>

        <!--

        <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
          <mat-label class="space-title">Band Height
          </mat-label>
          <mat-form-field>
            <input matInput formControlName="bandheight" (focus)="setInitialValue('bandheight')" (blur)="updateSingleField('bandheight')" id='bandheight'>
          </mat-form-field>
        </div>
-->

<!--

          <div
            class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start flex-section-external-pressure">
            <mat-label class="formLabel">
              Rafter Depth
            </mat-label>
            <mat-form-field>
              <input matInput formControlName="avgfdraftr" (focus)="setInitialValue('avgfdraftr')" (blur)="updateSingleField('avgfdraftr', true)">
            </mat-form-field>
          </div>
-->






          <div class="clearfix"></div>

        </div>
        <!--RF= radio group -->





      </div>
      <div class="tab-content" id="item6" [hidden]="selectedItem != 6">


        <div class="col-lg-6 col-12 px-lg-3 px-3 pb-3 d-flex flex-column">
          <label>Contact Support</label>
          <textarea rows=6 #supportNotes id='supportNotes' value="" placeholder="Let us know of any errors, questions or comments you may have regarding the site"></textarea>
        </div>

        <div style="display: flex; flex-direction: column; align-items: baseline; gap: 12px;">
          
         <div>
            <div>
              <button class="mr-2" mat-button (click)="sendSupportEmail()" style="background-color: red"
              title="Send to tech support.">Send Email</button>
            </div>

            <div>
              <button (click)="downloadFormData()" style="color: black;
              height: 40px;
              border: 0;
              border-radius: 7px;">Download FormData</button>
            </div>
          </div>

          <!--
          <div>
            <span><label>Full Resolution Images</label></span>
            <label class="switch">
              <input type="checkbox" (click)='toggleImageMode()'>
              <span class="slider round"></span>
            </label>
            </div>
          -->

        </div>

        <div *ngIf="multifamilyLoaded">
          <!--{{multifamilyData | json}}-->
          <div>
          <div *ngFor = "let obj of photoObj" style="    border: 1px solid black;
          padding: 20px;
          margin-top: 10px;
          text-align-last: center;">
              <label>{{obj.label}}</label>
              <img src="{{obj.photo}}" style="width: 40%; height: auto;"/>
          </div>
        </div>
        </div>

      <div id="photoUploadProgress" style="background: white;color: #424242; padding: 1em;">

          <h4 >Photo Upload Progress</h4>
          <div *ngFor="let entry of uploadProgress | keyvalue">
            <p *ngIf="entry.value < 100 && entry.value >=0" style="text-align: left; font-weight: 500;margin: 1em;">{{ entry.key }}.jpg – {{ entry.value }}%</p>
            <p *ngIf="entry.value == 100" style="text-align: left; font-weight: 500;margin: 1em; color: #8bc34a;">{{ entry.key }}.jpg – Complete.</p>
            <p *ngIf="entry.value == -1" style="text-align: left; font-weight: 500;margin: 1em; color: red;">{{ entry.key }}.jpg – Error Uploading: {{ uploadErrors[entry.key] }}</p>
          </div>

      </div>


      </div>



      <div class="tab-content" id="item7" [hidden]="selectedItem != 7" *ngIf="mftemplateid > 0">

        <h4>Template: {{templateName}}</h4>

        <app-dynamic-form *ngIf="mfSelected" [componentInstance]="this" [canvas]="canvas" [image]="image" [formFields]="formFields | async"></app-dynamic-form>

      </div>






<!--HVAC Grading-->


<div class="tab-content" id="item9" [hidden]="selectedItem != 9">

        <div *ngIf="showHvacSpecs" style="justify-content: center;
        display: flex;
        align-items: center;
        text-align-last: left;">
          <div class="d-flex flex-wrap row row" style="margin-top: 20px;
          margin-bottom: 20px;
          width: 95%;">
            <h3 class="collapseButton"><span>HVAC Grading Instructions</span> </h3>
            <div class="content" style="text-align: left">
              <pre style="white-space:pre-wrap">{{hvacSpecs}}</pre>
            </div>
          </div>
        </div>

  <div class="col-lg-6 col-12 px-lg-3 px-3 pb-3 d-flex flex-column">
    <p style="
    line-height: 1em;
    text-align: left;">HVAC Grading - {{ isPDWI ? 'Rough' : isFinal ? 'Final' : '' }}</p>
    <div style="display: flex;
    justify-content: space-evenly;
    padding-top: 1em;">
      <button style="border: 0;
      background: #76ae2c;
      color: white;
      height: 3em;
      padding-left: 1em;
      padding-right: 1em;
      border-radius: 0.25em;
      margin-right: 2em;" *ngIf="raterform.get('hvac1name').value.length > 1" (click)="setSysNo(1)">{{ raterform.get('hvac1name').value }}</button>

      <button style="border: 0;
      background: #76ae2c;
      color: white;
      height: 3em;
      padding-left: 1em;
      padding-right: 1em;
      border-radius: 0.25em;
      margin-right: 2em;" *ngIf="raterform.get('hvac2name').value.length > 1" (click)="setSysNo(2)">{{ raterform.get('hvac2name').value }}</button>

      <button style="border: 0;
      background: #76ae2c;
      color: white;
      height: 3em;
      padding-left: 1em;
      padding-right: 1em;
      border-radius: 0.25em;
      margin-right: 2em;" *ngIf="raterform.get('hvac3name').value.length > 1" (click)="setSysNo(3)">{{ raterform.get('hvac3name').value }}</button>

      <button style="border: 0;
      background: #76ae2c;
      color: white;
      height: 3em;
      padding-left: 1em;
      padding-right: 1em;
      border-radius: 0.25em;
      margin-right: 2em;" *ngIf="raterform.get('hvac4name').value.length > 1" (click)="setSysNo(4)">{{ raterform.get('hvac4name').value }}</button>

    </div>

    <div>

        <div>
        <p style="font-size: 3em;
        line-height: 1em;
        padding-top: 1em;
        color: #4f4f4f;
        font-weight: 300;
        letter-spacing: -0.01em;
        text-align: left;"
        >{{ getGradeValue('hvac', systemNo) }}</p>
        </div>
        
        <div style="padding-left: 2em;
        padding-top: 2em;
        padding-bottom: 2em;">
          <div style="font-weight: 300;
          color: #4f4f4f;
          letter-spacing: -0.01em;">
            <p style="text-align: left;padding-bottom: 0.25em;">Current Total Leakage {{ getGradeValue('totalleakage', systemNo) }}%</p>
            <p style="text-align: left;padding-bottom: 0.25em;">Number of Returns {{ getGradeValue('returns', systemNo) }}</p>
          </div>

          <div>
            <p style="text-align: left;text-decoration: underline;padding-top: 1em;">Targets for this system</p>
            <div style="font-weight: 300;
            color: #4f4f4f;
            letter-spacing: -0.01em;">
              <p style="text-align: left;padding-bottom: 0.25em;">Total Leakage: {{leakageTarget}}%</p> 
              <p style="text-align: left;padding-bottom: 0.25em;" *ngIf="curr_sys_grading_stagedone.toLowerCase().includes('rough-in') && hvac_1_area < 1000">For System Under 1000 SF: {{ getGradeValue('returns', systemNo) < 3 ? '40cfm' : '60cfm' }}</p>   
              <p style="text-align: left;padding-bottom: 0.25em;" *ngIf="!curr_sys_grading_stagedone.toLowerCase().includes('rough-in') && hvac_1_area < 1000">For System Under 1000 SF: {{ getGradeValue('returns', systemNo) < 3 ? '80cfm' : '120cfm' }}</p>
            </div>
          </div>
        </div>

          <div>


                        <!-- Checkbox for Manual Calculation -->
                        <div style="padding-top: 2em;">
                          <mat-checkbox style="margin-left: 0.5em" formControlName="manualcalc" (change)="toggleManualCalc($event, systemNo);changeCurrentGradeValue(raterform.get('manualcalc').value,'manualcalc', systemNo);">
                            <span style="color: #9e9e9e;margin-left:1em;">Use Manual Calculation</span>
                          </mat-checkbox>
                        </div>
            
                        <!-- Manual Design Input or Tonnage Dropdown -->
                        <div style="padding-top: 2em;">
                          <div *ngIf="!raterform.get('manualcalc').value" style="display: flex; gap: 1em; align-items: flex-start;">
                            <mat-form-field style="width: 45%;">
                              <mat-label style="color: #4f4f4f;">CFM/Ton</mat-label>
                              <mat-select formControlName="cfm_per_ton" (selectionChange)="changeCurrentGradeValue($event.value, 'cfmPerTon', systemNo);">
                                <mat-option [value]="400">400 CFM/ton</mat-option>
                                <mat-option [value]="350">350 CFM/ton</mat-option>
                              </mat-select>
                            </mat-form-field>
                            <mat-form-field style="width: 55%;">
                              <mat-label style="color: #4f4f4f;"> Tonnage <span><svg id="tonnage" class="svgHidden" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" >
  <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
</svg></span>
</mat-label>
                              <mat-select formControlName="tonnage" (selectionChange)="changeCurrentGradeValue(raterform.get('tonnage').value,'tonnage', systemNo);">
                                <mat-option *ngFor="let tonnage of tonnageTable" [value]="tonnage.tonnage">
                                  {{tonnage.tonnage}} tons
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
            
                          <div *ngIf="raterform.get('manualcalc').value">
                            <mat-form-field style="width:100%">
                              <mat-label style="color: #4f4f4f;"> Manual Design Airflow <span><svg id="manualdesign" class="svgHidden" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" >
  <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
</svg></span>
</mat-label>
                              <input matInput formControlName="manualdesign" (change)=" updateManualBounds();changeCurrentGradeValue(raterform.get('manualdesign').value,'manualdesign', systemNo);" placeholder="Enter Manual Design" type="number" step="0.01">
                            </mat-form-field>
                          </div>
                        </div>
            


                        <div style="padding-top: 2em;">
                          <!--Select with 3 options-->
                          <mat-form-field>
                            <mat-label style="color: #4f4f4f;">Airflow Testing Mode<span><svg id="airflowtestmode" class="svgHidden" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" >
  <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
</svg></span>
</mat-label>
                            <mat-select formControlName="airflowtestmode" 
                            (selectionChange)="changeCurrentGradeValue( raterform.get('airflowtestmode').value,
                            'airflowtestmode', systemNo); calculateOzNeeded(); ">
                              <mat-option value='Heating'>Heating</mat-option>
                              <mat-option value='Cooling'>Cooling</mat-option>
                            </mat-select>
                            </mat-form-field>
                        </div>






           <div>
            <p style="font-size: 2em;
            line-height: 1em;
            color: #4f4f4f;
            padding-top: 1em;
            text-align:left;">Locations</p>

            <div>
              <p style="padding-bottom: 2em;
              font-size: 1em;
              font-weight: 300;
              letter-spacing: -0.02em;
              color: #424242;
              text-align: left;">Enter the measured areas below, along with the cfm. Add locations as necessary. </p>
            </div>





            <!-- Input Section -->
            <div style="display: flex;
            flex-direction: column;">


              <div>
                <mat-form-field appearance="outline" style="border: 1px solid #d8d3d3;
                border-radius: 10px;">
                  <mat-label style="color: #4f4f4f;">Location Name</mat-label>
                  <input matInput formControlName = "locationName"  placeholder="Enter location name" />
                  <p>{{ locationName }}</p>
                </mat-form-field>
              </div>

              <div style="padding-top: 1em;">
                <mat-form-field appearance="outline" style="border: 1px solid #d8d3d3;
                border-radius: 10px;">
                  <mat-label style="color: #4f4f4f;">Air Flow (cfm)</mat-label>
                  <input matInput  formControlName = "airFlow"  placeholder="Enter airflow" />
                </mat-form-field>
              </div>

              <div *ngIf="!isAreaValid()" style="padding-top: 2em;">
                <button mat-raised-button style="color: #6d6c6c !important;
                width: 100%;
                background: #dedddd !important;" disabled>Enter the Location AND airflow above to add it.</button>
              </div>
              <div *ngIf="isAreaValid()" style="padding-top: 2em;">
                <p class="blink-reminder" style="color: red; font-weight: bold; text-align: center; margin-bottom: 5px;">Don't forget to hit Add!</p>
                <button mat-raised-button color="primary" (click)="addGradeLocation(systemNo);" style="width:100%" >Add</button>
              </div>


            </div>

            <!-- Display List Section -->
            <div *ngIf="currentGrade?.syslocs.length > 0" style="padding-top: 2em;">
              <table style="color: #4f4f4f">
                <thead>
                  <tr>
                    <th>Location Name</th>
                    <th>Air Flow (cfm)</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let loc of currentGrade?.syslocs; let i = index">
                    <td>{{ loc.name }}</td>
                    <td>{{ loc.airflow }}</td>
                    <td>
                      <button mat-button color="warn" (click)="removeLocation(i)">Remove</button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <p style="padding-top: 2em;">Total Airflow: {{ getGradingTotalAirflow(systemNo) }} cfm</p>

              <!--Warnings-->
  
              <p *ngIf="!raterform.get('manualcalc').value ||
              raterform.get('manualcalc').value == false " style="color: #76ae2c;">{{getAirflowGrade(raterform.get('tonnage').value, getGradingTotalAirflow(systemNo), false )}}</p>


              <p *ngIf="raterform.get('manualcalc').value" style="color: #76ae2c;">{{getAirflowGrade(raterform.get('manualdesign').value, getGradingTotalAirflow(systemNo), true )}}</p>

              <p style="color: lightgrey; ">{{ this.rangeText }}</p>

              <!-- Display Allowable Range -->
               <!--
                <div *ngIf="!raterform.get('manualcalc').value && currentGrade?.tonnage">
                  <p style="color: #9e9e9e;">Allowable Range: {{ getLowerBound(currentGrade.tonnage) }} - {{ getUpperBound(currentGrade.tonnage) }} cfm</p>
                </div>
               -->

              
            </div>


            <div style="padding-top: 4em;">
              <label style="color: #4f4f4f !important; font-size: 1.25em;">Airflow Report (PDF or Image)<span><svg id="airflowReport" class="svgHidden" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" >
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                </svg></span>
              </label>
              <input (change)="gradingPdfUpload($event, 'airflowReport', systemNo)" type="file" accept="application/pdf,image/*" id="airflowReportInput" style="display: none;" />
              <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('airflowReportInput')">
                Upload Report
              </button>
              <div *ngIf="getGradeValue('airflowReport', systemNo)" style="padding-top: 1em;padding-bottom: 2em; ">
                <a [href]="getGradeValue('airflowReport', systemNo)" target="_blank" rel="noopener noreferrer" style="color: #76ae2c; font-size: 1.1em;">View Report</a>
              </div>
            </div>

            <!--Watt Draw add 3 inputs for volts, amp, and watts-->
            <div style="padding-top: 4em;" >

            <div style="display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            padding-top: 2em;">
              <div>
                <div style="display: flex; align-items: center; gap: 1em; flex-wrap: wrap;">
                <mat-label style="color: #4f4f4f;">Volts<span><svg id="volts" class="svgHidden" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" >
  <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
</svg></span>
</mat-label>
                  <!-- Typical voltage reference (card y5wSQvJ4) -->
                  <div style="border: 1px solid #d0d0d0;
                  border-radius: 0.25em;
                  padding: 0.4em 0.75em;
                  background: #fafafa;
                  color: #4f4f4f;
                  font-weight: 300;
                  font-size: 0.85em;
                  line-height: 1.35;
                  white-space: nowrap;
                  text-align: left;">
                    <p style="font-weight: 500; margin: 0 0 0.15em 0;">Typical Voltage</p>
                    <p style="margin: 0;">Furnace - 110-130</p>
                    <p style="margin: 0;">Heat Pump - 225-255</p>
                  </div>
                </div>
                <input
                  matInput
                  formControlName = "volts"
                  (change)="changeCurrentGradeValue( $event.target.value,'volts', systemNo);updateWatts();calculateGrade();"
                  placeholder="Enter Volts"
                  type="number"
                  step="0.01"
                />
              </div>

            <div>
              <mat-label style="color: #4f4f4f;">Amps<span><svg id="amps" class="svgHidden" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" >
  <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
</svg></span>
</mat-label>

                <input
                matInput
                formControlName = "amps"
                (change)="changeCurrentGradeValue( $event.target.value,'amps', systemNo);updateWatts();calculateGrade();"
                placeholder="Enter Amps"
                type="number"
                step="0.01"
              />
            </div>
          </div>

          <div style="display: flex; gap: 2em; padding-top: 1em;">
            <div>
              <label style="color: #4f4f4f; font-size: 0.9em;">Volts Photo</label>
              <input (change)="gradingPhotoTaken($event, 'voltsPhoto', systemNo)" type="file" accept="image/*,text/plain" id="voltsPhotoInput" style="display: none;" />
              <button mat-flat-button color="primary" (click)="pictureClick('voltsPhotoInput')" style="margin-left: 0.5em;">
                <fa-icon [icon]="facamera"></fa-icon>
              </button>
              <div *ngIf="getGradeValue('voltsPhoto', systemNo)">
                <img style="width: 12em; margin-top: 0.5em;" [src]="getGradeValue('voltsPhoto', systemNo)">
              </div>
            </div>
            <div>
              <label style="color: #4f4f4f; font-size: 0.9em;">Amps Photo</label>
              <input (change)="gradingPhotoTaken($event, 'ampsPhoto', systemNo)" type="file" accept="image/*,text/plain" id="ampsPhotoInput" style="display: none;" />
              <button mat-flat-button color="primary" (click)="pictureClick('ampsPhotoInput')" style="margin-left: 0.5em;">
                <fa-icon [icon]="facamera"></fa-icon>
              </button>
              <div *ngIf="getGradeValue('ampsPhoto', systemNo)">
                <img style="width: 12em; margin-top: 0.5em;" [src]="getGradeValue('ampsPhoto', systemNo)">
              </div>
            </div>
          </div>

            <div style="padding-top: 2em;">
              <mat-label style="color: #4f4f4f;">Watts<span><svg id="watts" class="svgHidden" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" >
  <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
</svg></span>
</mat-label>
                <input
                matInput
                formControlName = "watts"
                (change)="changeCurrentGradeValue( $event.target.value,'watts', systemNo)"
                placeholder="Enter Watts"
                type="number"
                step="0.01"
              />
            </div>

            </div>

            


            <div style="padding-top: 4em;
            padding-bottom: 2em;">
              <div><mat-label style="color: #4f4f4f;font-size:1.5em;">Calculated Watt Draw Grade: {{raterform.get('calculatedAirFlowGrade').value}} ({{wattscfm}} watts/cfm):</mat-label></div>

              <!--Just show the value instead of the radio buttons -->
              <p style="font-size: 1.5em;">{{ getGradeValue('calcAirflowGrade', systemNo) }}</p>

              <p style="color: #9e9e9e;" *ngIf="raterform.get('calculatedAirFlowGrade').value == 'I' " >I <= 0.45 watts/cfm*</p>
              <p style="color: #9e9e9e;" *ngIf="raterform.get('calculatedAirFlowGrade').value == 'II' ">II >0.45 and <=0.58 watts/cfm*</p>
              <p style="color: #9e9e9e;" *ngIf="raterform.get('calculatedAirFlowGrade').value == 'III' ">III > 0.58 watts/cfm*</p>

              <!--
              <mat-radio-group formControlName="calculatedAirFlowGrade">
                <mat-radio-button 
                  (change)="changeCurrentGradeValue('I', 'calcAirflowGrade', systemNo)" 
                  value="I">I <= 0.45 watts/cfm</mat-radio-button>
                
                <mat-radio-button 
                  (change)="changeCurrentGradeValue('II', 'calcAirflowGrade', systemNo)" 
                  value="II">II >0.45 and <=0.58 watts/cfm</mat-radio-button>
                
                <mat-radio-button 
                  (change)="changeCurrentGradeValue('III', 'calcAirflowGrade', systemNo)" 
                  value="III">III > 0.58 Watts/CFM</mat-radio-button>
              </mat-radio-group>
              -->

            </div>

            <div style="padding-top: 4em;">


              <div>
                <label style="color: #4f4f4f !important;
                font-size: 1.25em;">Lineset Length Picture<span><svg id="linesetPhoto" class="svgHidden" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" >
  <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
</svg></span>
</label>
                <input (change)="gradingPhotoTaken($event, 'linesetPhoto', systemNo)" type="file" accept="image/*,text/plain" id="pictureinput89"
                  style="display: none;" />
                <button class="mt-3" mat-flat-button color="primary" (click)="pictureClick('pictureinput89')">
                  <span>
                    <fa-icon [icon]="facamera"></fa-icon>
                  </span>
                </button>

<!--
                <span [hidden]=""><button mat-button color="green"
                    [hidden]="" (click)="">
                    <fa-icon [icon]="facamera"></fa-icon>
                  </button></span>
    -->
                  
              </div>
              <div class="col-lg-6 col-12 px-lg-3 px-3 p-3 d-flex flex-column align-items-start">
                <img style="width: 12em; margin:1em;" [src]="getGradeValue('linesetPhoto', systemNo)">
              </div>


              <mat-form-field>
                <mat-label style="color: #4f4f4f;">Lineset Length (to the nearest foot)<span><svg id="linesetLength" class="svgHidden" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" >
  <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
</svg></span>
</mat-label>
                <input
                  matInput
                  formControlName = "lineset"
                  (change)="changeCurrentGradeValue( $event.target.value,'linesetLength', systemNo);calculateOzNeeded()"
                  placeholder="Enter Length"
                  type="number"
                  step="0.1"
                />
              </mat-form-field>
            </div>

            <div>
              <!--Select with 3 options-->
              <mat-form-field>
                <mat-label style="color: #4f4f4f;">Liquid Diameter (The smaller pipe)<span><svg id="liquidLineDiameter" class="svgHidden" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" >
  <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
</svg></span>
</mat-label>
                <mat-select formControlName="liquiddiameter" 
                (selectionChange)="changeCurrentGradeValue( raterform.get('liquiddiameter').value,'liquidLineDiameter', systemNo); calculateOzNeeded()">
                  <mat-option value=0.25>1/4"</mat-option>
                  <mat-option value=0.375>3/8"</mat-option>
                  <mat-option value=0.5>1/2"</mat-option>
                </mat-select>
                </mat-form-field>
            </div>

            <div>
              <label style="color: #4f4f4f !important;
              padding-bottom: 1em;">Refrigerant Charge Deviation (Office)</label>
              <input
                style="width: 3em; padding-left: 0.5em;"
                matInput
                formControlName = "chargedev"
                (change)="changeCurrentGradeValue( $event.target.value,'chargedev', systemNo);"
                placeholder=""
                type="number"
                step="0.1"
              /><span style="font-size: 2em;padding-top: .5em;">% <svg id="chargedev" class="svgHidden" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" >
  <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
</svg>
</span><span ></span>
            </div>



            <div>
              <button mat-raised-button color="primary" (click)="saveHvacGrading(true)">Save HVAC Grading</button>
            </div>



           </div>
      
          </div>
    </div>

  </div>




</div>









<!---->


















    </div>


    <div mat-dialog-actions class="raterform_bottom_savebar" style="display:flex; flex-wrap:nowrap;">
      <button class="mr-2" mat-button (click)="closeFunction(data)" >Close</button>
      <button class="mr-2" mat-button (click)="bail()" style="background-color: red"
        title="Press this to export (via email) all data that you've entered.">Bail</button>
      <button *ngIf="!data.noSave"  class="mr-2" (click)="save()" mat-button style="background-color: lightgreen; color:black"
        title="Save data" cdkFocusInitial>Save</button>
      <button class="mr-2" (click)="sendMFReports()" mat-button style="background-color: white; color:black; border: solid 1px black;"
        title="Save data" *ngIf="isESMFNC" cdkFocusInitial>Send Reports(PM)</button>



    </div>


  </form>


</div>
